var hu = Object.defineProperty, mu = Object.defineProperties;
var gu = Object.getOwnPropertyDescriptors;
var Yi = Object.getOwnPropertySymbols;
var vu = Object.prototype.hasOwnProperty, _u = Object.prototype.propertyIsEnumerable;
var ar = (e, t, n) => t in e ? hu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, At = (e, t) => {
  for (var n in t || (t = {}))
    vu.call(t, n) && ar(e, n, t[n]);
  if (Yi)
    for (var n of Yi(t))
      _u.call(t, n) && ar(e, n, t[n]);
  return e;
}, Xi = (e, t) => mu(e, gu(t));
var v = (e, t, n) => (ar(e, typeof t != "symbol" ? t + "" : t, n), n);
var Yt = (e, t, n) => new Promise((r, i) => {
  var s = (u) => {
    try {
      a(n.next(u));
    } catch (c) {
      i(c);
    }
  }, o = (u) => {
    try {
      a(n.throw(u));
    } catch (c) {
      i(c);
    }
  }, a = (u) => u.done ? r(u.value) : Promise.resolve(u.value).then(s, o);
  a((n = n.apply(e, t)).next());
});
const Cg = () => {
  const e = (t) => !(t.name.indexOf("#t=") >= 0 || t.name.indexOf("?t=") >= 0);
  window.performance._getEntriesByName || (window.performance._getEntriesByName = window.performance.getEntriesByName, window.performance.getEntriesByName = (...t) => window.performance._getEntriesByName(...t).filter(e)), window.performance._getEntries || (window.performance._getEntries = window.performance.getEntries, window.performance.getEntries = () => window.performance._getEntries().filter(e)), window.performance._getEntriesByType || (window.performance._getEntriesByType = window.performance.getEntriesByType, window.performance.getEntriesByType = (...t) => window.performance._getEntriesByType(...t).filter(e));
}, Ng = (e, t = "") => {
  let n = new URLSearchParams();
  window.location.hash.indexOf(`${e}=`) >= 0 ? n = new URLSearchParams("?" + window.location.hash.substr(1)) : window.location.search.indexOf(`${e}=`) >= 0 && (n = new URLSearchParams(window.location.search));
  var r = n.get(e);
  return r || t;
}, xg = () => window.location.hash.includes("t=");
var bu = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Eu(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var no = {}, Su = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
no.validate = function(e) {
  if (!e || e.length > 254)
    return !1;
  var t = Su.test(e);
  if (!t)
    return !1;
  var n = e.split("@");
  if (n[0].length > 64)
    return !1;
  var r = n[1].split(".");
  return !r.some(function(i) {
    return i.length > 63;
  });
};
const Mg = (e, t) => t === "email" ? !no.validate(e.trim()) : e.trim().length === 0;
var ro = { exports: {} }, P = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Qi = Object.getOwnPropertySymbols, yu = Object.prototype.hasOwnProperty, Tu = Object.prototype.propertyIsEnumerable;
function wu(e) {
  if (e == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function Au() {
  try {
    if (!Object.assign)
      return !1;
    var e = new String("abc");
    if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
      return !1;
    for (var t = {}, n = 0; n < 10; n++)
      t["_" + String.fromCharCode(n)] = n;
    var r = Object.getOwnPropertyNames(t).map(function(s) {
      return t[s];
    });
    if (r.join("") !== "0123456789")
      return !1;
    var i = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(s) {
      i[s] = s;
    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
  } catch (s) {
    return !1;
  }
}
var Ou = Au() ? Object.assign : function(e, t) {
  for (var n, r = wu(e), i, s = 1; s < arguments.length; s++) {
    n = Object(arguments[s]);
    for (var o in n)
      yu.call(n, o) && (r[o] = n[o]);
    if (Qi) {
      i = Qi(n);
      for (var a = 0; a < i.length; a++)
        Tu.call(n, i[a]) && (r[i[a]] = n[i[a]]);
    }
  }
  return r;
};
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ti = Ou, dt = 60103, io = 60106;
P.Fragment = 60107;
P.StrictMode = 60108;
P.Profiler = 60114;
var so = 60109, oo = 60110, ao = 60112;
P.Suspense = 60113;
var uo = 60115, co = 60116;
if (typeof Symbol == "function" && Symbol.for) {
  var ie = Symbol.for;
  dt = ie("react.element"), io = ie("react.portal"), P.Fragment = ie("react.fragment"), P.StrictMode = ie("react.strict_mode"), P.Profiler = ie("react.profiler"), so = ie("react.provider"), oo = ie("react.context"), ao = ie("react.forward_ref"), P.Suspense = ie("react.suspense"), uo = ie("react.memo"), co = ie("react.lazy");
}
var Ji = typeof Symbol == "function" && Symbol.iterator;
function Ru(e) {
  return e === null || typeof e != "object" ? null : (e = Ji && e[Ji] || e["@@iterator"], typeof e == "function" ? e : null);
}
function jt(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var lo = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, fo = {};
function ft(e, t, n) {
  this.props = e, this.context = t, this.refs = fo, this.updater = n || lo;
}
ft.prototype.isReactComponent = {};
ft.prototype.setState = function(e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null)
    throw Error(jt(85));
  this.updater.enqueueSetState(this, e, t, "setState");
};
ft.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function po() {
}
po.prototype = ft.prototype;
function ni(e, t, n) {
  this.props = e, this.context = t, this.refs = fo, this.updater = n || lo;
}
var ri = ni.prototype = new po();
ri.constructor = ni;
ti(ri, ft.prototype);
ri.isPureReactComponent = !0;
var ii = { current: null }, ho = Object.prototype.hasOwnProperty, mo = { key: !0, ref: !0, __self: !0, __source: !0 };
function go(e, t, n) {
  var r, i = {}, s = null, o = null;
  if (t != null)
    for (r in t.ref !== void 0 && (o = t.ref), t.key !== void 0 && (s = "" + t.key), t)
      ho.call(t, r) && !mo.hasOwnProperty(r) && (i[r] = t[r]);
  var a = arguments.length - 2;
  if (a === 1)
    i.children = n;
  else if (1 < a) {
    for (var u = Array(a), c = 0; c < a; c++)
      u[c] = arguments[c + 2];
    i.children = u;
  }
  if (e && e.defaultProps)
    for (r in a = e.defaultProps, a)
      i[r] === void 0 && (i[r] = a[r]);
  return { $$typeof: dt, type: e, key: s, ref: o, props: i, _owner: ii.current };
}
function Pu(e, t) {
  return { $$typeof: dt, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function si(e) {
  return typeof e == "object" && e !== null && e.$$typeof === dt;
}
function Iu(e) {
  var t = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(n) {
    return t[n];
  });
}
var Zi = /\/+/g;
function ur(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? Iu("" + e.key) : t.toString(36);
}
function dn(e, t, n, r, i) {
  var s = typeof e;
  (s === "undefined" || s === "boolean") && (e = null);
  var o = !1;
  if (e === null)
    o = !0;
  else
    switch (s) {
      case "string":
      case "number":
        o = !0;
        break;
      case "object":
        switch (e.$$typeof) {
          case dt:
          case io:
            o = !0;
        }
    }
  if (o)
    return o = e, i = i(o), e = r === "" ? "." + ur(o, 0) : r, Array.isArray(i) ? (n = "", e != null && (n = e.replace(Zi, "$&/") + "/"), dn(i, t, n, "", function(c) {
      return c;
    })) : i != null && (si(i) && (i = Pu(i, n + (!i.key || o && o.key === i.key ? "" : ("" + i.key).replace(Zi, "$&/") + "/") + e)), t.push(i)), 1;
  if (o = 0, r = r === "" ? "." : r + ":", Array.isArray(e))
    for (var a = 0; a < e.length; a++) {
      s = e[a];
      var u = r + ur(s, a);
      o += dn(s, t, n, u, i);
    }
  else if (u = Ru(e), typeof u == "function")
    for (e = u.call(e), a = 0; !(s = e.next()).done; )
      s = s.value, u = r + ur(s, a++), o += dn(s, t, n, u, i);
  else if (s === "object")
    throw t = "" + e, Error(jt(31, t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
  return o;
}
function Xt(e, t, n) {
  if (e == null)
    return e;
  var r = [], i = 0;
  return dn(e, r, "", "", function(s) {
    return t.call(n, s, i++);
  }), r;
}
function Cu(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), e._status = 0, e._result = t, t.then(function(n) {
      e._status === 0 && (n = n.default, e._status = 1, e._result = n);
    }, function(n) {
      e._status === 0 && (e._status = 2, e._result = n);
    });
  }
  if (e._status === 1)
    return e._result;
  throw e._result;
}
var vo = { current: null };
function Pe() {
  var e = vo.current;
  if (e === null)
    throw Error(jt(321));
  return e;
}
var Nu = { ReactCurrentDispatcher: vo, ReactCurrentBatchConfig: { transition: 0 }, ReactCurrentOwner: ii, IsSomeRendererActing: { current: !1 }, assign: ti };
P.Children = { map: Xt, forEach: function(e, t, n) {
  Xt(e, function() {
    t.apply(this, arguments);
  }, n);
}, count: function(e) {
  var t = 0;
  return Xt(e, function() {
    t++;
  }), t;
}, toArray: function(e) {
  return Xt(e, function(t) {
    return t;
  }) || [];
}, only: function(e) {
  if (!si(e))
    throw Error(jt(143));
  return e;
} };
P.Component = ft;
P.PureComponent = ni;
P.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Nu;
P.cloneElement = function(e, t, n) {
  if (e == null)
    throw Error(jt(267, e));
  var r = ti({}, e.props), i = e.key, s = e.ref, o = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (s = t.ref, o = ii.current), t.key !== void 0 && (i = "" + t.key), e.type && e.type.defaultProps)
      var a = e.type.defaultProps;
    for (u in t)
      ho.call(t, u) && !mo.hasOwnProperty(u) && (r[u] = t[u] === void 0 && a !== void 0 ? a[u] : t[u]);
  }
  var u = arguments.length - 2;
  if (u === 1)
    r.children = n;
  else if (1 < u) {
    a = Array(u);
    for (var c = 0; c < u; c++)
      a[c] = arguments[c + 2];
    r.children = a;
  }
  return {
    $$typeof: dt,
    type: e.type,
    key: i,
    ref: s,
    props: r,
    _owner: o
  };
};
P.createContext = function(e, t) {
  return t === void 0 && (t = null), e = { $$typeof: oo, _calculateChangedBits: t, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null }, e.Provider = { $$typeof: so, _context: e }, e.Consumer = e;
};
P.createElement = go;
P.createFactory = function(e) {
  var t = go.bind(null, e);
  return t.type = e, t;
};
P.createRef = function() {
  return { current: null };
};
P.forwardRef = function(e) {
  return { $$typeof: ao, render: e };
};
P.isValidElement = si;
P.lazy = function(e) {
  return { $$typeof: co, _payload: { _status: -1, _result: e }, _init: Cu };
};
P.memo = function(e, t) {
  return { $$typeof: uo, type: e, compare: t === void 0 ? null : t };
};
P.useCallback = function(e, t) {
  return Pe().useCallback(e, t);
};
P.useContext = function(e, t) {
  return Pe().useContext(e, t);
};
P.useDebugValue = function() {
};
P.useEffect = function(e, t) {
  return Pe().useEffect(e, t);
};
P.useImperativeHandle = function(e, t, n) {
  return Pe().useImperativeHandle(e, t, n);
};
P.useLayoutEffect = function(e, t) {
  return Pe().useLayoutEffect(e, t);
};
P.useMemo = function(e, t) {
  return Pe().useMemo(e, t);
};
P.useReducer = function(e, t, n) {
  return Pe().useReducer(e, t, n);
};
P.useRef = function(e) {
  return Pe().useRef(e);
};
P.useState = function(e) {
  return Pe().useState(e);
};
P.version = "17.0.2";
ro.exports = P;
var _o = ro.exports;
const xu = 250, Mu = 50;
class Lu {
  constructor(t, n) {
    var r, i;
    this.signalBuffer = [], this.itemLimit = (r = n == null ? void 0 : n.itemLimit) !== null && r !== void 0 ? r : Mu, this.sendTimeout = (i = n == null ? void 0 : n.sendTimeout) !== null && i !== void 0 ? i : xu, this.paused = (n == null ? void 0 : n.paused) || !1, this.sendFn = t, this.flushInterval = -1, this.paused || this.start(), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && this.flush();
    });
  }
  addItem(t) {
    this.paused || (this.signalBuffer.push(t), this.signalBuffer.length >= this.itemLimit && this.flush());
  }
  start() {
    this.paused = !1, this.sendTimeout > 0 && (this.flushInterval = window.setInterval(() => this.flush(), this.sendTimeout));
  }
  pause() {
    this.paused = !0, clearInterval(this.flushInterval);
  }
  groupItems(t) {
    const n = /* @__PURE__ */ new Map();
    return t.forEach((r) => {
      const i = JSON.stringify(r.meta);
      let s = n.get(i);
      s === void 0 ? s = [r] : s = [...s, r], n.set(i, s);
    }), Array.from(n.values());
  }
  flush() {
    if (this.paused || this.signalBuffer.length === 0)
      return;
    this.groupItems(this.signalBuffer).forEach(this.sendFn), this.signalBuffer = [];
  }
}
var H;
(function(e) {
  e.EXCEPTION = "exception", e.LOG = "log", e.MEASUREMENT = "measurement", e.TRACE = "trace", e.EVENT = "event";
})(H || (H = {}));
const ku = {
  [H.EXCEPTION]: "exceptions",
  [H.LOG]: "logs",
  [H.MEASUREMENT]: "measurements",
  [H.TRACE]: "traces",
  [H.EVENT]: "events"
};
function Du(e, t, n, r) {
  var i;
  t.debug("Initializing transports");
  const s = [];
  let o = n.paused, a = [];
  const u = (...y) => {
    t.debug("Adding transports"), y.forEach((E) => {
      if (t.debug(`Adding "${E.name}" transport`), s.some((D) => D === E)) {
        t.warn(`Transport ${E.name} is already added`);
        return;
      }
      E.unpatchedConsole = e, E.internalLogger = t, E.config = n, E.metas = r, s.push(E);
    });
  }, c = (...y) => {
    t.debug(`Adding beforeSendHooks
`, a), y.forEach((E) => {
      E && a.push(E);
    });
  }, p = (y) => {
    let E = y;
    for (const w of a) {
      const D = E.map(w).filter(Boolean);
      if (D.length === 0)
        return [];
      E = Uu(D, n);
    }
    return E;
  }, m = (y) => {
    const E = p(y);
    if (E.length !== 0)
      for (const w of s)
        t.debug(`Transporting item using ${w.name}
`, E), w.isBatched() && w.send(E);
  }, d = (y) => {
    var E, w;
    if (!((E = n.batching) === null || E === void 0) && E.enabled && s.every((V) => V.isBatched()))
      return;
    const [D] = p([y]);
    if (D !== void 0)
      for (const V of s)
        t.debug(`Transporting item using ${V.name}
`, D), V.isBatched() ? !((w = n.batching) === null || w === void 0) && w.enabled || V.send([D]) : V.send(D);
  };
  let l;
  return !((i = n.batching) === null || i === void 0) && i.enabled && (l = new Lu(m, {
    sendTimeout: n.batching.sendTimeout,
    itemLimit: n.batching.itemLimit,
    paused: o
  })), {
    add: u,
    addBeforeSendHooks: c,
    getBeforeSendHooks: () => [...a],
    execute: (y) => {
      var E;
      o || (!((E = n.batching) === null || E === void 0) && E.enabled && (l == null || l.addItem(y)), d(y));
    },
    isPaused: () => o,
    pause: () => {
      t.debug("Pausing transports"), l == null || l.pause(), o = !0;
    },
    remove: (...y) => {
      t.debug("Removing transports"), y.forEach((E) => {
        t.debug(`Removing "${E.name}" transport`);
        const w = s.indexOf(E);
        if (w === -1) {
          t.warn(`Transport "${E.name}" is not added`);
          return;
        }
        s.splice(w, 1);
      });
    },
    removeBeforeSendHooks: (...y) => {
      a.filter((E) => !y.includes(E));
    },
    get transports() {
      return [...s];
    },
    unpause: () => {
      t.debug("Unpausing transports"), l == null || l.start(), o = !1;
    }
  };
}
function Uu(e, t) {
  if (t.preserveOriginalError)
    for (const n of e)
      n.type === H.EXCEPTION && delete n.payload.originalError;
  return e;
}
function Ae(e, t) {
  return typeof e === t;
}
function Rn(e, t) {
  return Object.prototype.toString.call(e) === `[object ${t}]`;
}
function bo(e, t) {
  try {
    return e instanceof t;
  } catch (n) {
    return !1;
  }
}
const Bt = (e) => Ae(e, "null"), $t = (e) => Ae(e, "string"), ju = (e) => Ae(e, "number") && !isNaN(e) || Ae(e, "bigint"), Bu = (e) => Ae(e, "boolean"), pe = (e) => !Bt(e) && Ae(e, "object"), Ft = (e) => Ae(e, "function"), at = (e) => Rn(e, "Array"), $u = (e) => !pe(e) && !Ft(e), Fu = typeof Event != "undefined", Hu = (e) => Fu && bo(e, Event), Vu = typeof Error != "undefined", oi = (e) => Vu && bo(e, Error), zu = (e) => Rn(e, "ErrorEvent"), Gu = (e) => Rn(e, "DOMError"), qu = (e) => Rn(e, "DOMException");
function je(e) {
  return e == null ? !0 : at(e) || $t(e) ? e.length === 0 : pe(e) ? Object.keys(e).length === 0 : !1;
}
function De(e, t) {
  if (e === t)
    return !0;
  if (Ae(e, "number") && isNaN(e))
    return Ae(t, "number") && isNaN(t);
  const n = at(e), r = at(t);
  if (n !== r)
    return !1;
  if (n && r) {
    const o = e.length;
    if (o !== t.length)
      return !1;
    for (let a = o; a-- !== 0; )
      if (!De(e[a], t[a]))
        return !1;
    return !0;
  }
  const i = pe(e), s = pe(t);
  if (i !== s)
    return !1;
  if (e && t && i && s) {
    const o = Object.keys(e), a = Object.keys(t), u = o.length, c = a.length;
    if (u !== c)
      return !1;
    for (let p of o)
      if (!a.includes(p))
        return !1;
    for (let p of o)
      if (!De(e[p], t[p]))
        return !1;
    return !0;
  }
  return !1;
}
function ut() {
  return Date.now();
}
function Pn() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
function In(e) {
  return new Date(e).toISOString();
}
var W;
(function(e) {
  e.TRACE = "trace", e.DEBUG = "debug", e.INFO = "info", e.LOG = "log", e.WARN = "warn", e.ERROR = "error";
})(W || (W = {}));
const Ku = W.LOG, Wu = [
  W.TRACE,
  W.DEBUG,
  W.INFO,
  W.LOG,
  W.WARN,
  W.ERROR
];
function ye() {
}
function Yu(e) {
  const { size: t, concurrency: n } = e, r = [];
  let i = 0;
  const s = () => {
    if (i < n && r.length) {
      const { producer: a, resolve: u, reject: c } = r.shift();
      i++, a().then((p) => {
        i--, s(), u(p);
      }, (p) => {
        i--, s(), c(p);
      });
    }
  };
  return {
    add: (a) => {
      if (r.length + i >= t)
        throw new Error("Task buffer full");
      return new Promise((u, c) => {
        r.push({
          producer: a,
          resolve: u,
          reject: c
        }), s();
      });
    }
  };
}
const es = "abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ0123456789";
function Ke(e = 10) {
  return Array.from(Array(e)).map(() => es[Math.floor(Math.random() * es.length)]).join("");
}
const He = typeof globalThis != "undefined" ? globalThis : typeof global != "undefined" ? global : typeof self != "undefined" ? self : void 0;
function Xu(e) {
  return He == null ? void 0 : He[`__faroBundleId_${e}`];
}
function Qu() {
  const e = /* @__PURE__ */ new WeakSet();
  return function(t, n) {
    if (pe(n) && n !== null) {
      if (e.has(n))
        return null;
      e.add(n);
    }
    return n;
  };
}
function Ht(e = {}) {
  return JSON.stringify(e != null ? e : {}, Qu());
}
function pt(e = {}) {
  const t = {};
  for (const [n, r] of Object.entries(e))
    t[n] = pe(r) && r !== null ? Ht(r) : String(r);
  return t;
}
class q {
  constructor() {
    this.subscribers = [];
  }
  subscribe(t) {
    return this.subscribers.push(t), {
      unsubscribe: () => this.unsubscribe(t)
    };
  }
  unsubscribe(t) {
    this.subscribers = this.subscribers.filter((n) => n !== t);
  }
  notify(t) {
    this.subscribers.forEach((n) => n(t));
  }
  first() {
    const t = new q(), n = (s) => {
      t.notify(s), r.unsubscribe();
    }, r = this.subscribe(n), i = t.unsubscribe.bind(t);
    return this.withUnsubscribeOverride(t, i, n);
  }
  takeWhile(t) {
    const n = new q(), r = (s) => {
      t(s) ? n.notify(s) : n.unsubscribe(r);
    };
    this.subscribe(r);
    const i = n.unsubscribe.bind(n);
    return this.withUnsubscribeOverride(n, i, r);
  }
  filter(t) {
    const n = new q(), r = (s) => {
      t(s) && n.notify(s);
    };
    this.subscribe(r);
    const i = n.unsubscribe.bind(n);
    return this.withUnsubscribeOverride(n, i, r);
  }
  merge(...t) {
    const n = new q(), r = [];
    t.forEach((s) => {
      const o = s.subscribe((a) => {
        n.notify(a);
      });
      r.push(o);
    });
    const i = n.unsubscribeAll.bind(n);
    return n.unsubscribe = () => {
      r.forEach((s) => s.unsubscribe()), i();
    }, n;
  }
  withUnsubscribeOverride(t, n, r) {
    return t.unsubscribe = (i) => {
      n(i), this.unsubscribe(r);
    }, t;
  }
  unsubscribeAll() {
    this.subscribers = [];
  }
}
var Le;
(function(e) {
  e[e.OFF = 0] = "OFF", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.VERBOSE = 4] = "VERBOSE";
})(Le || (Le = {}));
const Ju = "Faro", ai = {
  debug: ye,
  error: ye,
  info: ye,
  prefix: Ju,
  warn: ye
}, Eo = Le.ERROR, Vt = Object.assign({}, console);
let cr = Vt;
function Zu(e) {
  var t;
  return cr = (t = e.unpatchedConsole) !== null && t !== void 0 ? t : cr, cr;
}
function So(e = Vt, t = Eo) {
  const n = ai;
  return t > Le.OFF && (n.error = t >= Le.ERROR ? function(...r) {
    e.error(`${n.prefix}
`, ...r);
  } : ye, n.warn = t >= Le.WARN ? function(...r) {
    e.warn(`${n.prefix}
`, ...r);
  } : ye, n.info = t >= Le.INFO ? function(...r) {
    e.info(`${n.prefix}
`, ...r);
  } : ye, n.debug = t >= Le.VERBOSE ? function(...r) {
    e.debug(`${n.prefix}
`, ...r);
  } : ye), n;
}
let ts = ai;
function ec(e, t) {
  return ts = So(e, t.internalLoggerLevel), ts;
}
class yo {
  constructor() {
    this.unpatchedConsole = Vt, this.internalLogger = ai, this.config = {}, this.metas = {};
  }
  logDebug(...t) {
    this.internalLogger.debug(`${this.name}
`, ...t);
  }
  logInfo(...t) {
    this.internalLogger.info(`${this.name}
`, ...t);
  }
  logWarn(...t) {
    this.internalLogger.warn(`${this.name}
`, ...t);
  }
  logError(...t) {
    this.internalLogger.error(`${this.name}
`, ...t);
  }
}
class tc extends yo {
  isBatched() {
    return !1;
  }
  getIgnoreUrls() {
    return [];
  }
}
function nc(e) {
  e.transports.add(...e.config.transports), e.transports.addBeforeSendHooks(e.config.beforeSend);
}
function rc(e, t) {
  var n, r;
  if (t === void 0)
    return e;
  if (e === void 0)
    return {
      resourceSpans: t
    };
  const i = (n = e.resourceSpans) === null || n === void 0 ? void 0 : n[0];
  if (i === void 0)
    return e;
  const s = (i == null ? void 0 : i.scopeSpans) || [], o = ((r = t == null ? void 0 : t[0]) === null || r === void 0 ? void 0 : r.scopeSpans) || [];
  return Object.assign(Object.assign({}, e), { resourceSpans: [
    Object.assign(Object.assign({}, i), { scopeSpans: [...s, ...o] })
  ] });
}
function ic(e) {
  let t = {
    meta: {}
  };
  return e[0] !== void 0 && (t.meta = e[0].meta), e.forEach((n) => {
    switch (n.type) {
      case H.LOG:
      case H.EVENT:
      case H.EXCEPTION:
      case H.MEASUREMENT: {
        const r = ku[n.type], i = t[r];
        t = Object.assign(Object.assign({}, t), { [r]: i === void 0 ? [n.payload] : [...i, n.payload] });
        break;
      }
      case H.TRACE: {
        t = Object.assign(Object.assign({}, t), { traces: rc(t.traces, n.payload.resourceSpans) });
        break;
      }
    }
  }), t;
}
const sc = "faroApiCall", oc = "user_action_start", To = {
  Normal: "normal",
  Critical: "critical"
}, ac = "faro.user.action";
var L;
(function(e) {
  e[e.Started = 0] = "Started", e[e.Halted = 1] = "Halted", e[e.Cancelled = 2] = "Cancelled", e[e.Ended = 3] = "Ended";
})(L || (L = {}));
class uc {
  constructor() {
    this.buffer = [];
  }
  addItem(t) {
    this.buffer.push(t);
  }
  flushBuffer(t) {
    if (Ft(t))
      for (const n of this.buffer)
        t(n);
    this.buffer.length = 0;
  }
  size() {
    return this.buffer.length;
  }
}
class cc extends q {
  constructor({ name: t, parentId: n, trigger: r, transports: i, attributes: s, trackUserActionsExcludeItem: o, importance: a = To.Normal, pushEvent: u }) {
    super(), this.name = t, this.attributes = s, this.id = Ke(), this.trigger = r, this.parentId = n != null ? n : this.id, this.trackUserActionsExcludeItem = o, this.importance = a, this._pushEvent = u, this._itemBuffer = new uc(), this._transports = i, this._state = L.Started, this._start();
  }
  addItem(t) {
    return this._state === L.Started ? (this._itemBuffer.addItem(t), !0) : !1;
  }
  _start() {
    this._state = L.Started, this._state === L.Started && (this.startTime = ut());
  }
  halt() {
    this._state === L.Started && (this._state = L.Halted, this.notify(this._state));
  }
  cancel() {
    this._state === L.Started && this._itemBuffer.flushBuffer((t) => {
      this._transports.execute(t);
    }), this._state = L.Cancelled, this.notify(this._state);
  }
  end() {
    if (this._state === L.Cancelled)
      return;
    const t = ut(), n = t - this.startTime;
    this._state = L.Ended, this._itemBuffer.flushBuffer((r) => {
      if (lc(r, this.trackUserActionsExcludeItem)) {
        this._transports.execute(r);
        return;
      }
      const i = Object.assign(Object.assign({}, r), { payload: Object.assign(Object.assign({}, r.payload), { action: {
        parentId: this.id,
        name: this.name
      } }) });
      this._transports.execute(i);
    }), this._state = L.Ended, this.notify(this._state), this._pushEvent(ac, Object.assign({ userActionName: this.name, userActionStartTime: this.startTime.toString(), userActionEndTime: t.toString(), userActionDuration: n.toString(), userActionTrigger: this.trigger, userActionImportance: this.importance }, pt(this.attributes)), void 0, {
      timestampOverwriteMs: this.startTime,
      customPayloadTransformer: (r) => (r.action = {
        id: this.id,
        name: this.name
      }, r)
    });
  }
  getState() {
    return this._state;
  }
}
function lc(e, t) {
  return (t == null ? void 0 : t(e)) || e.type === H.MEASUREMENT && e.payload.type === "web-vitals";
}
const wo = new q();
function dc({ transports: e, internalLogger: t, config: n, pushEvent: r }) {
  var i;
  const s = (i = n.userActionsInstrumentation) === null || i === void 0 ? void 0 : i.excludeItem;
  let o;
  const a = (p, m, d) => {
    if (u() === void 0) {
      const f = new cc({
        name: p,
        transports: e,
        attributes: m,
        trigger: (d == null ? void 0 : d.triggerName) || sc,
        importance: (d == null ? void 0 : d.importance) || To.Normal,
        trackUserActionsExcludeItem: s,
        pushEvent: r
      });
      return f.filter((h) => [L.Ended, L.Cancelled].includes(h)).first().subscribe(() => {
        o = void 0;
      }), wo.notify({
        type: oc,
        userAction: f
      }), o = f, o;
    } else {
      t.error("Attempted to create a new user action while one is already running. This is not possible.");
      return;
    }
  }, u = () => o;
  return {
    startUserAction: a,
    getActiveUserAction: u
  };
}
function Cn(e, t) {
  return !e || (e == null ? void 0 : e.getState()) !== L.Started ? !1 : (e.addItem(t), !0);
}
function fc({ internalLogger: e, config: t, metas: n, transports: r, tracesApi: i, userActionsApi: s }) {
  let o = null;
  return {
    pushEvent: (u, c, p, { skipDedupe: m, spanContext: d, timestampOverwriteMs: l, customPayloadTransformer: f = (h) => h } = {}) => {
      try {
        const h = pt(c), g = {
          meta: n.value,
          payload: f({
            name: u,
            domain: p != null ? p : t.eventDomain,
            attributes: je(h) ? void 0 : h,
            timestamp: l ? In(l) : Pn(),
            trace: d ? {
              trace_id: d.traceId,
              span_id: d.spanId
            } : i.getTraceContext()
          }),
          type: H.EVENT
        }, _ = {
          name: g.payload.name,
          attributes: g.payload.attributes,
          domain: g.payload.domain
        };
        if (!m && t.dedupe && !Bt(o) && De(_, o)) {
          e.debug(`Skipping event push because it is the same as the last one
`, g.payload);
          return;
        }
        o = _, e.debug(`Pushing event
`, g), Cn(s.getActiveUserAction(), g) || r.execute(g);
      } catch (h) {
        e.error("Error pushing event", h);
      }
    }
  };
}
const Ao = "Error", ns = (e) => e.map((t) => pe(t) ? Ht(t) : String(t)).join(" ");
function pc(e, t) {
  return e.some((n) => $t(n) ? t.includes(n) : !!t.match(n));
}
let Me;
function hc({ internalLogger: e, config: t, metas: n, transports: r, tracesApi: i, userActionsApi: s }) {
  var o;
  e.debug("Initializing exceptions API");
  let a = null;
  Me = (o = t.parseStacktrace) !== null && o !== void 0 ? o : Me;
  const u = (l) => {
    e.debug("Changing stacktrace parser"), Me = l != null ? l : Me;
  }, c = () => Me, { ignoreErrors: p = [], preserveOriginalError: m } = t, d = (l, { skipDedupe: f, stackFrames: h, type: g, context: _, spanContext: T, timestampOverwriteMs: S, originalError: b } = {}) => {
    if (!gc(p, b != null ? b : l))
      try {
        const y = pt(Object.assign(Object.assign({}, mc(b != null ? b : l)), _ != null ? _ : {})), E = {
          meta: n.value,
          payload: Object.assign(Object.assign({ type: g || l.name || Ao, value: l.message, timestamp: S ? In(S) : Pn(), trace: T ? {
            trace_id: T.traceId,
            span_id: T.spanId
          } : i.getTraceContext() }, je(y) ? {} : { context: y }), m ? { originalError: b } : {}),
          type: H.EXCEPTION
        };
        h = h != null ? h : l.stack ? Me == null ? void 0 : Me(l).frames : void 0, h != null && h.length && (E.payload.stacktrace = {
          frames: h
        });
        const w = {
          type: E.payload.type,
          value: E.payload.value,
          stackTrace: E.payload.stacktrace,
          context: E.payload.context
        };
        if (!f && t.dedupe && !Bt(a) && De(w, a)) {
          e.debug(`Skipping error push because it is the same as the last one
`, E.payload);
          return;
        }
        a = w, e.debug(`Pushing exception
`, E), Cn(s.getActiveUserAction(), E) || r.execute(E);
      } catch (y) {
        e.error("Error pushing event", y);
      }
  };
  return u(t.parseStacktrace), {
    changeStacktraceParser: u,
    getStacktraceParser: c,
    pushError: d
  };
}
function mc(e) {
  let t = e.cause;
  return oi(t) ? t = e.cause.toString() : t !== null && (pe(e.cause) || at(e.cause)) ? t = Ht(e.cause) : t != null && (t = e.cause.toString()), t == null ? {} : { cause: t };
}
function gc(e, t) {
  const { message: n, name: r, stack: i } = t;
  return pc(e, n + " " + r + " " + i);
}
const gn = (e) => e.map((t) => {
  try {
    return String(t);
  } catch (n) {
    return "";
  }
}).join(" ");
function vc({ internalLogger: e, config: t, metas: n, transports: r, tracesApi: i, userActionsApi: s }) {
  var o;
  e.debug("Initializing logs API");
  let a = null;
  const u = (o = t.logArgsSerializer) !== null && o !== void 0 ? o : gn;
  return {
    pushLog: (p, { context: m, level: d, skipDedupe: l, spanContext: f, timestampOverwriteMs: h } = {}) => {
      try {
        const g = pt(m), _ = {
          type: H.LOG,
          payload: {
            message: u(p),
            level: d != null ? d : Ku,
            context: je(g) ? void 0 : g,
            timestamp: h ? In(h) : Pn(),
            trace: f ? {
              trace_id: f.traceId,
              span_id: f.spanId
            } : i.getTraceContext()
          },
          meta: n.value
        }, T = {
          message: _.payload.message,
          level: _.payload.level,
          context: _.payload.context
        };
        if (!l && t.dedupe && !Bt(a) && De(T, a)) {
          e.debug(`Skipping log push because it is the same as the last one
`, _.payload);
          return;
        }
        a = T, e.debug(`Pushing log
`, _), Cn(s.getActiveUserAction(), _) || r.execute(_);
      } catch (g) {
        e.error(`Error pushing log
`, g);
      }
    }
  };
}
function _c({ internalLogger: e, config: t, metas: n, transports: r, tracesApi: i, userActionsApi: s }) {
  e.debug("Initializing measurements API");
  let o = null;
  return {
    pushMeasurement: (u, { skipDedupe: c, context: p, spanContext: m, timestampOverwriteMs: d } = {}) => {
      try {
        const l = pt(p), f = {
          type: H.MEASUREMENT,
          payload: Object.assign(Object.assign({}, u), { trace: m ? {
            trace_id: m.traceId,
            span_id: m.spanId
          } : i.getTraceContext(), timestamp: d ? In(d) : Pn(), context: je(l) ? void 0 : l }),
          meta: n.value
        }, h = {
          type: f.payload.type,
          values: f.payload.values,
          context: f.payload.context
        };
        if (!c && t.dedupe && !Bt(o) && De(h, o)) {
          e.debug(`Skipping measurement push because it is the same as the last one
`, f.payload);
          return;
        }
        o = h, e.debug(`Pushing measurement
`, f), Cn(s.getActiveUserAction(), f) || r.execute(f);
      } catch (l) {
        e.error(`Error pushing measurement
`, l);
      }
    }
  };
}
function bc({ internalLogger: e, metas: t }) {
  e.debug("Initializing meta API");
  let n, r, i, s;
  const o = (l) => {
    r && t.remove(r), r = {
      user: l
    }, t.add(r);
  }, a = (l, f) => {
    var h;
    const g = f == null ? void 0 : f.overrides, _ = g ? {
      overrides: Object.assign(Object.assign({}, (h = n == null ? void 0 : n.session) === null || h === void 0 ? void 0 : h.overrides), g)
    } : {};
    n && t.remove(n), n = {
      session: Object.assign(Object.assign({}, je(l) ? void 0 : l), _)
    }, t.add(n);
  }, u = () => t.value.session, c = (l, f) => {
    var h;
    if (f != null && f.overrides && a(u(), { overrides: f.overrides }), ((h = i == null ? void 0 : i.view) === null || h === void 0 ? void 0 : h.name) === (l == null ? void 0 : l.name))
      return;
    const g = i;
    i = {
      view: l
    }, t.add(i), g && t.remove(g);
  }, p = () => t.value.view, m = (l) => {
    var f;
    const h = $t(l) ? Object.assign(Object.assign({}, (f = s == null ? void 0 : s.page) !== null && f !== void 0 ? f : d()), { id: l }) : l;
    s && t.remove(s), s = {
      page: h
    }, t.add(s);
  }, d = () => t.value.page;
  return {
    setUser: o,
    resetUser: o,
    setSession: a,
    resetSession: a,
    getSession: u,
    setView: c,
    getView: p,
    setPage: m,
    getPage: d
  };
}
function Ec(e, t, n, r, i) {
  t.debug("Initializing traces API");
  let s;
  return {
    getOTEL: () => s,
    getTraceContext: () => {
      const m = s == null ? void 0 : s.trace.getSpanContext(s.context.active());
      return m ? {
        trace_id: m.traceId,
        span_id: m.spanId
      } : void 0;
    },
    initOTEL: (m, d) => {
      t.debug("Initializing OpenTelemetry"), s = {
        trace: m,
        context: d
      };
    },
    isOTELInitialized: () => !!s,
    pushTraces: (m) => {
      try {
        const d = {
          type: H.TRACE,
          payload: m,
          meta: r.value
        };
        t.debug(`Pushing trace
`, d), i.execute(d);
      } catch (d) {
        t.error(`Error pushing trace
`, d);
      }
    }
  };
}
function Sc(e, t, n, r, i) {
  t.debug("Initializing API");
  let s = null;
  const a = dc({
    transports: i,
    config: n,
    internalLogger: t,
    pushEvent: (m, d, l, f) => {
      s ? s(m, d, l, f) : t.warn("pushEventImpl is not initialized. Event dropped:", { name: m, attributes: d, domain: l, options: f });
    }
  }), u = Ec(e, t, n, r, i), c = {
    unpatchedConsole: e,
    internalLogger: t,
    userActionsApi: a,
    config: n,
    metas: r,
    transports: i,
    tracesApi: u
  }, p = fc(c);
  return s = p.pushEvent, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, u), hc(c)), bc(c)), vc(c)), _c(c)), p), a);
}
class ve extends yo {
  constructor() {
    super(...arguments), this.api = {}, this.transports = {};
  }
}
function yc(e, t, n, r, i, s) {
  t.debug("Initializing instrumentations");
  const o = [];
  return {
    add: (...c) => {
      t.debug("Adding instrumentations"), c.forEach((p) => {
        if (t.debug(`Adding "${p.name}" instrumentation`), o.some((d) => d.name === p.name)) {
          t.warn(`Instrumentation ${p.name} is already added`);
          return;
        }
        p.unpatchedConsole = e, p.internalLogger = t, p.config = n, p.metas = r, p.transports = i, p.api = s, o.push(p), p.initialize();
      });
    },
    get instrumentations() {
      return [...o];
    },
    remove: (...c) => {
      t.debug("Removing instrumentations"), c.forEach((p) => {
        var m, d;
        t.debug(`Removing "${p.name}" instrumentation`);
        const l = o.reduce((f, h, g) => f === null && h.name === p.name ? g : null, null);
        if (l === null) {
          t.warn(`Instrumentation "${p.name}" is not added`);
          return;
        }
        (d = (m = o[l]).destroy) === null || d === void 0 || d.call(m), o.splice(l, 1);
      });
    }
  };
}
function Tc(e) {
  e.instrumentations.add(...e.config.instrumentations);
}
function wc(e, t, n) {
  let r = [], i = [];
  const s = () => r.reduce((m, d) => Object.assign(m, Ft(d) ? d() : d), {}), o = () => {
    if (i.length) {
      const m = s();
      i.forEach((d) => d(m));
    }
  };
  return {
    add: (...m) => {
      t.debug(`Adding metas
`, m), r.push(...m), o();
    },
    remove: (...m) => {
      t.debug(`Removing metas
`, m), r = r.filter((d) => !m.includes(d)), o();
    },
    addListener: (m) => {
      t.debug(`Adding metas listener
`, m), i.push(m);
    },
    removeListener: (m) => {
      t.debug(`Removing metas listener
`, m), i = i.filter((d) => d !== m);
    },
    get value() {
      return s();
    }
  };
}
const J = "2.2.2";
function Ac(e) {
  var t, n;
  const r = {
    sdk: {
      version: J
    },
    app: {
      bundleId: e.config.app.name && Xu(e.config.app.name)
    }
  }, i = (t = e.config.sessionTracking) === null || t === void 0 ? void 0 : t.session;
  i && e.api.setSession(i), e.config.app && (r.app = Object.assign(Object.assign({}, e.config.app), r.app)), e.config.user && (r.user = e.config.user), e.config.view && (r.view = e.config.view), e.metas.add(r, ...(n = e.config.metas) !== null && n !== void 0 ? n : []);
}
const Oo = "_faroInternal";
function Oc(e) {
  if (e.config.preventGlobalExposure)
    e.internalLogger.debug("Skipping registering public Faro instance in the global scope");
  else {
    if (e.internalLogger.debug(`Registering public faro reference in the global scope using "${e.config.globalObjectKey}" key`), e.config.globalObjectKey in He) {
      e.internalLogger.warn(`Skipping global registration due to key "${e.config.globalObjectKey}" being used already. Please set "globalObjectKey" to something else or set "preventGlobalExposure" to "true"`);
      return;
    }
    Object.defineProperty(He, e.config.globalObjectKey, {
      configurable: !1,
      writable: !1,
      value: e
    });
  }
}
function Rc(e) {
  e.config.isolate ? e.internalLogger.debug("Skipping registering internal Faro instance on global object") : (e.internalLogger.debug("Registering internal Faro instance on global object"), Object.defineProperty(He, Oo, {
    configurable: !1,
    enumerable: !1,
    writable: !1,
    value: e
  }));
}
function Pc() {
  return Oo in He;
}
let k = {};
function Ic(e, t, n, r, i, s, o) {
  return t.debug("Initializing Faro"), k = {
    api: s,
    config: n,
    instrumentations: o,
    internalLogger: t,
    metas: r,
    pause: i.pause,
    transports: i,
    unpatchedConsole: e,
    unpause: i.unpause
  }, Rc(k), Oc(k), k;
}
function Cc(e) {
  const t = Zu(e), n = ec(t, e);
  if (Pc() && !e.isolate) {
    n.error('Faro is already registered. Either add instrumentations, transports etc. to the global faro instance or use the "isolate" property');
    return;
  }
  n.debug("Initializing");
  const r = wc(t, n), i = Du(t, n, e, r), s = Sc(t, n, e, r, i), o = yc(t, n, e, r, i, s), a = Ic(t, n, e, r, i, s, o);
  return Ac(a), nc(a), Tc(a), a;
}
const Nc = "faro", xc = {
  enabled: !0,
  sendTimeout: 250,
  itemLimit: 50
}, Mc = "view_changed", Qt = "session_start", lr = "session_resume", Lc = "session_extend", kc = "service_name_override", X = "unknown";
var Dr = { exports: {} };
(function(e, t) {
  (function(n, r) {
    var i = "1.0.41", s = "", o = "?", a = "function", u = "undefined", c = "object", p = "string", m = "major", d = "model", l = "name", f = "type", h = "vendor", g = "version", _ = "architecture", T = "console", S = "mobile", b = "tablet", y = "smarttv", E = "wearable", w = "embedded", D = 500, V = "Amazon", Y = "Apple", Ye = "ASUS", Xe = "BlackBerry", Ie = "Browser", ae = "Chrome", gt = "Edge", Ce = "Firefox", Ne = "Google", vt = "Honor", _t = "Huawei", Qe = "Lenovo", K = "LG", Je = "Microsoft", xe = "Motorola", Ze = "Nvidia", Bi = "OnePlus", bt = "Opera", nr = "OPPO", Et = "Samsung", $i = "Sharp", St = "Sony", rr = "Xiaomi", ir = "Zebra", Fi = "Facebook", Hi = "Chromium OS", Vi = "Mac OS", zi = " Browser", du = function(R, C) {
      var O = {};
      for (var U in R)
        C[U] && C[U].length % 2 === 0 ? O[U] = C[U].concat(R[U]) : O[U] = R[U];
      return O;
    }, Kt = function(R) {
      for (var C = {}, O = 0; O < R.length; O++)
        C[R[O].toUpperCase()] = R[O];
      return C;
    }, Gi = function(R, C) {
      return typeof R === p ? yt(C).indexOf(yt(R)) !== -1 : !1;
    }, yt = function(R) {
      return R.toLowerCase();
    }, fu = function(R) {
      return typeof R === p ? R.replace(/[^\d\.]/g, s).split(".")[0] : r;
    }, sr = function(R, C) {
      if (typeof R === p)
        return R = R.replace(/^\s\s*/, s), typeof C === u ? R : R.substring(0, D);
    }, Tt = function(R, C) {
      for (var O = 0, U, _e, ue, N, A, ce; O < C.length && !A; ) {
        var or = C[O], Wi = C[O + 1];
        for (U = _e = 0; U < or.length && !A && or[U]; )
          if (A = or[U++].exec(R), A)
            for (ue = 0; ue < Wi.length; ue++)
              ce = A[++_e], N = Wi[ue], typeof N === c && N.length > 0 ? N.length === 2 ? typeof N[1] == a ? this[N[0]] = N[1].call(this, ce) : this[N[0]] = N[1] : N.length === 3 ? typeof N[1] === a && !(N[1].exec && N[1].test) ? this[N[0]] = ce ? N[1].call(this, ce, N[2]) : r : this[N[0]] = ce ? ce.replace(N[1], N[2]) : r : N.length === 4 && (this[N[0]] = ce ? N[3].call(this, ce.replace(N[1], N[2])) : r) : this[N] = ce || r;
        O += 2;
      }
    }, wt = function(R, C) {
      for (var O in C)
        if (typeof C[O] === c && C[O].length > 0) {
          for (var U = 0; U < C[O].length; U++)
            if (Gi(C[O][U], R))
              return O === o ? r : O;
        } else if (Gi(C[O], R))
          return O === o ? r : O;
      return C.hasOwnProperty("*") ? C["*"] : R;
    }, pu = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, qi = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, Ki = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [g, [l, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [g, [l, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [l, g],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [g, [l, bt + " Mini"]],
        [
          /\bop(?:rg)?x\/([\w\.]+)/i
          // Opera GX
        ],
        [g, [l, bt + " GX"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [g, [l, bt]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [g, [l, "Baidu"]],
        [
          /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
          // Maxthon
        ],
        [g, [l, "Maxthon"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
          // Trident based
          /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
          // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
          /(heytap|ovi|115)browser\/([\d\.]+)/i,
          // HeyTap/Ovi/115
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [l, g],
        [
          /quark(?:pc)?\/([-\w\.]+)/i
          // Quark
        ],
        [g, [l, "Quark"]],
        [
          /\bddg\/([\w\.]+)/i
          // DuckDuckGo
        ],
        [g, [l, "DuckDuckGo"]],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [g, [l, "UC" + Ie]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [g, [l, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [g, [l, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [g, [l, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [g, [l, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [g, [l, "Smart Lenovo " + Ie]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[l, /(.+)/, "$1 Secure " + Ie], g],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [g, [l, Ce + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [g, [l, bt + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [g, [l, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [g, [l, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [g, [l, bt + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [g, [l, "MIUI" + zi]],
        [
          /fxios\/([\w\.-]+)/i
          // Firefox for iOS
        ],
        [g, [l, Ce]],
        [
          /\bqihoobrowser\/?([\w\.]*)/i
          // 360
        ],
        [g, [l, "360"]],
        [
          /\b(qq)\/([\w\.]+)/i
          // QQ
        ],
        [[l, /(.+)/, "$1Browser"], g],
        [
          /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
        ],
        [[l, /(.+)/, "$1" + zi], g],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [g, [l, Et + " Internet"]],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [g, [l, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[l, "Sogou Mobile"], g],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
          // QQ/2345
        ],
        [l, g],
        [
          /(lbbrowser|rekonq)/i,
          // LieBao Browser/Rekonq
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [l],
        [
          /ome\/([\w\.]+) \w* ?(iron) saf/i,
          // Iron
          /ome\/([\w\.]+).+qihu (360)[es]e/i
          // 360
        ],
        [g, l],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[l, Fi], g],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /(daum)apps[\/ ]([\w\.]+)/i,
          // Daum App
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(twitter)(?:and| f.+e\/([\w\.]+))/i,
          // Twitter
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [l, g],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [g, [l, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [g, [l, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [g, [l, ae + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[l, ae + " WebView"], g],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [g, [l, "Android " + Ie]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [l, g],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [g, [l, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [g, l],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [l, [g, wt, pu]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [l, g],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[l, "Netscape"], g],
        [
          /(wolvic|librewolf)\/([\w\.]+)/i
          // Wolvic/LibreWolf
        ],
        [l, g],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [g, [l, Ce + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
          /\b(links) \(([\w\.]+)/i
          // Links
        ],
        [l, [g, /_/g, "."]],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [l, [g, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /\b((amd|x|x86[-_]?|wow|win)64)\b/i
          // AMD64 (x64)
        ],
        [[_, "amd64"]],
        [
          /(ia32(?=;))/i,
          // IA32 (quicktime)
          /\b((i[346]|x)86)(pc)?\b/i
          // IA32 (x86)
        ],
        [[_, "ia32"]],
        [
          /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
          // ARM64
        ],
        [[_, "arm64"]],
        [
          /\b(arm(v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[_, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
        ],
        [[_, "arm"]],
        [
          /((ppc|powerpc)(64)?)( mac|;|\))/i
          // PowerPC
        ],
        [[_, /ower/, s, yt]],
        [
          / sun4\w[;\)]/i
          // SPARC
        ],
        [[_, "sparc"]],
        [
          /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[_, yt]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [d, [h, Et], [f, b]],
        [
          /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]((?!sm-[lr])[-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [d, [h, Et], [f, S]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [d, [h, Y], [f, S]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [d, [h, Y], [f, b]],
        [
          /(macintosh);/i
        ],
        [d, [h, Y]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [d, [h, $i], [f, S]],
        [
          // Honor
          /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
        ],
        [d, [h, vt], [f, b]],
        [
          /honor([-\w ]+)[;\)]/i
        ],
        [d, [h, vt], [f, S]],
        [
          // Huawei
          /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
        ],
        [d, [h, _t], [f, b]],
        [
          /(?:huawei)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [d, [h, _t], [f, S]],
        [
          // Xiaomi
          /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
          /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[d, /_/g, " "], [h, rr], [f, b]],
        [
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
          // Xiaomi Mi
          / ([\w ]+) miui\/v?\d/i
        ],
        [[d, /_/g, " "], [h, rr], [f, S]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [d, [h, nr], [f, S]],
        [
          /\b(opd2(\d{3}a?))(?: bui|\))/i
        ],
        [d, [h, wt, { OnePlus: ["304", "403", "203"], "*": nr }], [f, b]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [d, [h, "Vivo"], [f, S]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [d, [h, "Realme"], [f, S]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [d, [h, xe], [f, S]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [d, [h, xe], [f, b]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [d, [h, K], [f, b]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [d, [h, K], [f, S]],
        [
          // Lenovo
          /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
          /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
        ],
        [d, [h, Qe], [f, b]],
        [
          // Nokia
          /(nokia) (t[12][01])/i
        ],
        [h, d, [f, b]],
        [
          /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
          /nokia[-_ ]?(([-\w\. ]*))/i
        ],
        [[d, /_/g, " "], [f, S], [h, "Nokia"]],
        [
          // Google
          /(pixel (c|tablet))\b/i
          // Google Pixel C/Tablet
        ],
        [d, [h, Ne], [f, b]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [d, [h, Ne], [f, S]],
        [
          // Sony
          /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [d, [h, St], [f, S]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[d, "Xperia Tablet"], [h, St], [f, b]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [d, [h, Bi], [f, S]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [d, [h, V], [f, b]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[d, /(.+)/g, "Fire Phone $1"], [h, V], [f, S]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [d, h, [f, b]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [d, [h, Xe], [f, S]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [d, [h, Ye], [f, b]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [d, [h, Ye], [f, S]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [d, [h, "HTC"], [f, b]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [h, [d, /_/g, " "], [f, S]],
        [
          // TCL
          /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
        ],
        [d, [h, "TCL"], [f, b]],
        [
          // itel
          /(itel) ((\w+))/i
        ],
        [[h, yt], d, [f, wt, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [d, [h, "Acer"], [f, b]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [d, [h, "Meizu"], [f, S]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [d, [h, "Ulefone"], [f, S]],
        [
          // Energizer
          /; (energy ?\w+)(?: bui|\))/i,
          /; energizer ([\w ]+)(?: bui|\))/i
        ],
        [d, [h, "Energizer"], [f, S]],
        [
          // Cat
          /; cat (b35);/i,
          /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
        ],
        [d, [h, "Cat"], [f, S]],
        [
          // Smartfren
          /((?:new )?andromax[\w- ]+)(?: bui|\))/i
        ],
        [d, [h, "Smartfren"], [f, S]],
        [
          // Nothing
          /droid.+; (a(?:015|06[35]|142p?))/i
        ],
        [d, [h, "Nothing"], [f, S]],
        [
          // Archos
          /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
          /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
        ],
        [d, [h, "Archos"], [f, b]],
        [
          /archos ([\w ]+)( b|\))/i,
          /; (ac[3-6]\d\w{2,8})( b|\))/i
        ],
        [d, [h, "Archos"], [f, S]],
        [
          // MIXED
          /(imo) (tab \w+)/i,
          // IMO
          /(infinix) (x1101b?)/i
          // Infinix XPad
        ],
        [h, d, [f, b]],
        [
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
          /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
          // HMD/IMO
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
          // Lenovo
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [h, d, [f, S]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [h, d, [f, b]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [d, [h, Je], [f, b]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [d, [h, "Fairphone"], [f, S]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [d, [h, "AT&T"], [f, S]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [d, [h, "Siemens"], [f, S]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [d, [h, "RCA"], [f, b]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [d, [h, "Dell"], [f, b]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [d, [h, "Verizon"], [f, b]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [d, [h, "Barnes & Noble"], [f, b]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [d, [h, "NuVision"], [f, b]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [d, [h, "ZTE"], [f, b]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [d, [h, "ZTE"], [f, S]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [d, [h, "Swiss"], [f, S]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [d, [h, "Swiss"], [f, b]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [d, [h, "Zeki"], [f, b]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[h, "Dragon Touch"], d, [f, b]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [d, [h, "Insignia"], [f, b]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [d, [h, "NextBook"], [f, b]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[h, "Voice"], d, [f, S]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[h, "LvTel"], d, [f, S]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [d, [h, "Essential"], [f, S]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [d, [h, "Envizen"], [f, b]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [d, [h, "MachSpeed"], [f, b]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [d, [h, "Rotor"], [f, b]],
        [
          /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
          // Nvidia Tablets
        ],
        [d, [h, Ze], [f, b]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [h, d, [f, S]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[d, /\./g, " "], [h, Je], [f, S]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [d, [h, ir], [f, b]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [d, [h, ir], [f, S]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [h, [f, y]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[d, /^/, "SmartTV"], [h, Et], [f, y]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[h, K], [f, y]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [h, [d, Y + " TV"], [f, y]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[d, ae + "cast"], [h, Ne], [f, y]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [d, [h, V], [f, y]],
        [
          /(shield \w+ tv)/i
          // Nvidia Shield TV
        ],
        [d, [h, Ze], [f, y]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [d, [h, $i], [f, y]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [d, [h, St], [f, y]],
        [
          /(mi(tv|box)-?\w+) bui/i
          // Xiaomi
        ],
        [d, [h, rr], [f, y]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [h, d, [f, y]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[h, sr], [d, sr], [f, y]],
        [
          // SmartTV from Unidentified Vendors
          /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
        ],
        [d, [f, y]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
        ],
        [[f, y]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [h, d, [f, T]],
        [
          /droid.+; (shield)( bui|\))/i
          // Nvidia Portable
        ],
        [d, [h, Ze], [f, T]],
        [
          /(playstation \w+)/i
          // Playstation
        ],
        [d, [h, St], [f, T]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [d, [h, Je], [f, T]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
          // Samsung Galaxy Watch
        ],
        [d, [h, Et], [f, E]],
        [
          /((pebble))app/i,
          // Pebble
          /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
          // Asus ZenWatch / LG Watch / Pixel Watch
        ],
        [h, d, [f, E]],
        [
          /(ow(?:19|20)?we?[1-3]{1,3})/i
          // Oppo Watch
        ],
        [d, [h, nr], [f, E]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [d, [h, Y], [f, E]],
        [
          /(opwwe\d{3})/i
          // OnePlus Watch
        ],
        [d, [h, Bi], [f, E]],
        [
          /(moto 360)/i
          // Motorola 360
        ],
        [d, [h, xe], [f, E]],
        [
          /(smartwatch 3)/i
          // Sony SmartWatch
        ],
        [d, [h, St], [f, E]],
        [
          /(g watch r)/i
          // LG G Watch R
        ],
        [d, [h, K], [f, E]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [d, [h, ir], [f, E]],
        [
          ///////////////////
          // XR
          ///////////////////
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [d, [h, Ne], [f, E]],
        [
          /(pico) (4|neo3(?: link|pro)?)/i
          // Pico
        ],
        [h, d, [f, E]],
        [
          /; (quest( \d| pro)?)/i
          // Oculus Quest
        ],
        [d, [h, Fi], [f, E]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [h, [f, w]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [d, [h, V], [f, w]],
        [
          /(homepod).+mac os/i
          // Apple HomePod
        ],
        [d, [h, Y], [f, w]],
        [
          /windows iot/i
        ],
        [[f, w]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [d, [f, S]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [d, [f, b]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[f, b]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[f, S]],
        [
          /droid .+?; ([\w\. -]+)( bui|\))/i
          // Generic Android Device
        ],
        [d, [h, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [g, [l, gt + "HTML"]],
        [
          /(arkweb)\/([\w\.]+)/i
          // ArkWeb
        ],
        [l, g],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [g, [l, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
          // LibWeb
        ],
        [l, g],
        [
          /ladybird\//i
        ],
        [[l, "LibWeb"]],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [g, l]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [l, g],
        [
          /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [l, [g, wt, qi]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[g, wt, qi], [l, "Windows"]],
        [
          // iOS/macOS
          /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[g, /_/g, "."], [l, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[l, Vi], [g, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [g, l],
        [
          /(ubuntu) ([\w\.]+) like android/i
          // Ubuntu Touch
        ],
        [[l, /(.+)/, "$1 Touch"], g],
        [
          // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
          /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
        ],
        [l, g],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [g, [l, Xe]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [g, [l, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [g, [l, Ce + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [g, [l, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [g, [l, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [g, [l, ae + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[l, Hi], g],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [l, g],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[l, "Solaris"], g],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [l, g]
      ]
    }, re = function(R, C) {
      if (typeof R === c && (C = R, R = r), !(this instanceof re))
        return new re(R, C).getResult();
      var O = typeof n !== u && n.navigator ? n.navigator : r, U = R || (O && O.userAgent ? O.userAgent : s), _e = O && O.userAgentData ? O.userAgentData : r, ue = C ? du(Ki, C) : Ki, N = O && O.userAgent == U;
      return this.getBrowser = function() {
        var A = {};
        return A[l] = r, A[g] = r, Tt.call(A, U, ue.browser), A[m] = fu(A[g]), N && O && O.brave && typeof O.brave.isBrave == a && (A[l] = "Brave"), A;
      }, this.getCPU = function() {
        var A = {};
        return A[_] = r, Tt.call(A, U, ue.cpu), A;
      }, this.getDevice = function() {
        var A = {};
        return A[h] = r, A[d] = r, A[f] = r, Tt.call(A, U, ue.device), N && !A[f] && _e && _e.mobile && (A[f] = S), N && A[d] == "Macintosh" && O && typeof O.standalone !== u && O.maxTouchPoints && O.maxTouchPoints > 2 && (A[d] = "iPad", A[f] = b), A;
      }, this.getEngine = function() {
        var A = {};
        return A[l] = r, A[g] = r, Tt.call(A, U, ue.engine), A;
      }, this.getOS = function() {
        var A = {};
        return A[l] = r, A[g] = r, Tt.call(A, U, ue.os), N && !A[l] && _e && _e.platform && _e.platform != "Unknown" && (A[l] = _e.platform.replace(/chrome os/i, Hi).replace(/macos/i, Vi)), A;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return U;
      }, this.setUA = function(A) {
        return U = typeof A === p && A.length > D ? sr(A, D) : A, this;
      }, this.setUA(U), this;
    };
    re.VERSION = i, re.BROWSER = Kt([l, g, m]), re.CPU = Kt([_]), re.DEVICE = Kt([d, h, f, T, S, y, b, E, w]), re.ENGINE = re.OS = Kt([l, g]), e.exports && (t = e.exports = re), t.UAParser = re;
    var et = typeof n !== u && (n.jQuery || n.Zepto);
    if (et && !et.ua) {
      var Wt = new re();
      et.ua = Wt.getResult(), et.ua.get = function() {
        return Wt.getUA();
      }, et.ua.set = function(R) {
        Wt.setUA(R);
        var C = Wt.getResult();
        for (var O in C)
          et.ua[O] = C[O];
      };
    }
  })(typeof window == "object" ? window : bu);
})(Dr, Dr.exports);
var Dc = Dr.exports;
const Uc = () => {
  const e = new Dc.UAParser(), { name: t, version: n } = e.getBrowser(), { name: r, version: i } = e.getOS(), s = e.getUA(), o = navigator.language, a = navigator.userAgent.includes("Mobi"), u = c();
  return {
    browser: {
      name: t != null ? t : X,
      version: n != null ? n : X,
      os: `${r != null ? r : X} ${i != null ? i : X}`,
      userAgent: s != null ? s : X,
      language: o != null ? o : X,
      mobile: a,
      brands: u != null ? u : X,
      viewportWidth: `${window.innerWidth}`,
      viewportHeight: `${window.innerHeight}`
    }
  };
  function c() {
    if (!(!t || !n) && "userAgentData" in navigator && navigator.userAgentData)
      return navigator.userAgentData.brands;
  }
};
function jc(e) {
  var t, n, r, i;
  return {
    id: (i = (r = (n = (t = k.config) === null || t === void 0 ? void 0 : t.sessionTracking) === null || n === void 0 ? void 0 : n.generateSessionId) === null || r === void 0 ? void 0 : r.call(n)) !== null && i !== void 0 ? i : Ke(),
    attributes: e
  };
}
const Oe = {
  session: "sessionStorage",
  local: "localStorage"
};
function Ro(e) {
  var t;
  try {
    let n;
    n = window[e];
    const r = "__faro_storage_test__";
    return n.setItem(r, r), n.removeItem(r), !0;
  } catch (n) {
    return (t = k.internalLogger) === null || t === void 0 || t.info(`Web storage of type ${e} is not available. Reason: ${n}`), !1;
  }
}
function Nn(e, t) {
  return ci(t) ? window[t].getItem(e) : null;
}
function ui(e, t, n) {
  if (ci(n))
    try {
      window[n].setItem(e, t);
    } catch (r) {
    }
}
function Po(e, t) {
  ci(t) && window[t].removeItem(e);
}
const Io = Ro(Oe.local), Co = Ro(Oe.session);
function ci(e) {
  return e === Oe.local ? Io : e === Oe.session ? Co : !1;
}
function No(e, t) {
  let n = !1, r;
  const i = () => {
    if (r == null) {
      n = !1;
      return;
    }
    e(...r), r = null, setTimeout(i, t);
  };
  return (...s) => {
    if (n) {
      r = s;
      return;
    }
    e(...s), n = !0, setTimeout(i, t);
  };
}
function Bc() {
  return k.transports.transports.flatMap((e) => e.getIgnoreUrls());
}
function xn(e = "") {
  return Bc().some((t) => e && e.match(t) != null);
}
function xo(e) {
  if ($t(e))
    return e;
  if (e instanceof URL)
    return e.href;
  if (!je(e) && Ft(e == null ? void 0 : e.toString))
    return e.toString();
}
const it = "com.grafana.faro.session", $c = 4 * 60 * 60 * 1e3, Mo = 15 * 60 * 1e3, Lo = 1 * 1e3, Fc = Mo, Hc = {
  enabled: !0,
  persistent: !1,
  maxSessionPersistenceTime: Fc
};
function li() {
  var e, t, n;
  const i = k.config.sessionTracking;
  let s = (n = (t = (e = i == null ? void 0 : i.sampler) === null || e === void 0 ? void 0 : e.call(i, { metas: k.metas.value })) !== null && t !== void 0 ? t : i == null ? void 0 : i.samplingRate) !== null && n !== void 0 ? n : 1;
  return typeof s != "number" && (s = 0), Math.random() < s;
}
function vn({ sessionId: e, started: t, lastActivity: n, isSampled: r = !0 } = {}) {
  var i, s;
  const o = ut(), a = (s = (i = k.config) === null || i === void 0 ? void 0 : i.sessionTracking) === null || s === void 0 ? void 0 : s.generateSessionId;
  return e == null && (e = typeof a == "function" ? a() : Ke()), {
    sessionId: e,
    lastActivity: n != null ? n : o,
    started: t != null ? t : o,
    isSampled: r
  };
}
function ko(e) {
  if (e == null)
    return !1;
  const t = ut();
  return t - e.started < $c ? t - e.lastActivity < Mo : !1;
}
function di({ fetchUserSession: e, storeUserSession: t }) {
  return function({ forceSessionExtend: r } = { forceSessionExtend: !1 }) {
    var i, s, o;
    if (!e || !t)
      return;
    const a = k.config.sessionTracking, u = a == null ? void 0 : a.persistent;
    if (u && !Io || !u && !Co)
      return;
    const c = e();
    if (r === !1 && ko(c))
      t(Object.assign(Object.assign({}, c), { lastActivity: ut() }));
    else {
      let p = Do(vn({ isSampled: li() }), c);
      t(p), (i = k.api) === null || i === void 0 || i.setSession(p.sessionMeta), (s = a == null ? void 0 : a.onSessionChange) === null || s === void 0 || s.call(a, (o = c == null ? void 0 : c.sessionMeta) !== null && o !== void 0 ? o : null, p.sessionMeta);
    }
  };
}
function Do(e, t) {
  var n, r, i, s, o, a, u;
  const c = Object.assign(Object.assign({}, e), { sessionMeta: {
    id: e.sessionId,
    attributes: Object.assign(Object.assign(Object.assign({}, (r = (n = k.config.sessionTracking) === null || n === void 0 ? void 0 : n.session) === null || r === void 0 ? void 0 : r.attributes), (s = (i = k.metas.value.session) === null || i === void 0 ? void 0 : i.attributes) !== null && s !== void 0 ? s : {}), { isSampled: e.isSampled.toString() })
  } }), p = (a = (o = k.metas.value.session) === null || o === void 0 ? void 0 : o.overrides) !== null && a !== void 0 ? a : (u = t == null ? void 0 : t.sessionMeta) === null || u === void 0 ? void 0 : u.overrides;
  je(p) || (c.sessionMeta.overrides = p);
  const m = t == null ? void 0 : t.sessionId;
  return m != null && (c.sessionMeta.attributes.previousSession = m), c;
}
function Uo({ fetchUserSession: e, storeUserSession: t }) {
  return function(r) {
    const i = r.session, s = e();
    let o = i == null ? void 0 : i.id;
    const a = i == null ? void 0 : i.attributes, u = i == null ? void 0 : i.overrides, c = s == null ? void 0 : s.sessionMeta, p = c == null ? void 0 : c.overrides, m = !!u && !De(u, p), d = !!a && !De(a, c == null ? void 0 : c.attributes);
    if (!!i && o !== (s == null ? void 0 : s.sessionId) || d || m) {
      const f = Do(vn({ sessionId: o, isSampled: li() }), s);
      t(f), Vc(m, u, p), k.api.setSession(f.sessionMeta);
    }
  };
}
function Vc(e, t = {}, n = {}) {
  var r, i, s;
  if (!e)
    return;
  const o = t.serviceName, a = (s = (r = n.serviceName) !== null && r !== void 0 ? r : (i = k.metas.value.app) === null || i === void 0 ? void 0 : i.name) !== null && s !== void 0 ? s : "";
  o && o !== a && k.api.pushEvent(kc, {
    serviceName: o,
    previousServiceName: a
  });
}
class se {
  constructor() {
    this.updateSession = No(() => this.updateUserSession(), Lo), this.updateUserSession = di({
      fetchUserSession: se.fetchUserSession,
      storeUserSession: se.storeUserSession
    }), this.init();
  }
  static removeUserSession() {
    Po(it, se.storageTypeLocal);
  }
  static storeUserSession(t) {
    ui(it, Ht(t), se.storageTypeLocal);
  }
  static fetchUserSession() {
    const t = Nn(it, se.storageTypeLocal);
    return t ? JSON.parse(t) : null;
  }
  init() {
    document.addEventListener("visibilitychange", () => {
      document.visibilityState === "visible" && this.updateSession();
    }), k.metas.addListener(Uo({
      fetchUserSession: se.fetchUserSession,
      storeUserSession: se.storeUserSession
    }));
  }
}
se.storageTypeLocal = Oe.local;
class de {
  constructor() {
    this.updateSession = No(() => this.updateUserSession(), Lo), this.updateUserSession = di({
      fetchUserSession: de.fetchUserSession,
      storeUserSession: de.storeUserSession
    }), this.init();
  }
  static removeUserSession() {
    Po(it, de.storageTypeSession);
  }
  static storeUserSession(t) {
    ui(it, Ht(t), de.storageTypeSession);
  }
  static fetchUserSession() {
    const t = Nn(it, de.storageTypeSession);
    return t ? JSON.parse(t) : null;
  }
  init() {
    document.addEventListener("visibilitychange", () => {
      document.visibilityState === "visible" && this.updateSession();
    }), k.metas.addListener(Uo({
      fetchUserSession: de.fetchUserSession,
      storeUserSession: de.storeUserSession
    }));
  }
}
de.storageTypeSession = Oe.session;
function jo(e) {
  return e != null && e.persistent ? se : de;
}
class zc extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-session", this.version = J;
  }
  sendSessionStartEvent(t) {
    var n, r;
    const i = t.session;
    if (i && i.id !== ((n = this.notifiedSession) === null || n === void 0 ? void 0 : n.id)) {
      if (this.notifiedSession && this.notifiedSession.id === ((r = i.attributes) === null || r === void 0 ? void 0 : r.previousSession)) {
        this.api.pushEvent(Lc, {}, void 0, { skipDedupe: !0 }), this.notifiedSession = i;
        return;
      }
      this.notifiedSession = i, this.api.pushEvent(Qt, {}, void 0, { skipDedupe: !0 });
    }
  }
  createInitialSession(t, n) {
    var r, i, s, o, a, u;
    let c = t.fetchUserSession();
    if (n.persistent && n.maxSessionPersistenceTime && c) {
      const d = ut();
      c.lastActivity < d - n.maxSessionPersistenceTime && (se.removeUserSession(), c = null);
    }
    let p, m;
    if (ko(c)) {
      const d = c == null ? void 0 : c.sessionId;
      m = vn({
        sessionId: d,
        isSampled: c.isSampled || !1,
        started: c == null ? void 0 : c.started
      });
      const l = c == null ? void 0 : c.sessionMeta, f = Object.assign(Object.assign({}, (r = n.session) === null || r === void 0 ? void 0 : r.overrides), l == null ? void 0 : l.overrides);
      m.sessionMeta = Object.assign(Object.assign({}, n.session), { id: d, attributes: Object.assign(Object.assign(Object.assign({}, (i = n.session) === null || i === void 0 ? void 0 : i.attributes), l == null ? void 0 : l.attributes), {
        // For valid resumed sessions we do not want to recalculate the sampling decision on each init phase.
        isSampled: m.isSampled.toString()
      }), overrides: f }), p = lr;
    } else {
      const d = (o = (s = n.session) === null || s === void 0 ? void 0 : s.id) !== null && o !== void 0 ? o : jc().id;
      m = vn({
        sessionId: d,
        isSampled: li()
      });
      const l = (a = n.session) === null || a === void 0 ? void 0 : a.overrides;
      m.sessionMeta = Object.assign({ id: d, attributes: Object.assign({ isSampled: m.isSampled.toString() }, (u = n.session) === null || u === void 0 ? void 0 : u.attributes) }, l ? { overrides: l } : {}), p = Qt;
    }
    return { initialSession: m, lifecycleType: p };
  }
  registerBeforeSendHook(t) {
    var n;
    const { updateSession: r } = new t();
    (n = this.transports) === null || n === void 0 || n.addBeforeSendHooks((i) => {
      var s, o, a;
      r();
      const u = (s = i.meta.session) === null || s === void 0 ? void 0 : s.attributes;
      if (u && (u == null ? void 0 : u.isSampled) === "true") {
        let c = JSON.parse(JSON.stringify(i));
        const p = (o = c.meta.session) === null || o === void 0 ? void 0 : o.attributes;
        return p == null || delete p.isSampled, Object.keys(p != null ? p : {}).length === 0 && ((a = c.meta.session) === null || a === void 0 || delete a.attributes), c;
      }
      return null;
    });
  }
  initialize() {
    this.logDebug("init session instrumentation");
    const t = this.config.sessionTracking;
    if (t != null && t.enabled) {
      const n = jo(t);
      this.registerBeforeSendHook(n);
      const { initialSession: r, lifecycleType: i } = this.createInitialSession(n, t);
      n.storeUserSession(r);
      const s = r.sessionMeta;
      this.notifiedSession = s, this.api.setSession(s), i === Qt && this.api.pushEvent(Qt, {}, void 0, { skipDedupe: !0 }), i === lr && this.api.pushEvent(lr, {}, void 0, { skipDedupe: !0 });
    }
    this.metas.addListener(this.sendSessionStartEvent.bind(this));
  }
}
const Gc = "resource-entry", fi = "http-request-start", pi = "http-request-end", qc = "dom-mutation", Kc = "console";
let Jt, rs = !1;
function Wc(e) {
  if (Jt || (Jt = new q()), !rs) {
    const t = e != null ? e : Vt;
    Wu.forEach((n) => {
      console[n] = (...r) => {
        var i;
        Jt.notify({
          type: Kc,
          level: n,
          args: r
        }), (i = t[n]) === null || i === void 0 || i.apply(console, r);
      };
    }), rs = !0;
  }
  return Jt;
}
const Yc = "Non-Error promise rejection captured with value:", Xc = "UnhandledRejection", Qc = "DOMError", Jc = "DOMException", Zc = "Non-Error exception captured with keys:", el = "?", tl = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
function nl(e) {
  var t, n;
  const r = e.match(tl), i = (t = r == null ? void 0 : r[1]) !== null && t !== void 0 ? t : Ao;
  return [(n = r == null ? void 0 : r[2]) !== null && n !== void 0 ? n : e, i];
}
const is = `
`, rl = "eval", il = "?", ss = "@", sl = /^\s*at (?:(?![a-z]+:\/\/)([^(]+?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, ol = /\((\S*)(?::(\d+))(?::(\d+))\)/, al = "eval", Bo = "address at ", ul = Bo.length, cl = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, ll = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, dl = " > eval", os = "safari-extension", as = "safari-web-extension", fl = /Minified React error #\d+;/i;
function $o(e, t, n, r) {
  const i = {
    filename: e || document.location.href,
    function: t || il
  };
  return n !== void 0 && (i.lineno = n), r !== void 0 && (i.colno = r), i;
}
function us(e, t) {
  const n = e == null ? void 0 : e.includes(os), r = !n && (e == null ? void 0 : e.includes(as));
  return !n && !r ? [e, t] : [
    e != null && e.includes(ss) ? e.split(ss)[0] : e,
    n ? `${os}:${t}` : `${as}:${t}`
  ];
}
function Ur(e) {
  let t = [];
  e.stacktrace ? t = e.stacktrace.split(is).filter((r, i) => i % 2 === 0) : e.stack && (t = e.stack.split(is));
  const n = t.reduce((r, i, s) => {
    let o, a, u, c, p;
    if (o = sl.exec(i)) {
      if (a = o[1], u = o[2], c = o[3], p = o[4], u != null && u.startsWith(al)) {
        const m = ol.exec(u);
        m && (u = m[1], c = m[2], p = m[3]);
      }
      u = u != null && u.startsWith(Bo) ? u.substring(ul) : u, [a, u] = us(a, u);
    } else if (o = cl.exec(i)) {
      if (a = o[1], u = o[3], c = o[4], p = o[5], u && u.includes(dl)) {
        const m = ll.exec(u);
        m && (a = a || rl, u = m[1], c = m[2]);
      } else
        s === 0 && !p && ju(e.columnNumber) && (p = String(e.columnNumber + 1));
      [a, u] = us(a, u);
    }
    return (u || a) && r.push($o(u, a, c ? Number(c) : void 0, p ? Number(p) : void 0)), r;
  }, []);
  return fl.test(e.message) ? n.slice(1) : n;
}
function pl(e) {
  return {
    frames: Ur(e)
  };
}
function Fo(e) {
  let t, n, r = [], i, s;
  if (zu(e) && e.error)
    t = e.error.message, n = e.error.name, r = Ur(e.error);
  else if ((i = Gu(e)) || qu(e)) {
    const { name: o, message: a } = e;
    n = o != null ? o : i ? Qc : Jc, t = a ? `${n}: ${a}` : n;
  } else
    oi(e) ? (t = e.message, r = Ur(e)) : (pe(e) || (s = Hu(e))) && (n = s ? e.constructor.name : void 0, t = `${Zc} ${Object.keys(e)}`);
  return [t, n, r];
}
function Ho(e) {
  const [t, n, r, i, s] = e;
  let o, a, u = [];
  const c = $t(t), p = $o(n, el, r, i);
  return s || !c ? ([o, a, u] = Fo(s != null ? s : t), u.length === 0 && (u = [p])) : c && ([o, a] = nl(t), u = [p]), { value: o, type: a, stackFrames: u };
}
function cs(e, t) {
  return oi(e[0]) ? Ho(e) : { value: t(e) };
}
class ke extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-console", this.version = J, this.errorSerializer = gn;
  }
  initialize() {
    var t, n;
    const r = this.config.consoleInstrumentation, i = (r == null ? void 0 : r.serializeErrors) || !!(r != null && r.errorSerializer);
    this.errorSerializer = i ? (t = r == null ? void 0 : r.errorSerializer) !== null && t !== void 0 ? t : ns : gn;
    const s = (n = r == null ? void 0 : r.disabledLevels) !== null && n !== void 0 ? n : ke.defaultDisabledLevels, o = Wc(this.unpatchedConsole);
    this.subscription = o.subscribe(({ level: a, args: u }) => {
      if (!s.includes(a))
        try {
          if (a === W.ERROR && !(r != null && r.consoleErrorAsLog)) {
            const { value: c, type: p, stackFrames: m } = cs(u, this.errorSerializer);
            if (c && !p && !m) {
              this.api.pushError(new Error(ke.consoleErrorPrefix + c));
              return;
            }
            this.api.pushError(new Error(ke.consoleErrorPrefix + c), { type: p, stackFrames: m });
          } else if (a === W.ERROR && (r != null && r.consoleErrorAsLog)) {
            const { value: c, type: p, stackFrames: m } = cs(u, this.errorSerializer);
            this.api.pushLog(c ? [ke.consoleErrorPrefix + c] : u, {
              level: a,
              context: {
                value: c != null ? c : "",
                type: p != null ? p : "",
                stackFrames: m != null && m.length ? ns(m) : ""
              }
            });
          } else
            this.api.pushLog(u, { level: a });
        } catch (c) {
          this.logError(c);
        }
    });
  }
  // Clean up subscription when instrumentation is destroyed
  destroy() {
    var t;
    (t = this.subscription) === null || t === void 0 || t.unsubscribe(), this.subscription = void 0;
  }
}
ke.defaultDisabledLevels = [W.DEBUG, W.TRACE, W.LOG];
ke.consoleErrorPrefix = "console.error: ";
function hl(e) {
  const t = window.onerror;
  window.onerror = (...n) => {
    try {
      const { value: r, type: i, stackFrames: s } = Ho(n), o = n[4];
      if (r) {
        const a = { type: i, stackFrames: s };
        o != null && (a.originalError = o), e.pushError(new Error(r), a);
      }
    } finally {
      t == null || t.apply(window, n);
    }
  };
}
function ml(e) {
  const t = (n) => {
    var r, i;
    let s = n;
    s.reason ? s = n.reason : !((r = n.detail) === null || r === void 0) && r.reason && (s = (i = n.detail) === null || i === void 0 ? void 0 : i.reason);
    let o, a, u = [];
    $u(s) ? (o = `${Yc} ${String(s)}`, a = Xc) : [o, a, u] = Fo(s), o && e.pushError(new Error(o), { type: a, stackFrames: u });
  };
  window.addEventListener("unhandledrejection", t);
}
class gl extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-errors", this.version = J;
  }
  initialize() {
    this.logDebug("Initializing"), hl(this.api), ml(this.api);
  }
}
class vl extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-view", this.version = J;
  }
  sendViewChangedEvent(t) {
    var n, r, i, s;
    const o = t.view;
    o && o.name !== ((n = this.notifiedView) === null || n === void 0 ? void 0 : n.name) && (this.api.pushEvent(Mc, {
      fromView: (i = (r = this.notifiedView) === null || r === void 0 ? void 0 : r.name) !== null && i !== void 0 ? i : X,
      toView: (s = o.name) !== null && s !== void 0 ? s : X
    }, void 0, { skipDedupe: !0 }), this.notifiedView = o);
  }
  initialize() {
    this.metas.addListener(this.sendViewChangedEvent.bind(this));
  }
}
let ls = class {
  constructor() {
    v(this, "t");
    v(this, "o", 0);
    v(this, "i", []);
  }
  u(t) {
    var i;
    if (t.hadRecentInput)
      return;
    const n = this.i[0], r = this.i.at(-1);
    this.o && n && r && t.startTime - r.startTime < 1e3 && t.startTime - n.startTime < 5e3 ? (this.o += t.value, this.i.push(t)) : (this.o = t.value, this.i = [t]), (i = this.t) == null || i.call(this, t);
  }
};
const ht = () => {
  const e = performance.getEntriesByType("navigation")[0];
  if (e && e.responseStart > 0 && e.responseStart < performance.now())
    return e;
}, _n = (e) => {
  if (document.readyState === "loading")
    return "loading";
  {
    const t = ht();
    if (t) {
      if (e < t.domInteractive)
        return "loading";
      if (t.domContentLoadedEventStart === 0 || e < t.domContentLoadedEventStart)
        return "dom-interactive";
      if (t.domComplete === 0 || e < t.domComplete)
        return "dom-content-loaded";
    }
  }
  return "complete";
}, _l = (e) => {
  const t = e.nodeName;
  return e.nodeType === 1 ? t.toLowerCase() : t.toUpperCase().replace(/^#/, "");
}, hi = (e) => {
  let t = "";
  try {
    for (; (e == null ? void 0 : e.nodeType) !== 9; ) {
      const n = e, r = n.id ? "#" + n.id : [_l(n), ...Array.from(n.classList).sort()].join(".");
      if (t.length + r.length > 99)
        return t || r;
      if (t = t ? r + ">" + t : r, n.id)
        break;
      e = n.parentNode;
    }
  } catch (n) {
  }
  return t;
}, dr = /* @__PURE__ */ new WeakMap();
function ct(e, t) {
  return dr.get(e) || dr.set(e, new t()), dr.get(e);
}
let Vo = -1;
const zo = () => Vo, mt = (e) => {
  addEventListener("pageshow", (t) => {
    t.persisted && (Vo = t.timeStamp, e(t));
  }, !0);
}, he = (e, t, n, r) => {
  let i, s;
  return (o) => {
    t.value >= 0 && (o || r) && (s = t.value - (i != null ? i : 0), (s || i === void 0) && (i = t.value, t.delta = s, t.rating = ((a, u) => a > u[1] ? "poor" : a > u[0] ? "needs-improvement" : "good")(t.value, n), e(t)));
  };
}, mi = (e) => {
  requestAnimationFrame(() => requestAnimationFrame(() => e()));
}, zt = () => {
  var t;
  const e = ht();
  return (t = e == null ? void 0 : e.activationStart) != null ? t : 0;
}, me = (e, t = -1) => {
  const n = ht();
  let r = "navigate";
  return zo() >= 0 ? r = "back-forward-cache" : n && (document.prerendering || zt() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : n.type && (r = n.type.replace(/_/g, "-"))), { name: e, value: t, rating: "good", delta: 0, entries: [], id: `v5-${Date.now()}-${Math.floor(8999999999999 * Math.random()) + 1e12}`, navigationType: r };
}, lt = (e, t, n = {}) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      const r = new PerformanceObserver((i) => {
        Promise.resolve().then(() => {
          t(i.getEntries());
        });
      });
      return r.observe(At({ type: e, buffered: !0 }, n)), r;
    }
  } catch (r) {
  }
}, gi = (e) => {
  let t = !1;
  return () => {
    t || (e(), t = !0);
  };
};
let rt = -1;
const Go = /* @__PURE__ */ new Set(), ds = () => document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0, jr = (e) => {
  if (document.visibilityState === "hidden") {
    if (e.type === "visibilitychange")
      for (const t of Go)
        t();
    isFinite(rt) || (rt = e.type === "visibilitychange" ? e.timeStamp : 0, removeEventListener("prerenderingchange", jr, !0));
  }
}, Mn = () => {
  var e;
  if (rt < 0) {
    const t = zt(), n = document.prerendering || (e = globalThis.performance.getEntriesByType("visibility-state").filter((r) => r.name === "hidden" && r.startTime > t)[0]) == null ? void 0 : e.startTime;
    rt = n != null ? n : ds(), addEventListener("visibilitychange", jr, !0), addEventListener("prerenderingchange", jr, !0), mt(() => {
      setTimeout(() => {
        rt = ds();
      });
    });
  }
  return { get firstHiddenTime() {
    return rt;
  }, onHidden(t) {
    Go.add(t);
  } };
}, Ln = (e) => {
  document.prerendering ? addEventListener("prerenderingchange", () => e(), !0) : e();
}, fs = [1800, 3e3], qo = (e, t = {}) => {
  Ln(() => {
    const n = Mn();
    let r, i = me("FCP");
    const s = lt("paint", (o) => {
      for (const a of o)
        a.name === "first-contentful-paint" && (s.disconnect(), a.startTime < n.firstHiddenTime && (i.value = Math.max(a.startTime - zt(), 0), i.entries.push(a), r(!0)));
    });
    s && (r = he(e, i, fs, t.reportAllChanges), mt((o) => {
      i = me("FCP"), r = he(e, i, fs, t.reportAllChanges), mi(() => {
        i.value = performance.now() - o.timeStamp, r(!0);
      });
    }));
  });
}, ps = [0.1, 0.25], hs = (e) => e.find((t) => {
  var n;
  return ((n = t.node) == null ? void 0 : n.nodeType) === 1;
}) || e[0], bl = (e, t = {}) => {
  const n = ct(t = Object.assign({}, t), ls), r = /* @__PURE__ */ new WeakMap();
  n.t = (i) => {
    var s, o, a;
    if ((s = i == null ? void 0 : i.sources) != null && s.length) {
      const u = hs(i.sources), c = u == null ? void 0 : u.node;
      if (c) {
        const p = (a = (o = t.generateTarget) == null ? void 0 : o.call(t, c)) != null ? a : hi(c);
        r.set(u, p);
      }
    }
  }, ((i, s = {}) => {
    const o = Mn();
    qo(gi(() => {
      let a, u = me("CLS", 0);
      const c = ct(s, ls), p = (d) => {
        for (const l of d)
          c.u(l);
        c.o > u.value && (u.value = c.o, u.entries = c.i, a());
      }, m = lt("layout-shift", p);
      m && (a = he(i, u, ps, s.reportAllChanges), o.onHidden(() => {
        p(m.takeRecords()), a(!0);
      }), mt(() => {
        c.o = 0, u = me("CLS", 0), a = he(i, u, ps, s.reportAllChanges), mi(() => a());
      }), setTimeout(a));
    }));
  })((i) => {
    const s = ((o) => {
      var u;
      let a = {};
      if (o.entries.length) {
        const c = o.entries.reduce((p, m) => p.value > m.value ? p : m);
        if ((u = c == null ? void 0 : c.sources) != null && u.length) {
          const p = hs(c.sources);
          p && (a = { largestShiftTarget: r.get(p), largestShiftTime: c.startTime, largestShiftValue: c.value, largestShiftSource: p, largestShiftEntry: c, loadState: _n(c.startTime) });
        }
      }
      return Object.assign(o, { attribution: a });
    })(i);
    e(s);
  }, t);
}, El = (e, t = {}) => {
  qo((n) => {
    const r = ((i) => {
      let s = { timeToFirstByte: 0, firstByteToFCP: i.value, loadState: _n(zo()) };
      if (i.entries.length) {
        const o = ht(), a = i.entries.at(-1);
        if (o) {
          const u = o.activationStart || 0, c = Math.max(0, o.responseStart - u);
          s = { timeToFirstByte: c, firstByteToFCP: i.value - c, loadState: _n(i.entries[0].startTime), navigationEntry: o, fcpEntry: a };
        }
      }
      return Object.assign(i, { attribution: s });
    })(n);
    e(r);
  }, t);
};
let Ko = 0, fr = 1 / 0, Zt = 0;
const Sl = (e) => {
  for (const t of e)
    t.interactionId && (fr = Math.min(fr, t.interactionId), Zt = Math.max(Zt, t.interactionId), Ko = Zt ? (Zt - fr) / 7 + 1 : 0);
};
let Br;
const ms = () => {
  var e;
  return Br ? Ko : (e = performance.interactionCount) != null ? e : 0;
}, yl = () => {
  "interactionCount" in performance || Br || (Br = lt("event", Sl, { type: "event", buffered: !0, durationThreshold: 0 }));
};
let gs = 0, vs = class {
  constructor() {
    v(this, "l", []);
    v(this, "h", /* @__PURE__ */ new Map());
    v(this, "m");
    v(this, "p");
  }
  v() {
    gs = ms(), this.l.length = 0, this.h.clear();
  }
  M() {
    const t = Math.min(this.l.length - 1, Math.floor((ms() - gs) / 50));
    return this.l[t];
  }
  u(t) {
    var i, s;
    if ((i = this.m) == null || i.call(this, t), !t.interactionId && t.entryType !== "first-input")
      return;
    const n = this.l.at(-1);
    let r = this.h.get(t.interactionId);
    if (r || this.l.length < 10 || t.duration > n.T) {
      if (r ? t.duration > r.T ? (r.entries = [t], r.T = t.duration) : t.duration === r.T && t.startTime === r.entries[0].startTime && r.entries.push(t) : (r = { id: t.interactionId, entries: [t], T: t.duration }, this.h.set(r.id, r), this.l.push(r)), this.l.sort((o, a) => a.T - o.T), this.l.length > 10) {
        const o = this.l.splice(10);
        for (const a of o)
          this.h.delete(a.id);
      }
      (s = this.p) == null || s.call(this, r);
    }
  }
};
const $r = (e) => {
  const t = globalThis.requestIdleCallback || setTimeout;
  document.visibilityState === "hidden" ? e() : (e = gi(e), addEventListener("visibilitychange", e, { once: !0, capture: !0 }), t(() => {
    e(), removeEventListener("visibilitychange", e, { capture: !0 });
  }));
}, _s = [200, 500], Tl = (e, t = {}) => {
  const n = ct(t = Object.assign({}, t), vs);
  let r = [], i = [], s = 0;
  const o = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
  let u = !1;
  const c = () => {
    u || ($r(p), u = !0);
  }, p = () => {
    const l = n.l.map((_) => o.get(_.entries[0])), f = i.length - 50;
    i = i.filter((_, T) => T >= f || l.includes(_));
    const h = /* @__PURE__ */ new Set();
    for (const _ of i) {
      const T = m(_.startTime, _.processingEnd);
      for (const S of T)
        h.add(S);
    }
    const g = r.length - 1 - 50;
    r = r.filter((_, T) => _.startTime > s && T > g || h.has(_)), u = !1;
  };
  n.m = (l) => {
    const f = l.startTime + l.duration;
    let h;
    s = Math.max(s, l.processingEnd);
    for (let g = i.length - 1; g >= 0; g--) {
      const _ = i[g];
      if (Math.abs(f - _.renderTime) <= 8) {
        h = _, h.startTime = Math.min(l.startTime, h.startTime), h.processingStart = Math.min(l.processingStart, h.processingStart), h.processingEnd = Math.max(l.processingEnd, h.processingEnd), h.entries.push(l);
        break;
      }
    }
    h || (h = { startTime: l.startTime, processingStart: l.processingStart, processingEnd: l.processingEnd, renderTime: f, entries: [l] }, i.push(h)), (l.interactionId || l.entryType === "first-input") && o.set(l, h), c();
  }, n.p = (l) => {
    var f, h;
    if (!a.get(l)) {
      const g = l.entries[0].target;
      if (g) {
        const _ = (h = (f = t.generateTarget) == null ? void 0 : f.call(t, g)) != null ? h : hi(g);
        a.set(l, _);
      }
    }
  };
  const m = (l, f) => {
    const h = [];
    for (const g of r)
      if (!(g.startTime + g.duration < l)) {
        if (g.startTime > f)
          break;
        h.push(g);
      }
    return h;
  }, d = (l) => {
    const f = l.entries[0], h = o.get(f), g = f.processingStart, _ = Math.max(f.startTime + f.duration, g), T = Math.min(h.processingEnd, _), S = h.entries.sort((w, D) => w.processingStart - D.processingStart), b = m(f.startTime, T), y = n.h.get(f.interactionId), E = { interactionTarget: a.get(y), interactionType: f.name.startsWith("key") ? "keyboard" : "pointer", interactionTime: f.startTime, nextPaintTime: _, processedEventEntries: S, longAnimationFrameEntries: b, inputDelay: g - f.startTime, processingDuration: T - g, presentationDelay: _ - T, loadState: _n(f.startTime), longestScript: void 0, totalScriptDuration: void 0, totalStyleAndLayoutDuration: void 0, totalPaintDuration: void 0, totalUnattributedDuration: void 0 };
    return ((w) => {
      var _t;
      if (!((_t = w.longAnimationFrameEntries) != null && _t.length))
        return;
      const D = w.interactionTime, V = w.inputDelay, Y = w.processingDuration;
      let Ye, Xe, Ie = 0, ae = 0, gt = 0, Ce = 0;
      for (const Qe of w.longAnimationFrameEntries) {
        ae = ae + Qe.startTime + Qe.duration - Qe.styleAndLayoutStart;
        for (const K of Qe.scripts) {
          const Je = K.startTime + K.duration;
          if (Je < D)
            continue;
          const xe = Je - Math.max(D, K.startTime), Ze = K.duration ? xe / K.duration * K.forcedStyleAndLayoutDuration : 0;
          Ie += xe - Ze, ae += Ze, xe > Ce && (Xe = K.startTime < D + V ? "input-delay" : K.startTime >= D + V + Y ? "presentation-delay" : "processing-duration", Ye = K, Ce = xe);
        }
      }
      const Ne = w.longAnimationFrameEntries.at(-1), vt = Ne ? Ne.startTime + Ne.duration : 0;
      vt >= D + V + Y && (gt = w.nextPaintTime - vt), Ye && Xe && (w.longestScript = { entry: Ye, subpart: Xe, intersectingDuration: Ce }), w.totalScriptDuration = Ie, w.totalStyleAndLayoutDuration = ae, w.totalPaintDuration = gt, w.totalUnattributedDuration = w.nextPaintTime - D - Ie - ae - gt;
    })(E), Object.assign(l, { attribution: E });
  };
  lt("long-animation-frame", (l) => {
    r = r.concat(l), c();
  }), ((l, f = {}) => {
    if (!globalThis.PerformanceEventTiming || !("interactionId" in PerformanceEventTiming.prototype))
      return;
    const h = Mn();
    Ln(() => {
      var y;
      yl();
      let g, _ = me("INP");
      const T = ct(f, vs), S = (E) => {
        $r(() => {
          for (const D of E)
            T.u(D);
          const w = T.M();
          w && w.T !== _.value && (_.value = w.T, _.entries = w.entries, g());
        });
      }, b = lt("event", S, { durationThreshold: (y = f.durationThreshold) != null ? y : 40 });
      g = he(l, _, _s, f.reportAllChanges), b && (b.observe({ type: "first-input", buffered: !0 }), h.onHidden(() => {
        S(b.takeRecords()), g(!0);
      }), mt(() => {
        T.v(), _ = me("INP"), g = he(l, _, _s, f.reportAllChanges);
      }));
    });
  })((l) => {
    const f = d(l);
    e(f);
  }, t);
};
class bs {
  constructor() {
    v(this, "m");
  }
  u(t) {
    var n;
    (n = this.m) == null || n.call(this, t);
  }
}
const Es = [2500, 4e3], wl = (e, t = {}) => {
  const n = ct(t = Object.assign({}, t), bs), r = /* @__PURE__ */ new WeakMap();
  n.m = (i) => {
    var o, a;
    const s = i.element;
    if (s) {
      const u = (a = (o = t.generateTarget) == null ? void 0 : o.call(t, s)) != null ? a : hi(s);
      r.set(i, u);
    }
  }, ((i, s = {}) => {
    Ln(() => {
      const o = Mn();
      let a, u = me("LCP");
      const c = ct(s, bs), p = (d) => {
        s.reportAllChanges || (d = d.slice(-1));
        for (const l of d)
          c.u(l), l.startTime < o.firstHiddenTime && (u.value = Math.max(l.startTime - zt(), 0), u.entries = [l], a());
      }, m = lt("largest-contentful-paint", p);
      if (m) {
        a = he(i, u, Es, s.reportAllChanges);
        const d = gi(() => {
          p(m.takeRecords()), m.disconnect(), a(!0);
        }), l = (f) => {
          f.isTrusted && ($r(d), removeEventListener(f.type, l, { capture: !0 }));
        };
        for (const f of ["keydown", "click", "visibilitychange"])
          addEventListener(f, l, { capture: !0 });
        mt((f) => {
          u = me("LCP"), a = he(i, u, Es, s.reportAllChanges), mi(() => {
            u.value = performance.now() - f.timeStamp, a(!0);
          });
        });
      }
    });
  })((i) => {
    const s = ((o) => {
      let a = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadDuration: 0, elementRenderDelay: o.value };
      if (o.entries.length) {
        const u = ht();
        if (u) {
          const c = u.activationStart || 0, p = o.entries.at(-1), m = p.url && performance.getEntriesByType("resource").filter((h) => h.name === p.url)[0], d = Math.max(0, u.responseStart - c), l = Math.max(d, m ? (m.requestStart || m.startTime) - c : 0), f = Math.min(o.value, Math.max(l, m ? m.responseEnd - c : 0));
          a = { target: r.get(p), timeToFirstByte: d, resourceLoadDelay: l - d, resourceLoadDuration: f - l, elementRenderDelay: o.value - f, navigationEntry: u, lcpEntry: p }, p.url && (a.url = p.url), m && (a.lcpResourceEntry = m);
        }
      }
      return Object.assign(o, { attribution: a });
    })(i);
    e(s);
  }, t);
}, Ss = [800, 1800], Fr = (e) => {
  document.prerendering ? Ln(() => Fr(e)) : document.readyState !== "complete" ? addEventListener("load", () => Fr(e), !0) : setTimeout(e);
}, Al = (e, t = {}) => {
  ((n, r = {}) => {
    let i = me("TTFB"), s = he(n, i, Ss, r.reportAllChanges);
    Fr(() => {
      const o = ht();
      o && (i.value = Math.max(o.responseStart - zt(), 0), i.entries = [o], s(!0), mt(() => {
        i = me("TTFB", 0), s = he(n, i, Ss, r.reportAllChanges), s(!0);
      }));
    });
  })((n) => {
    const r = ((i) => {
      let s = { waitingDuration: 0, cacheDuration: 0, dnsDuration: 0, connectionDuration: 0, requestDuration: 0 };
      if (i.entries.length) {
        const o = i.entries[0], a = o.activationStart || 0, u = Math.max((o.workerStart || o.fetchStart) - a, 0), c = Math.max(o.domainLookupStart - a, 0), p = Math.max(o.connectStart - a, 0), m = Math.max(o.connectEnd - a, 0);
        s = { waitingDuration: u, cacheDuration: c - u, dnsDuration: p - c, connectionDuration: m - p, requestDuration: i.value - m, navigationEntry: o };
      }
      return Object.assign(i, { attribution: s });
    })(n);
    e(r);
  }, t);
}, Hr = "com.grafana.faro.lastNavigationId", pr = "load_state", ys = "time_to_first_byte";
class Ol {
  constructor(t, n) {
    this.corePushMeasurement = t, this.webVitalConfig = n;
  }
  initialize() {
    this.measureCLS(), this.measureFCP(), this.measureINP(), this.measureLCP(), this.measureTTFB();
  }
  measureCLS() {
    var t;
    bl((n) => {
      const { loadState: r, largestShiftValue: i, largestShiftTime: s, largestShiftTarget: o } = n.attribution, a = this.buildInitialValues(n);
      this.addIfPresent(a, "largest_shift_value", i), this.addIfPresent(a, "largest_shift_time", s);
      const u = this.buildInitialContext(n);
      this.addIfPresent(u, pr, r), this.addIfPresent(u, "largest_shift_target", o), this.pushMeasurement(a, u);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  measureFCP() {
    var t;
    El((n) => {
      const { firstByteToFCP: r, timeToFirstByte: i, loadState: s } = n.attribution, o = this.buildInitialValues(n);
      this.addIfPresent(o, "first_byte_to_fcp", r), this.addIfPresent(o, ys, i);
      const a = this.buildInitialContext(n);
      this.addIfPresent(a, pr, s), this.pushMeasurement(o, a);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  measureINP() {
    var t;
    Tl((n) => {
      const { interactionTime: r, presentationDelay: i, inputDelay: s, processingDuration: o, nextPaintTime: a, loadState: u, interactionTarget: c, interactionType: p } = n.attribution, m = this.buildInitialValues(n);
      this.addIfPresent(m, "interaction_time", r), this.addIfPresent(m, "presentation_delay", i), this.addIfPresent(m, "input_delay", s), this.addIfPresent(m, "processing_duration", o), this.addIfPresent(m, "next_paint_time", a);
      const d = this.buildInitialContext(n);
      this.addIfPresent(d, pr, u), this.addIfPresent(d, "interaction_target", c), this.addIfPresent(d, "interaction_type", p), this.pushMeasurement(m, d);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  measureLCP() {
    var t;
    wl((n) => {
      const { elementRenderDelay: r, resourceLoadDelay: i, resourceLoadDuration: s, timeToFirstByte: o, target: a } = n.attribution, u = this.buildInitialValues(n);
      this.addIfPresent(u, "element_render_delay", r), this.addIfPresent(u, "resource_load_delay", i), this.addIfPresent(u, "resource_load_duration", s), this.addIfPresent(u, ys, o);
      const c = this.buildInitialContext(n);
      this.addIfPresent(c, "element", a), this.pushMeasurement(u, c);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  measureTTFB() {
    var t;
    Al((n) => {
      const { dnsDuration: r, connectionDuration: i, requestDuration: s, waitingDuration: o, cacheDuration: a } = n.attribution, u = this.buildInitialValues(n);
      this.addIfPresent(u, "dns_duration", r), this.addIfPresent(u, "connection_duration", i), this.addIfPresent(u, "request_duration", s), this.addIfPresent(u, "waiting_duration", o), this.addIfPresent(u, "cache_duration", a);
      const c = this.buildInitialContext(n);
      this.pushMeasurement(u, c);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  buildInitialValues(t) {
    return {
      [t.name.toLowerCase()]: t.value,
      delta: t.delta
    };
  }
  buildInitialContext(t) {
    var n;
    const r = (n = Nn(Hr, Oe.session)) !== null && n !== void 0 ? n : X;
    return {
      id: t.id,
      rating: t.rating,
      navigation_type: t.navigationType,
      navigation_entry_id: r
    };
  }
  pushMeasurement(t, n) {
    const r = "web-vitals";
    this.corePushMeasurement({ type: r, values: t }, { context: n });
  }
  addIfPresent(t, n, r) {
    r && (t[n] = r);
  }
}
class Rl extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-web-vitals", this.version = J;
  }
  initialize() {
    this.logDebug("Initializing"), new Ol(this.api.pushMeasurement, this.config.webVitalsInstrumentation).initialize();
  }
}
const Pl = "navigation", Vr = "resource", Il = /^00-[a-f0-9]{32}-[a-f0-9]{16}-[0-9]{1,2}$/;
function Wo(e = []) {
  for (const t of e)
    if (t.name === "traceparent") {
      if (!Il.test(t.description))
        continue;
      const [, n, r] = t.description.split("-");
      if (n != null && r != null)
        return { traceId: n, spanId: r };
      break;
    }
}
function Cl() {
  return "PerformanceObserver" in window;
}
function Nl(e) {
  if (document.readyState === "complete")
    e();
  else {
    const t = () => {
      document.readyState === "complete" && (e(), document.removeEventListener("readystatechange", t));
    };
    document.addEventListener("readystatechange", t);
  }
}
function xl(e, t = {}) {
  for (const [n, r] of Object.entries(t)) {
    const i = e[n];
    return i == null ? !1 : at(r) ? r.includes(i) : i === r;
  }
  return !0;
}
function Yo(e) {
  const {
    connectEnd: t,
    connectStart: n,
    decodedBodySize: r,
    domainLookupEnd: i,
    domainLookupStart: s,
    duration: o,
    encodedBodySize: a,
    fetchStart: u,
    initiatorType: c,
    name: p,
    nextHopProtocol: m,
    redirectEnd: d,
    redirectStart: l,
    // @ts-expect-error the renderBlockingStatus property is not available in all browsers
    renderBlockingStatus: f,
    requestStart: h,
    responseEnd: g,
    responseStart: _,
    responseStatus: T,
    secureConnectionStart: S,
    transferSize: b,
    workerStart: y
  } = e;
  return {
    name: p,
    duration: $(o),
    tcpHandshakeTime: $(t - n),
    dnsLookupTime: $(i - s),
    tlsNegotiationTime: $(t - S),
    responseStatus: $(T),
    redirectTime: $(d - l),
    requestTime: $(_ - h),
    responseTime: $(g - _),
    fetchTime: $(g - u),
    serviceWorkerTime: $(u - y),
    decodedBodySize: $(r),
    encodedBodySize: $(a),
    cacheHitStatus: E(),
    renderBlockingStatus: $(f),
    protocol: m,
    initiatorType: c,
    visibilityState: document.visibilityState,
    ttfb: $(_ - h),
    transferSize: $(b)
    // TODO: add in future iteration, ideally after nested objects are supported by the collector.
    // serverTiming: resourceEntryRaw.serverTiming,
  };
  function E() {
    let w = "fullLoad";
    return b === 0 ? r > 0 && (w = "cache") : T != null ? T === 304 && (w = "conditionalFetch") : a > 0 && b < a && (w = "conditionalFetch"), w;
  }
}
function Ml(e) {
  const { activationStart: t, domComplete: n, domContentLoadedEventEnd: r, domContentLoadedEventStart: i, domInteractive: s, fetchStart: o, loadEventEnd: a, loadEventStart: u, responseStart: c, type: p } = e, m = Ll();
  return Object.assign(Object.assign({}, Yo(e)), {
    pageLoadTime: $(n - o),
    documentParsingTime: $(m ? s - m : null),
    domProcessingTime: $(n - s),
    domContentLoadHandlerTime: $(r - i),
    onLoadTime: $(a - u),
    // For navigation entries we can calculate the TTFB based on activationStart. We overwrite the TTFB value coming with the resource entry.
    // For more accuracy on prerendered pages page we calculate relative top the activationStart instead of the start of the navigation.
    // clamp to 0 if activationStart occurs after first byte is received.
    ttfb: $(Math.max(c - (t != null ? t : 0), 0)),
    type: p
  });
}
function Ll() {
  var e;
  return ((e = performance.timing) === null || e === void 0 ? void 0 : e.domLoading) != null ? performance.timing.domLoading - performance.timeOrigin : null;
}
function $(e) {
  return e == null ? X : typeof e == "number" ? Math.round(e > 0 ? e : 0).toString() : e.toString();
}
function kl(e) {
  let t;
  const n = new Promise((i) => {
    t = i;
  });
  return new PerformanceObserver((i) => {
    var s;
    const [o] = i.getEntries();
    if (o == null || xn(o.name))
      return;
    const a = o.toJSON();
    let u = Wo(a == null ? void 0 : a.serverTiming);
    const c = (s = Nn(Hr, Oe.session)) !== null && s !== void 0 ? s : X, p = Object.assign(Object.assign({}, Ml(a)), { faroNavigationId: Ke(), faroPreviousNavigationId: c });
    ui(Hr, p.faroNavigationId, Oe.session), e("faro.performance.navigation", p, void 0, {
      spanContext: u,
      timestampOverwriteMs: performance.timeOrigin + a.startTime
    }), t(p);
  }).observe({
    type: Pl,
    buffered: !0
  }), n;
}
const Dl = { initiatorType: ["xmlhttprequest", "fetch"] };
function Ul(e, t, n) {
  const r = k.config.trackResources;
  new PerformanceObserver((s) => {
    const o = s.getEntries();
    for (const a of o) {
      if (xn(a.name))
        continue;
      n == null || n.notify({
        type: Vr
      });
      const u = a.toJSON();
      let c = Wo(u == null ? void 0 : u.serverTiming);
      if (r == null && xl(u, Dl) || r) {
        const p = Object.assign(Object.assign({}, Yo(u)), { faroNavigationId: e, faroResourceId: Ke() });
        t("faro.performance.resource", p, void 0, {
          spanContext: c,
          timestampOverwriteMs: performance.timeOrigin + u.startTime
        });
      }
    }
  }).observe({
    type: Vr,
    buffered: !0
  });
}
var jl = globalThis && globalThis.__awaiter || function(e, t, n, r) {
  function i(s) {
    return s instanceof n ? s : new n(function(o) {
      o(s);
    });
  }
  return new (n || (n = Promise))(function(s, o) {
    function a(p) {
      try {
        c(r.next(p));
      } catch (m) {
        o(m);
      }
    }
    function u(p) {
      try {
        c(r.throw(p));
      } catch (m) {
        o(m);
      }
    }
    function c(p) {
      p.done ? s(p.value) : i(p.value).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
};
const Xo = new q();
class Bl extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-performance", this.version = J;
  }
  initialize() {
    if (!Cl()) {
      this.logDebug("performance observer not supported. Disable performance instrumentation.");
      return;
    }
    Nl(() => jl(this, void 0, void 0, function* () {
      const t = this.api.pushEvent, { faroNavigationId: n } = yield kl(t);
      n != null && Ul(n, t, Xo);
    }));
  }
}
const $l = "faroUserActionName", Fl = "data-faro-user-action-name";
let en, hr;
function Qo() {
  return en || (en = new q()), hr || (hr = new MutationObserver((e, t) => {
    en.notify({ type: qc });
  }), hr.observe(document, {
    attributes: !0,
    childList: !0,
    subtree: !0,
    characterData: !0
  })), en;
}
const mr = "fetch", tn = "xhr";
let tt, Ts = !1, gr, vr;
function Jo() {
  if (tt)
    return tt;
  tt = new q();
  function e(n) {
    tt.notify({
      type: fi,
      request: n
    });
  }
  function t(n) {
    tt.notify({
      type: pi,
      request: n
    });
  }
  return Ts || (Vl({
    onRequestStart: e,
    onRequestEnd: t
  }), Hl({
    onRequestStart: e,
    onRequestEnd: t
  }), Ts = !0), tt;
}
function Hl({ onRequestStart: e, onRequestEnd: t }) {
  gr || (gr = XMLHttpRequest.prototype.open), XMLHttpRequest.prototype.open = function() {
    const n = arguments[1], r = xn(n), i = arguments[0], s = Ke();
    this.addEventListener("loadstart", function() {
      r || e({ url: n, method: i, requestId: s, apiType: tn });
    }), this.addEventListener("load", function() {
      r || t({ url: n, method: i, requestId: s, apiType: tn });
    }), this.addEventListener("error", function() {
      r || t({ url: n, method: i, requestId: s, apiType: tn });
    }), this.addEventListener("abort", function() {
      r || t({ url: n, method: i, requestId: s, apiType: tn });
    }), gr.apply(this, arguments);
  };
}
function Vl({ onRequestEnd: e, onRequestStart: t }) {
  vr || (vr = window.fetch), window.fetch = function() {
    var n, r;
    const i = (n = xo(arguments[0])) !== null && n !== void 0 ? n : "", s = xn(i), o = ((r = arguments[1]) !== null && r !== void 0 ? r : {}).method, a = Ke();
    return s || t({ url: i, method: o, requestId: a, apiType: mr }), vr.apply(this, arguments).then((u) => (s || e({ url: i, method: o, requestId: a, apiType: mr }), u)).catch((u) => {
      throw s || e({ url: i, method: o, requestId: a, apiType: mr }), u;
    });
  };
}
let nn, ws = !1;
function zl() {
  return nn || (nn = new q()), ws || (Xo.subscribe((e) => {
    e.type === Vr && nn.notify({ type: Gc });
  }), ws = !0), nn;
}
function Gl(e) {
  const t = e.split("data-")[1], n = t == null ? void 0 : t.replace(/-(.)/g, (r, i) => i.toUpperCase());
  return n == null ? void 0 : n.replace(/-/g, "");
}
function ql(e, t, n) {
  return e && clearTimeout(e), e = setTimeout(() => {
    t();
  }, n), e;
}
function Kl(e) {
  return e.type === fi;
}
function _r(e) {
  return e.type === pi;
}
const Wl = 100, Yl = 10 * 1e3;
class Xl {
  constructor(t) {
    this.userAction = t, this.http = Jo(), this.dom = Qo(), this.perf = zl(), this.isValid = !1, this.runningRequests = /* @__PURE__ */ new Map();
  }
  attach() {
    this.allMonitorsSub = new q().merge(this.http, this.dom, this.perf).takeWhile(() => [L.Started, L.Halted].includes(this.userAction.getState())).filter((t) => !(this.userAction.getState() === L.Halted && !(_r(t) && this.runningRequests.has(t.request.requestId)))).subscribe((t) => {
      Kl(t) && this.runningRequests.set(t.request.requestId, t.request), _r(t) && this.runningRequests.delete(t.request.requestId), _r(t) ? this.userAction.getState() === L.Halted && this.runningRequests.size === 0 && this.endAction() : (this.isValid || (this.isValid = !0), this.scheduleFollowUp());
    }), this.stateSub = this.userAction.filter((t) => [L.Ended, L.Cancelled].includes(t)).first().subscribe(() => this.cleanup()), this.scheduleFollowUp();
  }
  scheduleFollowUp() {
    this.clearTimer(this.followUpTid), this.followUpTid = setTimeout(() => {
      if (this.userAction.getState() === L.Started && this.runningRequests.size > 0) {
        this.haltAction();
        return;
      }
      if (this.isValid) {
        this.endAction();
        return;
      }
      this.cancelAction();
    }, Wl);
  }
  haltAction() {
    this.userAction.getState() === L.Started && (this.userAction.halt(), this.startHaltTimeout());
  }
  startHaltTimeout() {
    this.clearTimer(this.haltTid), this.haltTid = ql(this.haltTid, () => {
      this.userAction.getState() === L.Halted && this.endAction();
    }, Yl);
  }
  endAction() {
    this.userAction.end(), this.cleanup();
  }
  cancelAction() {
    this.userAction.cancel(), this.cleanup();
  }
  cleanup() {
    var t, n;
    this.clearTimer(this.followUpTid), this.clearTimer(this.haltTid), (t = this.allMonitorsSub) === null || t === void 0 || t.unsubscribe(), (n = this.stateSub) === null || n === void 0 || n.unsubscribe(), this.allMonitorsSub = void 0, this.stateSub = void 0, this.runningRequests.clear();
  }
  clearTimer(t) {
    t && clearTimeout(t);
  }
}
function Ql(e) {
  const { api: t, config: n } = e;
  function r(s) {
    var o, a;
    const u = Jl(s.target, (a = (o = n.userActionsInstrumentation) === null || o === void 0 ? void 0 : o.dataAttributeName) !== null && a !== void 0 ? a : $l);
    if (!u)
      return;
    const c = t.startUserAction(u, {}, { triggerName: s.type });
    c && i(c);
  }
  function i(s) {
    const o = s;
    new Xl(o).attach();
  }
  return { processUserEvent: r, processUserActionStarted: i };
}
function Jl(e, t) {
  const n = Gl(t), r = e.dataset;
  for (const i in r)
    if (i === n)
      return r[i];
}
class Zl extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-user-action", this.version = J;
  }
  initialize() {
    const { processUserEvent: t, processUserActionStarted: n } = Ql(k);
    window.addEventListener("pointerdown", t), window.addEventListener("keydown", (r) => {
      [" ", "Enter"].includes(r.key) && t(r);
    }), this._userActionSub = wo.subscribe(({ type: r, userAction: i }) => {
      r === "user_action_start" && n(i);
    });
  }
  destroy() {
    var t;
    (t = this._userActionSub) === null || t === void 0 || t.unsubscribe();
  }
}
class ed extends ve {
  constructor() {
    super(), this.name = "@grafana/faro-web-sdk:instrumentation-csp", this.version = J;
  }
  initialize() {
    document.addEventListener("securitypolicyviolation", this.securitypolicyviolationHandler.bind(this));
  }
  destroy() {
    document.removeEventListener("securitypolicyviolation", this.securitypolicyviolationHandler);
  }
  securitypolicyviolationHandler(t) {
    const n = {
      blockedURI: t.blockedURI,
      columnNumber: t.columnNumber,
      disposition: t.disposition,
      documentURI: t.documentURI,
      effectiveDirective: t.effectiveDirective,
      lineNumber: t.lineNumber,
      originalPolicy: t.originalPolicy,
      referrer: t.referrer,
      sample: t.sample,
      sourceFile: t.sourceFile,
      statusCode: t.statusCode,
      violatedDirective: t.violatedDirective
    };
    this.api.pushEvent("securitypolicyviolation", pt(n));
  }
}
function td(e) {
  return e.type === fi;
}
function nd(e) {
  return e.type === pi;
}
class rd extends q {
  constructor(t, n) {
    var r, i, s, o;
    super(), this._tracking = !1, this.eventsObservable = t, this._options = {
      inactivityMs: (r = n == null ? void 0 : n.inactivityMs) !== null && r !== void 0 ? r : 100,
      drainTimeoutMs: (i = n == null ? void 0 : n.drainTimeoutMs) !== null && i !== void 0 ? i : 10 * 1e3,
      isOperationStart: (s = n == null ? void 0 : n.isOperationStart) !== null && s !== void 0 ? s : () => {
      },
      isOperationEnd: (o = n == null ? void 0 : n.isOperationEnd) !== null && o !== void 0 ? o : () => {
      }
    }, this._initialize();
  }
  _initialize() {
    this.eventsObservable.filter(() => this._tracking).subscribe((t) => {
      var n, r, i;
      this._lastEventTime = Date.now(), (n = this._currentEvents) === null || n === void 0 || n.push(t);
      const s = this._options.isOperationStart(t);
      s && ((r = this._activeOperations) === null || r === void 0 || r.set(s, !0));
      const o = this._options.isOperationEnd(t);
      o && ((i = this._activeOperations) === null || i === void 0 || i.delete(o)), this._scheduleInactivityCheck();
    });
  }
  startTracking() {
    this._tracking || (this._tracking = !0, this._startTime = Date.now(), this._lastEventTime = Date.now(), this.notify({
      message: "tracking-started"
    }), this._currentEvents = [], this._activeOperations = /* @__PURE__ */ new Map(), this._scheduleInactivityCheck());
  }
  stopTracking() {
    this._tracking = !1, this._clearTimer(this._inactivityTid), this._clearTimer(this._drainTid);
    let t = 0;
    this.hasActiveOperations() ? t = Date.now() - this._startTime : t = this._lastEventTime ? this._lastEventTime - this._startTime : 0, this.notify({
      message: "tracking-ended",
      events: this._currentEvents,
      duration: t
    });
  }
  _scheduleInactivityCheck() {
    this._inactivityTid = As(this._inactivityTid, () => {
      this.hasActiveOperations() ? this._startDrainTimeout() : this.stopTracking();
    }, this._options.inactivityMs);
  }
  _startDrainTimeout() {
    this._drainTid = As(this._drainTid, () => {
      this.stopTracking();
    }, this._options.drainTimeoutMs);
  }
  hasActiveOperations() {
    return !!this._activeOperations && this._activeOperations.size > 0;
  }
  _clearTimer(t) {
    t && clearTimeout(t);
  }
}
function As(e, t, n) {
  return e && clearTimeout(e), e = setTimeout(() => {
    t();
  }, n), e;
}
const id = "interaction";
let rn;
const Os = /* @__PURE__ */ new Set(), sd = /* @__PURE__ */ new Map();
function od(e) {
  return rn || (rn = new q()), e.forEach((t) => {
    if (!Os.has(t)) {
      const n = () => {
        rn.notify({ type: id, name: t });
      };
      window.addEventListener(t, n), Os.add(t), sd.set(t, n);
    }
  }), rn;
}
const ad = "url-change";
let sn, br = !1, on, Er, Sr, Rs, Ps, Is, yr;
function ud() {
  sn || (sn = new q(), on = location.href);
  function e(t, n) {
    const r = n != null ? n : location.href;
    r !== on && (sn.notify({ type: ad, from: on, to: r, trigger: t }), on = r);
  }
  if (!br)
    if ("navigation" in window && "NavigateEvent" in window) {
      Is = (r) => {
        try {
          const i = r == null ? void 0 : r.destination;
          i != null && i.sameDocument && typeof i.url == "string" && e("navigate", i.url);
        } catch (i) {
        }
      }, window.navigation.addEventListener("navigate", Is);
      const n = window.NavigateEvent;
      n && n.prototype && typeof n.prototype.intercept == "function" && (yr || (yr = n.prototype.intercept), n.prototype.intercept = function(r) {
        try {
          const i = !!(!(this === null || this === void 0) && this.canIntercept), s = this === null || this === void 0 ? void 0 : this.destination;
          i && s && s.sameDocument === !1 && typeof s.url == "string" && e("navigate-intercept", s.url);
        } catch (i) {
        }
        return yr.call(this, r);
      }), br = !0;
    } else
      Er || (Er = window.history.pushState), window.history.pushState = function(...n) {
        const r = Er.apply(window.history, n);
        return e("pushState"), r;
      }, Sr || (Sr = window.history.replaceState), window.history.replaceState = function(...n) {
        const r = Sr.apply(window.history, n);
        return e("replaceState"), r;
      }, Rs = () => e("popstate"), Ps = () => e("hashchange"), window.addEventListener("popstate", Rs), window.addEventListener("hashchange", Ps), br = !0;
  return sn;
}
class cd extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-navigation", this.version = J;
  }
  initialize() {
    const t = Jo(), n = Qo(), r = ud(), i = od(["pointerdown", "keydown"]), s = new rd(new q().merge(t, n, r), {
      inactivityMs: 100,
      drainTimeoutMs: 10 * 1e3,
      isOperationStart: (o) => td(o) ? o.request.requestId : void 0,
      isOperationEnd: (o) => nd(o) ? o.request.requestId : void 0
    });
    s.filter((o) => o.message === "tracking-ended").subscribe((o) => {
      var a, u, c;
      if (!((a = o.events) === null || a === void 0) && a.some((p) => p.type === "url-change") && (!((u = o.events) === null || u === void 0) && u.some((p) => p.type === "dom-mutation"))) {
        const p = (c = o.events) === null || c === void 0 ? void 0 : c.find((m) => m.type === "url-change");
        k.api.pushEvent("faro.navigation", {
          fromUrl: p == null ? void 0 : p.from,
          toUrl: p == null ? void 0 : p.to,
          sameDocument: String(!0),
          duration: o.duration
        });
      }
    }), i.subscribe(() => {
      s.startTracking();
    });
  }
}
function Zo(e = {}) {
  const t = [
    new Zl(),
    new gl(),
    new Rl(),
    new zc(),
    new vl(),
    new cd()
  ];
  return e.enablePerformanceInstrumentation !== !1 && t.unshift(new Bl()), e.enableContentSecurityPolicyInstrumentation !== !1 && t.push(new ed()), e.captureConsole !== !1 && t.push(new ke()), t;
}
const ld = "browser", dd = () => {
  const e = window.k6;
  return {
    k6: Object.assign({
      // we only add the k6 meta if Faro is running inside a k6 environment, so this is always true
      isK6Browser: !0
    }, (e == null ? void 0 : e.testRunId) && { testRunId: e == null ? void 0 : e.testRunId })
  };
};
let Cs, Tr;
function fd({ generatePageId: e, initialPageMeta: t } = {}) {
  return () => {
    const r = location.href;
    return Ft(e) && Cs !== r && (Cs = r, Tr = e(location)), {
      page: Object.assign(Object.assign({ url: r }, Tr ? { id: Tr } : {}), t)
    };
  };
}
var Ns = globalThis && globalThis.__awaiter || function(e, t, n, r) {
  function i(s) {
    return s instanceof n ? s : new n(function(o) {
      o(s);
    });
  }
  return new (n || (n = Promise))(function(s, o) {
    function a(p) {
      try {
        c(r.next(p));
      } catch (m) {
        o(m);
      }
    }
    function u(p) {
      try {
        c(r.throw(p));
      } catch (m) {
        o(m);
      }
    }
    function c(p) {
      p.done ? s(p.value) : i(p.value).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, pd = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const hd = 30, md = 5, gd = 5e3, vd = 6e4, _d = 429, bd = 202;
class Ed extends tc {
  constructor(t) {
    var n, r, i, s;
    super(), this.options = t, this.name = "@grafana/faro-web-sdk:transport-fetch", this.version = J, this.disabledUntil = /* @__PURE__ */ new Date(), this.rateLimitBackoffMs = (n = t.defaultRateLimitBackoffMs) !== null && n !== void 0 ? n : gd, this.getNow = (r = t.getNow) !== null && r !== void 0 ? r : () => Date.now(), this.promiseBuffer = Yu({
      size: (i = t.bufferSize) !== null && i !== void 0 ? i : hd,
      concurrency: (s = t.concurrency) !== null && s !== void 0 ? s : md
    });
  }
  send(t) {
    return Ns(this, void 0, void 0, function* () {
      try {
        if (this.disabledUntil > new Date(this.getNow()))
          return this.logWarn(`Dropping transport item due to too many requests. Backoff until ${this.disabledUntil}`), Promise.resolve();
        yield this.promiseBuffer.add(() => {
          const n = JSON.stringify(ic(t)), { url: r, requestOptions: i, apiKey: s } = this.options, o = i != null ? i : {}, { headers: a = {} } = o, u = pd(o, ["headers"]);
          let c;
          const p = this.metas.value.session;
          p != null && (c = p.id);
          const m = {};
          for (const [d, l] of Object.entries(a))
            m[d] = typeof l == "function" ? l() : l;
          return fetch(r, Object.assign({ method: "POST", headers: Object.assign(Object.assign(Object.assign({ "Content-Type": "application/json" }, m), s ? { "x-api-key": s } : {}), c ? { "x-faro-session-id": c } : {}), body: n, keepalive: n.length <= vd }, u != null ? u : {})).then((d) => Ns(this, void 0, void 0, function* () {
            return d.status === bd && d.headers.get("X-Faro-Session-Status") === "invalid" && this.extendFaroSession(this.config, this.logDebug), d.status === _d && (this.disabledUntil = this.getRetryAfterDate(d), this.logWarn(`Too many requests, backing off until ${this.disabledUntil}`)), d.text().catch(ye), d;
          })).catch((d) => {
            this.logError(`Failed sending payload to the receiver
`, JSON.parse(n), d);
          });
        });
      } catch (n) {
        this.logError(n);
      }
    });
  }
  getIgnoreUrls() {
    var t;
    return [this.options.url].concat((t = this.config.ignoreUrls) !== null && t !== void 0 ? t : []);
  }
  isBatched() {
    return !0;
  }
  getRetryAfterDate(t) {
    const n = this.getNow(), r = t.headers.get("Retry-After");
    if (r) {
      const i = Number(r);
      if (!isNaN(i))
        return new Date(i * 1e3 + n);
      const s = Date.parse(r);
      if (!isNaN(s))
        return new Date(s);
    }
    return new Date(n + this.rateLimitBackoffMs);
  }
  extendFaroSession(t, n) {
    const r = "Session expired", i = t.sessionTracking;
    if (i != null && i.enabled) {
      const { fetchUserSession: s, storeUserSession: o } = jo(i);
      di({ fetchUserSession: s, storeUserSession: o })({ forceSessionExtend: !0 }), n(`${r} created new session.`);
    } else
      n(`${r}.`);
  }
}
var Sd = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function yd(e) {
  var t, n, r, i, s;
  const o = [], a = So(e.unpatchedConsole, e.internalLoggerLevel);
  e.transports ? ((e.url || e.apiKey) && a.error('if "transports" is defined, "url" and "apiKey" should not be defined'), o.push(...e.transports)) : e.url ? o.push(new Ed({
    url: e.url,
    apiKey: e.apiKey
  })) : a.error('either "url" or "transports" must be defined');
  const {
    // properties with default values
    dedupe: u = !0,
    eventDomain: c = ld,
    globalObjectKey: p = Nc,
    instrumentations: m = Zo(),
    internalLoggerLevel: d = Eo,
    isolate: l = !1,
    logArgsSerializer: f = gn,
    metas: h = wd(e),
    paused: g = !1,
    preventGlobalExposure: _ = !1,
    unpatchedConsole: T = Vt,
    url: S,
    experimental: b
  } = e, y = Sd(e, ["dedupe", "eventDomain", "globalObjectKey", "instrumentations", "internalLoggerLevel", "isolate", "logArgsSerializer", "metas", "paused", "preventGlobalExposure", "unpatchedConsole", "url", "experimental"]), E = (t = b == null ? void 0 : b.trackNavigation) !== null && t !== void 0 ? t : !1, w = {
    dataAttributeName: (r = (n = e.userActionsInstrumentation) === null || n === void 0 ? void 0 : n.dataAttributeName) !== null && r !== void 0 ? r : Fl,
    excludeItem: (i = e.userActionsInstrumentation) === null || i === void 0 ? void 0 : i.excludeItem
  };
  return Object.assign(Object.assign({}, y), {
    batching: Object.assign(Object.assign({}, xc), e.batching),
    dedupe: u,
    globalObjectKey: p,
    instrumentations: Td(m, e),
    internalLoggerLevel: d,
    isolate: l,
    logArgsSerializer: f,
    metas: h,
    parseStacktrace: pl,
    paused: g,
    preventGlobalExposure: _,
    transports: o,
    unpatchedConsole: T,
    eventDomain: c,
    ignoreUrls: [
      ...(s = e.ignoreUrls) !== null && s !== void 0 ? s : [],
      // ignore configured cloud collector url by default
      ...S ? [S] : [],
      // Try our best to exclude collector URLs form other Faro instances. By default these are URLs ending with /collect or /collect/ followed by alphanumeric characters.
      /\/collect(?:\/[\w]*)?$/
    ],
    sessionTracking: Object.assign(Object.assign(Object.assign({}, Hc), e.sessionTracking), Ad({
      trackGeolocation: e.trackGeolocation,
      sessionTracking: e.sessionTracking
    })),
    userActionsInstrumentation: w,
    experimental: {
      trackNavigation: E
    }
  });
}
function Td(e, { experimental: t }) {
  var n;
  const r = (n = t == null ? void 0 : t.trackNavigation) !== null && n !== void 0 ? n : !1;
  return e.filter((i) => !(i.name === "@grafana/faro-web-sdk:instrumentation-navigation" && !r));
}
function wd(e) {
  var t, n;
  const { page: r, generatePageId: i } = (t = e == null ? void 0 : e.pageTracking) !== null && t !== void 0 ? t : {}, s = [
    Uc,
    fd({ generatePageId: i, initialPageMeta: r }),
    ...(n = e.metas) !== null && n !== void 0 ? n : []
  ];
  return pe(window == null ? void 0 : window.k6) ? [...s, dd] : s;
}
function Ad({ trackGeolocation: e, sessionTracking: t }) {
  var n;
  const r = {};
  return Bu(e) && (r.geoLocationTrackingEnabled = e), je(r) ? {} : {
    session: Object.assign(Object.assign({}, (n = t == null ? void 0 : t.session) !== null && n !== void 0 ? n : {}), { overrides: r })
  };
}
function Od(e) {
  const t = yd(e);
  if (t)
    return Cc(t);
}
const Rd = _o.version;
Pd();
function Pd() {
  const e = Rd.split(".");
  try {
    return e[0] ? parseInt(e[0], 10) : null;
  } catch (t) {
    return null;
  }
}
var kn = {};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Id = _o, ea = 60103;
kn.Fragment = 60107;
if (typeof Symbol == "function" && Symbol.for) {
  var xs = Symbol.for;
  ea = xs("react.element"), kn.Fragment = xs("react.fragment");
}
var Cd = Id.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Nd = Object.prototype.hasOwnProperty, xd = { key: !0, ref: !0, __self: !0, __source: !0 };
function ta(e, t, n) {
  var r, i = {}, s = null, o = null;
  n !== void 0 && (s = "" + n), t.key !== void 0 && (s = "" + t.key), t.ref !== void 0 && (o = t.ref);
  for (r in t)
    Nd.call(t, r) && !xd.hasOwnProperty(r) && (i[r] = t[r]);
  if (e && e.defaultProps)
    for (r in t = e.defaultProps, t)
      i[r] === void 0 && (i[r] = t[r]);
  return { $$typeof: ea, type: e, key: s, ref: o, props: i, _owner: Cd.current };
}
kn.jsx = ta;
kn.jsxs = ta;
var na = { exports: {} }, x = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var z = typeof Symbol == "function" && Symbol.for, vi = z ? Symbol.for("react.element") : 60103, _i = z ? Symbol.for("react.portal") : 60106, Dn = z ? Symbol.for("react.fragment") : 60107, Un = z ? Symbol.for("react.strict_mode") : 60108, jn = z ? Symbol.for("react.profiler") : 60114, Bn = z ? Symbol.for("react.provider") : 60109, $n = z ? Symbol.for("react.context") : 60110, bi = z ? Symbol.for("react.async_mode") : 60111, Fn = z ? Symbol.for("react.concurrent_mode") : 60111, Hn = z ? Symbol.for("react.forward_ref") : 60112, Vn = z ? Symbol.for("react.suspense") : 60113, Md = z ? Symbol.for("react.suspense_list") : 60120, zn = z ? Symbol.for("react.memo") : 60115, Gn = z ? Symbol.for("react.lazy") : 60116, Ld = z ? Symbol.for("react.block") : 60121, kd = z ? Symbol.for("react.fundamental") : 60117, Dd = z ? Symbol.for("react.responder") : 60118, Ud = z ? Symbol.for("react.scope") : 60119;
function Z(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case vi:
        switch (e = e.type, e) {
          case bi:
          case Fn:
          case Dn:
          case jn:
          case Un:
          case Vn:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case $n:
              case Hn:
              case Gn:
              case zn:
              case Bn:
                return e;
              default:
                return t;
            }
        }
      case _i:
        return t;
    }
  }
}
function ra(e) {
  return Z(e) === Fn;
}
x.AsyncMode = bi;
x.ConcurrentMode = Fn;
x.ContextConsumer = $n;
x.ContextProvider = Bn;
x.Element = vi;
x.ForwardRef = Hn;
x.Fragment = Dn;
x.Lazy = Gn;
x.Memo = zn;
x.Portal = _i;
x.Profiler = jn;
x.StrictMode = Un;
x.Suspense = Vn;
x.isAsyncMode = function(e) {
  return ra(e) || Z(e) === bi;
};
x.isConcurrentMode = ra;
x.isContextConsumer = function(e) {
  return Z(e) === $n;
};
x.isContextProvider = function(e) {
  return Z(e) === Bn;
};
x.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === vi;
};
x.isForwardRef = function(e) {
  return Z(e) === Hn;
};
x.isFragment = function(e) {
  return Z(e) === Dn;
};
x.isLazy = function(e) {
  return Z(e) === Gn;
};
x.isMemo = function(e) {
  return Z(e) === zn;
};
x.isPortal = function(e) {
  return Z(e) === _i;
};
x.isProfiler = function(e) {
  return Z(e) === jn;
};
x.isStrictMode = function(e) {
  return Z(e) === Un;
};
x.isSuspense = function(e) {
  return Z(e) === Vn;
};
x.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Dn || e === Fn || e === jn || e === Un || e === Vn || e === Md || typeof e == "object" && e !== null && (e.$$typeof === Gn || e.$$typeof === zn || e.$$typeof === Bn || e.$$typeof === $n || e.$$typeof === Hn || e.$$typeof === kd || e.$$typeof === Dd || e.$$typeof === Ud || e.$$typeof === Ld);
};
x.typeOf = Z;
na.exports = x;
var jd = na.exports, ia = jd, Bd = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, $d = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, sa = {};
sa[ia.ForwardRef] = Bd;
sa[ia.Memo] = $d;
var Ms;
(function(e) {
  e.V4 = "v4", e.V5 = "v5", e.V6 = "v6", e.V6_data_router = "v6_data_router", e.V7 = "v7", e.V7_data_router = "v7_data_router";
})(Ms || (Ms = {}));
var Ls;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(Ls || (Ls = {}));
var Fd = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Fe = "1.9.0", ks = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function Hd(e) {
  var t = /* @__PURE__ */ new Set([e]), n = /* @__PURE__ */ new Set(), r = e.match(ks);
  if (!r)
    return function() {
      return !1;
    };
  var i = {
    major: +r[1],
    minor: +r[2],
    patch: +r[3],
    prerelease: r[4]
  };
  if (i.prerelease != null)
    return function(u) {
      return u === e;
    };
  function s(a) {
    return n.add(a), !1;
  }
  function o(a) {
    return t.add(a), !0;
  }
  return function(u) {
    if (t.has(u))
      return !0;
    if (n.has(u))
      return !1;
    var c = u.match(ks);
    if (!c)
      return s(u);
    var p = {
      major: +c[1],
      minor: +c[2],
      patch: +c[3],
      prerelease: c[4]
    };
    return p.prerelease != null || i.major !== p.major ? s(u) : i.major === 0 ? i.minor === p.minor && i.patch <= p.patch ? o(u) : s(u) : i.minor <= p.minor ? o(u) : s(u);
  };
}
var Vd = Hd(Fe), zd = Fe.split(".")[0], Mt = Symbol.for("opentelemetry.js.api." + zd), Lt = Fd;
function Gt(e, t, n, r) {
  var i;
  r === void 0 && (r = !1);
  var s = Lt[Mt] = (i = Lt[Mt]) !== null && i !== void 0 ? i : {
    version: Fe
  };
  if (!r && s[e]) {
    var o = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return n.error(o.stack || o.message), !1;
  }
  if (s.version !== Fe) {
    var o = new Error("@opentelemetry/api: Registration of version v" + s.version + " for " + e + " does not match previously registered API v" + Fe);
    return n.error(o.stack || o.message), !1;
  }
  return s[e] = t, n.debug("@opentelemetry/api: Registered a global for " + e + " v" + Fe + "."), !0;
}
function Ve(e) {
  var t, n, r = (t = Lt[Mt]) === null || t === void 0 ? void 0 : t.version;
  if (!(!r || !Vd(r)))
    return (n = Lt[Mt]) === null || n === void 0 ? void 0 : n[e];
}
function qt(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + Fe + ".");
  var n = Lt[Mt];
  n && delete n[e];
}
var Gd = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}, qd = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, s; r < i; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Kd = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ot("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ot("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ot("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ot("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return Ot("verbose", this._namespace, t);
    }, e;
  }()
);
function Ot(e, t, n) {
  var r = Ve("diag");
  if (r)
    return n.unshift(t), r[e].apply(r, qd([], Gd(n), !1));
}
var F;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(F || (F = {}));
function Wd(e, t) {
  e < F.NONE ? e = F.NONE : e > F.ALL && (e = F.ALL), t = t || {};
  function n(r, i) {
    var s = t[r];
    return typeof s == "function" && e >= i ? s.bind(t) : function() {
    };
  }
  return {
    error: n("error", F.ERROR),
    warn: n("warn", F.WARN),
    info: n("info", F.INFO),
    debug: n("debug", F.DEBUG),
    verbose: n("verbose", F.VERBOSE)
  };
}
var Yd = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}, Xd = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, s; r < i; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Qd = "diag", ge = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var s = [], o = 0; o < arguments.length; o++)
            s[o] = arguments[o];
          var a = Ve("diag");
          if (a)
            return a[i].apply(a, Xd([], Yd(s), !1));
        };
      }
      var n = this, r = function(i, s) {
        var o, a, u;
        if (s === void 0 && (s = { logLevel: F.INFO }), i === n) {
          var c = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return n.error((o = c.stack) !== null && o !== void 0 ? o : c.message), !1;
        }
        typeof s == "number" && (s = {
          logLevel: s
        });
        var p = Ve("diag"), m = Wd((a = s.logLevel) !== null && a !== void 0 ? a : F.INFO, i);
        if (p && !s.suppressOverrideMessage) {
          var d = (u = new Error().stack) !== null && u !== void 0 ? u : "<failed to generate stacktrace>";
          p.warn("Current logger will be overwritten from " + d), m.warn("Current logger will overwrite one already registered from " + d);
        }
        return Gt("diag", m, n, !0);
      };
      n.setLogger = r, n.disable = function() {
        qt(Qd, n);
      }, n.createComponentLogger = function(i) {
        return new Kd(i);
      }, n.verbose = t("verbose"), n.debug = t("debug"), n.info = t("info"), n.warn = t("warn"), n.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), Jd = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}, Zd = globalThis && globalThis.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ef = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var n = this._entries.get(t);
      if (n)
        return Object.assign({}, n);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var n = Jd(t, 2), r = n[0], i = n[1];
        return [r, i];
      });
    }, e.prototype.setEntry = function(t, n) {
      var r = new e(this._entries);
      return r._entries.set(t, n), r;
    }, e.prototype.removeEntry = function(t) {
      var n = new e(this._entries);
      return n._entries.delete(t), n;
    }, e.prototype.removeEntries = function() {
      for (var t, n, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var s = new e(this._entries);
      try {
        for (var o = Zd(r), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          s._entries.delete(u);
        }
      } catch (c) {
        t = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return s;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), tf = Symbol("BaggageEntryMetadata"), nf = ge.instance();
function rf(e) {
  return e === void 0 && (e = {}), new ef(new Map(Object.entries(e)));
}
function sf(e) {
  return typeof e != "string" && (nf.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: tf,
    toString: function() {
      return e;
    }
  };
}
function qn(e) {
  return Symbol.for(e);
}
var of = (
  /** @class */
  function() {
    function e(t) {
      var n = this;
      n._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), n.getValue = function(r) {
        return n._currentContext.get(r);
      }, n.setValue = function(r, i) {
        var s = new e(n._currentContext);
        return s._currentContext.set(r, i), s;
      }, n.deleteValue = function(r) {
        var i = new e(n._currentContext);
        return i._currentContext.delete(r), i;
      };
    }
    return e;
  }()
), nt = new of(), We = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (r[s] = i[s]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), af = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, n) {
      return vf;
    }, e.prototype.createHistogram = function(t, n) {
      return _f;
    }, e.prototype.createCounter = function(t, n) {
      return gf;
    }, e.prototype.createUpDownCounter = function(t, n) {
      return bf;
    }, e.prototype.createObservableGauge = function(t, n) {
      return Sf;
    }, e.prototype.createObservableCounter = function(t, n) {
      return Ef;
    }, e.prototype.createObservableUpDownCounter = function(t, n) {
      return yf;
    }, e.prototype.addBatchObservableCallback = function(t, n) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), Kn = (
  /** @class */
  function() {
    function e() {
    }
    return e;
  }()
), uf = (
  /** @class */
  function(e) {
    We(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(n, r) {
    }, t;
  }(Kn)
), cf = (
  /** @class */
  function(e) {
    We(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(n, r) {
    }, t;
  }(Kn)
), lf = (
  /** @class */
  function(e) {
    We(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(n, r) {
    }, t;
  }(Kn)
), df = (
  /** @class */
  function(e) {
    We(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(n, r) {
    }, t;
  }(Kn)
), Ei = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), ff = (
  /** @class */
  function(e) {
    We(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Ei)
), pf = (
  /** @class */
  function(e) {
    We(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Ei)
), hf = (
  /** @class */
  function(e) {
    We(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Ei)
), mf = new af(), gf = new uf(), vf = new lf(), _f = new df(), bf = new cf(), Ef = new ff(), Sf = new pf(), yf = new hf(), Tf = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, wf = {
  set: function(e, t, n) {
    e != null && (e[t] = n);
  }
}, Af = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}, Of = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, s; r < i; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Rf = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return nt;
    }, e.prototype.with = function(t, n, r) {
      for (var i = [], s = 3; s < arguments.length; s++)
        i[s - 3] = arguments[s];
      return n.call.apply(n, Of([r], Af(i), !1));
    }, e.prototype.bind = function(t, n) {
      return n;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), Pf = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}, If = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, s; r < i; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}, wr = "context", Cf = new Rf(), Wn = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return Gt(wr, t, ge.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, n, r) {
      for (var i, s = [], o = 3; o < arguments.length; o++)
        s[o - 3] = arguments[o];
      return (i = this._getContextManager()).with.apply(i, If([t, n, r], Pf(s), !1));
    }, e.prototype.bind = function(t, n) {
      return this._getContextManager().bind(t, n);
    }, e.prototype._getContextManager = function() {
      return Ve(wr) || Cf;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), qt(wr, ge.instance());
    }, e;
  }()
), Re;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(Re || (Re = {}));
var oa = "0000000000000000", aa = "00000000000000000000000000000000", ua = {
  traceId: aa,
  spanId: oa,
  traceFlags: Re.NONE
}, Nt = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = ua), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, n) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, n) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, n) {
    }, e;
  }()
), Si = qn("OpenTelemetry Context Key SPAN");
function yi(e) {
  return e.getValue(Si) || void 0;
}
function Nf() {
  return yi(Wn.getInstance().active());
}
function Ti(e, t) {
  return e.setValue(Si, t);
}
function xf(e) {
  return e.deleteValue(Si);
}
function Mf(e, t) {
  return Ti(e, new Nt(t));
}
function ca(e) {
  var t;
  return (t = yi(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Lf = /^([0-9a-f]{32})$/i, kf = /^[0-9a-f]{16}$/i;
function la(e) {
  return Lf.test(e) && e !== aa;
}
function Df(e) {
  return kf.test(e) && e !== oa;
}
function Yn(e) {
  return la(e.traceId) && Df(e.spanId);
}
function Uf(e) {
  return new Nt(e);
}
var Ar = Wn.getInstance(), da = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, n, r) {
      r === void 0 && (r = Ar.active());
      var i = !!(n != null && n.root);
      if (i)
        return new Nt();
      var s = r && ca(r);
      return jf(s) && Yn(s) ? new Nt(s) : new Nt();
    }, e.prototype.startActiveSpan = function(t, n, r, i) {
      var s, o, a;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? a = n : arguments.length === 3 ? (s = n, a = r) : (s = n, o = r, a = i);
        var u = o != null ? o : Ar.active(), c = this.startSpan(t, s, u), p = Ti(u, c);
        return Ar.with(p, a, void 0, c);
      }
    }, e;
  }()
);
function jf(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var Bf = new da(), $f = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      this._provider = t, this.name = n, this.version = r, this.options = i;
    }
    return e.prototype.startSpan = function(t, n, r) {
      return this._getTracer().startSpan(t, n, r);
    }, e.prototype.startActiveSpan = function(t, n, r, i) {
      var s = this._getTracer();
      return Reflect.apply(s.startActiveSpan, s, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Bf;
    }, e;
  }()
), Ff = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, n, r) {
      return new da();
    }, e;
  }()
), Hf = new Ff(), Ds = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, n, r) {
      var i;
      return (i = this.getDelegateTracer(t, n, r)) !== null && i !== void 0 ? i : new $f(this, t, n, r);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Hf;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, n, r) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, n, r);
    }, e;
  }()
), bn;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(bn || (bn = {}));
var kt;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(kt || (kt = {}));
var ze;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(ze || (ze = {}));
var j = Wn.getInstance(), I = ge.instance(), Vf = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, n, r) {
      return mf;
    }, e;
  }()
), zf = new Vf(), Or = "metrics", Gf = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return Gt(Or, t, ge.instance());
    }, e.prototype.getMeterProvider = function() {
      return Ve(Or) || zf;
    }, e.prototype.getMeter = function(t, n, r) {
      return this.getMeterProvider().getMeter(t, n, r);
    }, e.prototype.disable = function() {
      qt(Or, ge.instance());
    }, e;
  }()
), fa = Gf.getInstance(), qf = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, n) {
    }, e.prototype.extract = function(t, n) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), wi = qn("OpenTelemetry Baggage Key");
function pa(e) {
  return e.getValue(wi) || void 0;
}
function Kf() {
  return pa(Wn.getInstance().active());
}
function Wf(e, t) {
  return e.setValue(wi, t);
}
function Yf(e) {
  return e.deleteValue(wi);
}
var Rr = "propagation", Xf = new qf(), Qf = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = rf, this.getBaggage = pa, this.getActiveBaggage = Kf, this.setBaggage = Wf, this.deleteBaggage = Yf;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return Gt(Rr, t, ge.instance());
    }, e.prototype.inject = function(t, n, r) {
      return r === void 0 && (r = wf), this._getGlobalPropagator().inject(t, n, r);
    }, e.prototype.extract = function(t, n, r) {
      return r === void 0 && (r = Tf), this._getGlobalPropagator().extract(t, n, r);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      qt(Rr, ge.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return Ve(Rr) || Xf;
    }, e;
  }()
), ee = Qf.getInstance(), Pr = "trace", Jf = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new Ds(), this.wrapSpanContext = Uf, this.isSpanContextValid = Yn, this.deleteSpan = xf, this.getSpan = yi, this.getActiveSpan = Nf, this.getSpanContext = ca, this.setSpan = Ti, this.setSpanContext = Mf;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var n = Gt(Pr, this._proxyTracerProvider, ge.instance());
      return n && this._proxyTracerProvider.setDelegate(t), n;
    }, e.prototype.getTracerProvider = function() {
      return Ve(Pr) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, n) {
      return this.getTracerProvider().getTracer(t, n);
    }, e.prototype.disable = function() {
      qt(Pr, ge.instance()), this._proxyTracerProvider = new Ds();
    }, e;
  }()
), G = Jf.getInstance();
const Ai = qn("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Oi(e) {
  return e.setValue(Ai, !0);
}
function Zf(e) {
  return e.deleteValue(Ai);
}
function Xn(e) {
  return e.getValue(Ai) === !0;
}
const ep = "=", ha = ";", En = ",", Ir = "baggage", tp = 180, np = 4096, rp = 8192;
function ip(e) {
  return e.reduce((t, n) => {
    const r = `${t}${t !== "" ? En : ""}${n}`;
    return r.length > rp ? t : r;
  }, "");
}
function sp(e) {
  return e.getAllEntries().map(([t, n]) => {
    let r = `${encodeURIComponent(t)}=${encodeURIComponent(n.value)}`;
    return n.metadata !== void 0 && (r += ha + n.metadata.toString()), r;
  });
}
function ma(e) {
  if (!e)
    return;
  const t = e.indexOf(ha), n = t === -1 ? e : e.substring(0, t), r = n.indexOf(ep);
  if (r <= 0)
    return;
  const i = n.substring(0, r).trim(), s = n.substring(r + 1).trim();
  if (!i || !s)
    return;
  let o, a;
  try {
    o = decodeURIComponent(i), a = decodeURIComponent(s);
  } catch (c) {
    return;
  }
  let u;
  if (t !== -1 && t < e.length - 1) {
    const c = e.substring(t + 1);
    u = sf(c);
  }
  return { key: o, value: a, metadata: u };
}
function op(e) {
  const t = {};
  return typeof e == "string" && e.length > 0 && e.split(En).forEach((n) => {
    const r = ma(n);
    r !== void 0 && r.value.length > 0 && (t[r.key] = r.value);
  }), t;
}
class ga {
  inject(t, n, r) {
    const i = ee.getBaggage(t);
    if (!i || Xn(t))
      return;
    const s = sp(i).filter((a) => a.length <= np).slice(0, tp), o = ip(s);
    o.length > 0 && r.set(n, Ir, o);
  }
  extract(t, n, r) {
    const i = r.get(n, Ir), s = Array.isArray(i) ? i.join(En) : i;
    if (!s)
      return t;
    const o = {};
    return s.length === 0 || (s.split(En).forEach((u) => {
      const c = ma(u);
      if (c) {
        const p = { value: c.value };
        c.metadata && (p.metadata = c.metadata), o[c.key] = p;
      }
    }), Object.entries(o).length === 0) ? t : ee.setBaggage(t, ee.createBaggage(o));
  }
  fields() {
    return [Ir];
  }
}
class ap {
  /**
   * Create a new AnchoredClock anchored to the current time returned by systemClock.
   *
   * @param systemClock should be a clock that returns the number of milliseconds since January 1 1970 such as Date
   * @param monotonicClock should be a clock that counts milliseconds monotonically such as window.performance or perf_hooks.performance
   */
  constructor(t, n) {
    v(this, "_monotonicClock");
    v(this, "_epochMillis");
    v(this, "_performanceMillis");
    this._monotonicClock = n, this._epochMillis = t.now(), this._performanceMillis = n.now();
  }
  /**
   * Returns the current time by adding the number of milliseconds since the
   * AnchoredClock was created to the creation epoch time
   */
  now() {
    const t = this._monotonicClock.now() - this._performanceMillis;
    return this._epochMillis + t;
  }
}
function xt(e) {
  const t = {};
  if (typeof e != "object" || e == null)
    return t;
  for (const n in e) {
    if (!Object.prototype.hasOwnProperty.call(e, n))
      continue;
    if (!up(n)) {
      I.warn(`Invalid attribute key: ${n}`);
      continue;
    }
    const r = e[n];
    if (!Ri(r)) {
      I.warn(`Invalid attribute value set for key: ${n}`);
      continue;
    }
    Array.isArray(r) ? t[n] = r.slice() : t[n] = r;
  }
  return t;
}
function up(e) {
  return typeof e == "string" && e !== "";
}
function Ri(e) {
  return e == null ? !0 : Array.isArray(e) ? cp(e) : va(typeof e);
}
function cp(e) {
  let t;
  for (const n of e) {
    if (n == null)
      continue;
    const r = typeof n;
    if (r !== t) {
      if (!t) {
        if (va(r)) {
          t = r;
          continue;
        }
        return !1;
      }
      return !1;
    }
  }
  return !0;
}
function va(e) {
  switch (e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function _a() {
  return (e) => {
    I.error(lp(e));
  };
}
function lp(e) {
  return typeof e == "string" ? e : JSON.stringify(dp(e));
}
function dp(e) {
  const t = {};
  let n = e;
  for (; n !== null; )
    Object.getOwnPropertyNames(n).forEach((r) => {
      if (t[r])
        return;
      const i = n[r];
      i && (t[r] = String(i));
    }), n = Object.getPrototypeOf(n);
  return t;
}
let ba = _a();
function fp(e) {
  ba = e;
}
function Ge(e) {
  try {
    ba(e);
  } catch (t) {
  }
}
function pp(e) {
}
function hp(e) {
}
function mp(e) {
}
function gp(e) {
}
const vp = globalThis, _p = "2.5.0", bp = "deployment.environment", Ep = bp, zr = "error.type", Cr = "exception.message", Sp = "exception.stacktrace", Nr = "exception.type", Ea = "http.request.method", Sa = "http.request.method_original", ya = "http.response.status_code", Ta = "server.address", wa = "server.port", Aa = "service.name", yp = "service.version", Gr = "telemetry.sdk.language", Tp = "webjs", qr = "telemetry.sdk.name", Kr = "telemetry.sdk.version", Oa = "url.full", wp = "user_agent.original", Ap = "process.runtime.name", fn = {
  [qr]: "opentelemetry",
  [Ap]: "browser",
  [Gr]: Tp,
  [Kr]: _p
}, oe = performance, Ra = 9, Op = 6, Rp = Math.pow(10, Op), Sn = Math.pow(10, Ra);
function fe(e) {
  const t = e / 1e3, n = Math.trunc(t), r = Math.round(e % 1e3 * Rp);
  return [n, r];
}
function Pp() {
  return oe.timeOrigin;
}
function qe(e) {
  const t = fe(oe.timeOrigin), n = fe(typeof e == "number" ? e : oe.now());
  return Pi(t, n);
}
function st(e) {
  if (Qn(e))
    return e;
  if (typeof e == "number")
    return e < oe.timeOrigin ? qe(e) : fe(e);
  if (e instanceof Date)
    return fe(e.getTime());
  throw TypeError("Invalid input type");
}
function Pa(e, t) {
  let n = t[0] - e[0], r = t[1] - e[1];
  return r < 0 && (n -= 1, r += Sn), [n, r];
}
function Ip(e) {
  const t = Ra, n = `${"0".repeat(t)}${e[1]}Z`, r = n.substring(n.length - t - 1);
  return new Date(e[0] * 1e3).toISOString().replace("000Z", r);
}
function Te(e) {
  return e[0] * Sn + e[1];
}
function Cp(e) {
  return e[0] * 1e3 + e[1] / 1e6;
}
function Np(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function Qn(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function Wr(e) {
  return Qn(e) || typeof e == "number" || e instanceof Date;
}
function Pi(e, t) {
  const n = [e[0] + t[0], e[1] + t[1]];
  return n[1] >= Sn && (n[1] -= Sn, n[0] += 1), n;
}
function xp(e) {
  typeof e != "number" && e.unref();
}
var Dt;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(Dt || (Dt = {}));
class Ia {
  /**
   * Construct a composite propagator from a list of propagators.
   *
   * @param [config] Configuration object for composite propagator
   */
  constructor(t = {}) {
    v(this, "_propagators");
    v(this, "_fields");
    var n;
    this._propagators = (n = t.propagators) != null ? n : [], this._fields = Array.from(new Set(this._propagators.map((r) => typeof r.fields == "function" ? r.fields() : []).reduce((r, i) => r.concat(i), [])));
  }
  /**
   * Run each of the configured propagators with the given context and carrier.
   * Propagators are run in the order they are configured, so if multiple
   * propagators write the same carrier key, the propagator later in the list
   * will "win".
   *
   * @param context Context to inject
   * @param carrier Carrier into which context will be injected
   */
  inject(t, n, r) {
    for (const i of this._propagators)
      try {
        i.inject(t, n, r);
      } catch (s) {
        I.warn(`Failed to inject with ${i.constructor.name}. Err: ${s.message}`);
      }
  }
  /**
   * Run each of the configured propagators with the given context and carrier.
   * Propagators are run in the order they are configured, so if multiple
   * propagators write the same context key, the propagator later in the list
   * will "win".
   *
   * @param context Context to add values to
   * @param carrier Carrier from which to extract context
   */
  extract(t, n, r) {
    return this._propagators.reduce((i, s) => {
      try {
        return s.extract(i, n, r);
      } catch (o) {
        I.warn(`Failed to extract with ${s.constructor.name}. Err: ${o.message}`);
      }
      return i;
    }, t);
  }
  fields() {
    return this._fields.slice();
  }
}
const Yr = "[_0-9a-z-*/]", Mp = `[a-z]${Yr}{0,255}`, Lp = `[a-z0-9]${Yr}{0,240}@[a-z]${Yr}{0,13}`, kp = new RegExp(`^(?:${Mp}|${Lp})$`), Dp = /^[ -~]{0,255}[!-~]$/, Up = /,|=/;
function jp(e) {
  return kp.test(e);
}
function Bp(e) {
  return Dp.test(e) && !Up.test(e);
}
const Us = 32, $p = 512, js = ",", Bs = "=";
class Jn {
  constructor(t) {
    v(this, "_internalState", /* @__PURE__ */ new Map());
    t && this._parse(t);
  }
  set(t, n) {
    const r = this._clone();
    return r._internalState.has(t) && r._internalState.delete(t), r._internalState.set(t, n), r;
  }
  unset(t) {
    const n = this._clone();
    return n._internalState.delete(t), n;
  }
  get(t) {
    return this._internalState.get(t);
  }
  serialize() {
    return this._keys().reduce((t, n) => (t.push(n + Bs + this.get(n)), t), []).join(js);
  }
  _parse(t) {
    t.length > $p || (this._internalState = t.split(js).reverse().reduce((n, r) => {
      const i = r.trim(), s = i.indexOf(Bs);
      if (s !== -1) {
        const o = i.slice(0, s), a = i.slice(s + 1, r.length);
        jp(o) && Bp(a) && n.set(o, a);
      }
      return n;
    }, /* @__PURE__ */ new Map()), this._internalState.size > Us && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Us))));
  }
  _keys() {
    return Array.from(this._internalState.keys()).reverse();
  }
  _clone() {
    const t = new Jn();
    return t._internalState = new Map(this._internalState), t;
  }
}
const pn = "traceparent", hn = "tracestate", Fp = "00", Hp = "(?!ff)[\\da-f]{2}", Vp = "(?![0]{32})[\\da-f]{32}", zp = "(?![0]{16})[\\da-f]{16}", Gp = "[\\da-f]{2}", qp = new RegExp(`^\\s?(${Hp})-(${Vp})-(${zp})-(${Gp})(-.*)?\\s?$`);
function Ca(e) {
  const t = qp.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
class Ii {
  inject(t, n, r) {
    const i = G.getSpanContext(t);
    if (!i || Xn(t) || !Yn(i))
      return;
    const s = `${Fp}-${i.traceId}-${i.spanId}-0${Number(i.traceFlags || Re.NONE).toString(16)}`;
    r.set(n, pn, s), i.traceState && r.set(n, hn, i.traceState.serialize());
  }
  extract(t, n, r) {
    const i = r.get(n, pn);
    if (!i)
      return t;
    const s = Array.isArray(i) ? i[0] : i;
    if (typeof s != "string")
      return t;
    const o = Ca(s);
    if (!o)
      return t;
    o.isRemote = !0;
    const a = r.get(n, hn);
    if (a) {
      const u = Array.isArray(a) ? a.join(",") : a;
      o.traceState = new Jn(typeof u == "string" ? u : void 0);
    }
    return G.setSpanContext(t, o);
  }
  fields() {
    return [pn, hn];
  }
}
const Ci = qn("OpenTelemetry SDK Context Key RPC_METADATA");
var Xr;
(function(e) {
  e.HTTP = "http";
})(Xr || (Xr = {}));
function Kp(e, t) {
  return e.setValue(Ci, t);
}
function Wp(e) {
  return e.deleteValue(Ci);
}
function Yp(e) {
  return e.getValue(Ci);
}
const Xp = "[object Object]", Qp = "[object Null]", Jp = "[object Undefined]", Zp = Function.prototype, Na = Zp.toString, eh = Na.call(Object), th = Object.getPrototypeOf, xa = Object.prototype, Ma = xa.hasOwnProperty, Be = Symbol ? Symbol.toStringTag : void 0, La = xa.toString;
function $s(e) {
  if (!nh(e) || rh(e) !== Xp)
    return !1;
  const t = th(e);
  if (t === null)
    return !0;
  const n = Ma.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Na.call(n) === eh;
}
function nh(e) {
  return e != null && typeof e == "object";
}
function rh(e) {
  return e == null ? e === void 0 ? Jp : Qp : Be && Be in Object(e) ? ih(e) : sh(e);
}
function ih(e) {
  const t = Ma.call(e, Be), n = e[Be];
  let r = !1;
  try {
    e[Be] = void 0, r = !0;
  } catch (s) {
  }
  const i = La.call(e);
  return r && (t ? e[Be] = n : delete e[Be]), i;
}
function sh(e) {
  return La.call(e);
}
const oh = 20;
function ka(...e) {
  let t = e.shift();
  const n = /* @__PURE__ */ new WeakMap();
  for (; e.length > 0; )
    t = Da(t, e.shift(), 0, n);
  return t;
}
function xr(e) {
  return yn(e) ? e.slice() : e;
}
function Da(e, t, n = 0, r) {
  let i;
  if (!(n > oh)) {
    if (n++, mn(e) || mn(t) || Ua(t))
      i = xr(t);
    else if (yn(e)) {
      if (i = e.slice(), yn(t))
        for (let s = 0, o = t.length; s < o; s++)
          i.push(xr(t[s]));
      else if (Rt(t)) {
        const s = Object.keys(t);
        for (let o = 0, a = s.length; o < a; o++) {
          const u = s[o];
          i[u] = xr(t[u]);
        }
      }
    } else if (Rt(e))
      if (Rt(t)) {
        if (!ah(e, t))
          return t;
        i = Object.assign({}, e);
        const s = Object.keys(t);
        for (let o = 0, a = s.length; o < a; o++) {
          const u = s[o], c = t[u];
          if (mn(c))
            typeof c == "undefined" ? delete i[u] : i[u] = c;
          else {
            const p = i[u], m = c;
            if (Fs(e, u, r) || Fs(t, u, r))
              delete i[u];
            else {
              if (Rt(p) && Rt(m)) {
                const d = r.get(p) || [], l = r.get(m) || [];
                d.push({ obj: e, key: u }), l.push({ obj: t, key: u }), r.set(p, d), r.set(m, l);
              }
              i[u] = Da(i[u], c, n, r);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Fs(e, t, n) {
  const r = n.get(e[t]) || [];
  for (let i = 0, s = r.length; i < s; i++) {
    const o = r[i];
    if (o.key === t && o.obj === e)
      return !0;
  }
  return !1;
}
function yn(e) {
  return Array.isArray(e);
}
function Ua(e) {
  return typeof e == "function";
}
function Rt(e) {
  return !mn(e) && !yn(e) && !Ua(e) && typeof e == "object";
}
function mn(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function ah(e, t) {
  return !(!$s(e) || !$s(t));
}
class Zn extends Error {
  constructor(t) {
    super(t), Object.setPrototypeOf(this, Zn.prototype);
  }
}
function uh(e, t) {
  let n;
  const r = new Promise(function(s, o) {
    n = setTimeout(function() {
      o(new Zn("Operation timed out."));
    }, t);
  });
  return Promise.race([e, r]).then((i) => (clearTimeout(n), i), (i) => {
    throw clearTimeout(n), i;
  });
}
function Ni(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function xi(e, t) {
  if (!t)
    return !1;
  for (const n of t)
    if (Ni(e, n))
      return !0;
  return !1;
}
class ch {
  constructor() {
    v(this, "_promise");
    v(this, "_resolve");
    v(this, "_reject");
    this._promise = new Promise((t, n) => {
      this._resolve = t, this._reject = n;
    });
  }
  get promise() {
    return this._promise;
  }
  resolve(t) {
    this._resolve(t);
  }
  reject(t) {
    this._reject(t);
  }
}
class ja {
  constructor(t, n) {
    v(this, "_isCalled", !1);
    v(this, "_deferred", new ch());
    v(this, "_callback");
    v(this, "_that");
    this._callback = t, this._that = n;
  }
  get isCalled() {
    return this._isCalled;
  }
  get promise() {
    return this._deferred.promise;
  }
  call(...t) {
    if (!this._isCalled) {
      this._isCalled = !0;
      try {
        Promise.resolve(this._callback.call(this._that, ...t)).then((n) => this._deferred.resolve(n), (n) => this._deferred.reject(n));
      } catch (n) {
        this._deferred.reject(n);
      }
    }
    return this._deferred.promise;
  }
}
const Hs = {
  ALL: F.ALL,
  VERBOSE: F.VERBOSE,
  DEBUG: F.DEBUG,
  INFO: F.INFO,
  WARN: F.WARN,
  ERROR: F.ERROR,
  NONE: F.NONE
};
function lh(e) {
  if (e == null)
    return;
  const t = Hs[e.toUpperCase()];
  return t == null ? (I.warn(`Unknown log level "${e}", expected one of ${Object.keys(Hs)}, using default`), F.INFO) : t;
}
function dh(e, t) {
  return new Promise((n) => {
    j.with(Oi(j.active()), () => {
      e.export(t, (r) => {
        n(r);
      });
    });
  });
}
const fh = {
  _export: dh
}, ph = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnchoredClock: ap,
  BindOnceFuture: ja,
  CompositePropagator: Ia,
  get ExportResultCode() {
    return Dt;
  },
  get RPCType() {
    return Xr;
  },
  SDK_INFO: fn,
  TRACE_PARENT_HEADER: pn,
  TRACE_STATE_HEADER: hn,
  TimeoutError: Zn,
  TraceState: Jn,
  W3CBaggagePropagator: ga,
  W3CTraceContextPropagator: Ii,
  _globalThis: vp,
  addHrTimes: Pi,
  callWithTimeout: uh,
  deleteRPCMetadata: Wp,
  diagLogLevelFromString: lh,
  getBooleanFromEnv: hp,
  getNumberFromEnv: mp,
  getRPCMetadata: Yp,
  getStringFromEnv: pp,
  getStringListFromEnv: gp,
  getTimeOrigin: Pp,
  globalErrorHandler: Ge,
  hrTime: qe,
  hrTimeDuration: Pa,
  hrTimeToMicroseconds: Np,
  hrTimeToMilliseconds: Cp,
  hrTimeToNanoseconds: Te,
  hrTimeToTimeStamp: Ip,
  internal: fh,
  isAttributeValue: Ri,
  isTimeInput: Wr,
  isTimeInputHrTime: Qn,
  isTracingSuppressed: Xn,
  isUrlIgnored: xi,
  loggingErrorHandler: _a,
  merge: ka,
  millisToHrTime: fe,
  otperformance: oe,
  parseKeyPairsIntoRecord: op,
  parseTraceParent: Ca,
  sanitizeAttributes: xt,
  setGlobalErrorHandler: fp,
  setRPCMetadata: Kp,
  suppressTracing: Oi,
  timeInputToHrTime: st,
  unrefTimer: xp,
  unsuppressTracing: Zf,
  urlMatches: Ni
}, Symbol.toStringTag, { value: "Module" }));
var we = {}, te = {};
Object.defineProperty(te, "__esModule", { value: !0 });
te.toAnyValue = te.toKeyValue = te.toAttributes = te.createInstrumentationScope = te.createResource = void 0;
function hh(e) {
  const t = {
    attributes: Ba(e.attributes),
    droppedAttributesCount: 0
  }, n = e.schemaUrl;
  return n && n !== "" && (t.schemaUrl = n), t;
}
te.createResource = hh;
function mh(e) {
  return {
    name: e.name,
    version: e.version
  };
}
te.createInstrumentationScope = mh;
function Ba(e) {
  return Object.keys(e).map((t) => Mi(t, e[t]));
}
te.toAttributes = Ba;
function Mi(e, t) {
  return {
    key: e,
    value: Li(t)
  };
}
te.toKeyValue = Mi;
function Li(e) {
  const t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(Li) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(([n, r]) => Mi(n, r))
    }
  } : {};
}
te.toAnyValue = Li;
var ne = {};
const gh = /* @__PURE__ */ Eu(ph);
var er = {};
Object.defineProperty(er, "__esModule", { value: !0 });
er.hexToBinary = void 0;
function Vs(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function vh(e) {
  const t = new Uint8Array(e.length / 2);
  let n = 0;
  for (let r = 0; r < e.length; r += 2) {
    const i = Vs(e.charCodeAt(r)), s = Vs(e.charCodeAt(r + 1));
    t[n++] = i << 4 | s;
  }
  return t;
}
er.hexToBinary = vh;
Object.defineProperty(ne, "__esModule", { value: !0 });
ne.getOtlpEncoder = ne.encodeAsString = ne.encodeAsLongBits = ne.toLongBits = ne.hrTimeToNanos = void 0;
const _h = gh, ki = er;
function Di(e) {
  const t = BigInt(1e9);
  return BigInt(Math.trunc(e[0])) * t + BigInt(Math.trunc(e[1]));
}
ne.hrTimeToNanos = Di;
function $a(e) {
  const t = Number(BigInt.asUintN(32, e)), n = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: n };
}
ne.toLongBits = $a;
function Ui(e) {
  const t = Di(e);
  return $a(t);
}
ne.encodeAsLongBits = Ui;
function Fa(e) {
  return Di(e).toString();
}
ne.encodeAsString = Fa;
const bh = typeof BigInt != "undefined" ? Fa : _h.hrTimeToNanoseconds;
function zs(e) {
  return e;
}
function Ha(e) {
  if (e !== void 0)
    return (0, ki.hexToBinary)(e);
}
const Eh = {
  encodeHrTime: Ui,
  encodeSpanContext: ki.hexToBinary,
  encodeOptionalSpanContext: Ha
};
function Sh(e) {
  var r, i;
  if (e === void 0)
    return Eh;
  const t = (r = e.useLongBits) != null ? r : !0, n = (i = e.useHex) != null ? i : !1;
  return {
    encodeHrTime: t ? Ui : bh,
    encodeSpanContext: n ? zs : ki.hexToBinary,
    encodeOptionalSpanContext: n ? zs : Ha
  };
}
ne.getOtlpEncoder = Sh;
Object.defineProperty(we, "__esModule", { value: !0 });
var Va = we.createExportTraceServiceRequest = we.toOtlpSpanEvent = we.toOtlpLink = we.sdkSpanToOtlpSpan = void 0;
const Ut = te, yh = ne, Th = 256, wh = 512;
function za(e, t) {
  let n = e & 255 | Th;
  return t && (n |= wh), n;
}
function Ga(e, t) {
  var s, o, a, u;
  const n = e.spanContext(), r = e.status, i = (s = e.parentSpanContext) != null && s.spanId ? t.encodeSpanContext((o = e.parentSpanContext) == null ? void 0 : o.spanId) : void 0;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: i,
    traceState: (a = n.traceState) == null ? void 0 : a.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: (0, Ut.toAttributes)(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map((c) => Ka(c, t)),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: r.code,
      message: r.message
    },
    links: e.links.map((c) => qa(c, t)),
    droppedLinksCount: e.droppedLinksCount,
    flags: za(n.traceFlags, (u = e.parentSpanContext) == null ? void 0 : u.isRemote)
  };
}
we.sdkSpanToOtlpSpan = Ga;
function qa(e, t) {
  var n;
  return {
    attributes: e.attributes ? (0, Ut.toAttributes)(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (n = e.context.traceState) == null ? void 0 : n.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0,
    flags: za(e.context.traceFlags, e.context.isRemote)
  };
}
we.toOtlpLink = qa;
function Ka(e, t) {
  return {
    attributes: e.attributes ? (0, Ut.toAttributes)(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
we.toOtlpSpanEvent = Ka;
function Ah(e, t) {
  const n = (0, yh.getOtlpEncoder)(t);
  return {
    resourceSpans: Rh(e, n)
  };
}
Va = we.createExportTraceServiceRequest = Ah;
function Oh(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e) {
    let r = t.get(n.resource);
    r || (r = /* @__PURE__ */ new Map(), t.set(n.resource, r));
    const i = `${n.instrumentationScope.name}@${n.instrumentationScope.version || ""}:${n.instrumentationScope.schemaUrl || ""}`;
    let s = r.get(i);
    s || (s = [], r.set(i, s)), s.push(n);
  }
  return t;
}
function Rh(e, t) {
  const n = Oh(e), r = [], i = n.entries();
  let s = i.next();
  for (; !s.done; ) {
    const [o, a] = s.value, u = [], c = a.values();
    let p = c.next();
    for (; !p.done; ) {
      const l = p.value;
      if (l.length > 0) {
        const f = l.map((h) => Ga(h, t));
        u.push({
          scope: (0, Ut.createInstrumentationScope)(l[0].instrumentationScope),
          spans: f,
          schemaUrl: l[0].instrumentationScope.schemaUrl
        });
      }
      p = c.next();
    }
    const m = (0, Ut.createResource)(o), d = {
      resource: m,
      scopeSpans: u,
      schemaUrl: m.schemaUrl
    };
    r.push(d), s = i.next();
  }
  return r;
}
var Wa = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EStatusCode = e.ESpanKind = void 0, function(t) {
    t[t.SPAN_KIND_UNSPECIFIED = 0] = "SPAN_KIND_UNSPECIFIED", t[t.SPAN_KIND_INTERNAL = 1] = "SPAN_KIND_INTERNAL", t[t.SPAN_KIND_SERVER = 2] = "SPAN_KIND_SERVER", t[t.SPAN_KIND_CLIENT = 3] = "SPAN_KIND_CLIENT", t[t.SPAN_KIND_PRODUCER = 4] = "SPAN_KIND_PRODUCER", t[t.SPAN_KIND_CONSUMER = 5] = "SPAN_KIND_CONSUMER";
  }(e.ESpanKind || (e.ESpanKind = {})), function(t) {
    t[t.STATUS_CODE_UNSET = 0] = "STATUS_CODE_UNSET", t[t.STATUS_CODE_OK = 1] = "STATUS_CODE_OK", t[t.STATUS_CODE_ERROR = 2] = "STATUS_CODE_ERROR";
  }(e.EStatusCode || (e.EStatusCode = {}));
})(Wa);
const Ph = "duration_ns";
function Ih(e = []) {
  var t, n;
  for (const r of e) {
    const { scopeSpans: i } = r;
    for (const s of i) {
      const { scope: o, spans: a = [] } = s;
      for (const u of a) {
        if (u.kind !== Wa.ESpanKind.SPAN_KIND_CLIENT)
          continue;
        const c = {
          traceId: u.traceId.toString(),
          spanId: u.spanId.toString()
        }, p = {};
        for (const l of u.attributes)
          p[l.key] = String(Object.values(l.value)[0]);
        !Number.isNaN(u.endTimeUnixNano) && !Number.isNaN(u.startTimeUnixNano) && (p[Ph] = String(Number(u.endTimeUnixNano) - Number(u.startTimeUnixNano)));
        const m = ((t = o == null ? void 0 : o.name) !== null && t !== void 0 ? t : "").indexOf("-");
        let d = X;
        o != null && o.name && (m === -1 && (d = (n = o.name.split("/")[1]) !== null && n !== void 0 ? n : o.name), m > -1 && (d = o == null ? void 0 : o.name.substring(m + 1))), k.api.pushEvent(`faro.tracing.${d}`, p, void 0, {
          spanContext: c,
          // Convert nanoseconds to milliseconds
          timestampOverwriteMs: Number(u.endTimeUnixNano) / 1e6,
          customPayloadTransformer: (l) => {
            var f, h;
            return p["faro.action.user.name"] != null && p["faro.action.user.parentId"] != null && (l.action = {
              name: p["faro.action.user.name"],
              parentId: p["faro.action.user.parentId"]
            }, (f = l.attributes) === null || f === void 0 || delete f["faro.action.user.name"], (h = l.attributes) === null || h === void 0 || delete h["faro.action.user.parentId"]), l;
          }
        });
      }
    }
  }
}
class Ch {
  constructor(t) {
    this.config = t;
  }
  export(t, n) {
    const r = Va(t, { useHex: !0, useLongBits: !1 });
    this.config.api.pushTraces(r), Ih(r.resourceSpans), n({ code: Dt.SUCCESS });
  }
  shutdown() {
    return Promise.resolve(void 0);
  }
}
class Ya {
  emit(t) {
  }
}
const Nh = new Ya(), an = Symbol.for("io.opentelemetry.js.api.logs"), Pt = globalThis;
function xh(e, t, n) {
  return (r) => r === e ? t : n;
}
const Gs = 1;
class Mh {
  getLogger(t, n, r) {
    return new Ya();
  }
}
const Xa = new Mh();
class Lh {
  constructor(t, n, r, i) {
    this._provider = t, this.name = n, this.version = r, this.options = i;
  }
  /**
   * Emit a log record. This method should only be used by log appenders.
   *
   * @param logRecord
   */
  emit(t) {
    this._getLogger().emit(t);
  }
  /**
   * Try to get a logger from the proxy logger provider.
   * If the proxy logger provider has no delegate, return a noop logger.
   */
  _getLogger() {
    if (this._delegate)
      return this._delegate;
    const t = this._provider._getDelegateLogger(this.name, this.version, this.options);
    return t ? (this._delegate = t, this._delegate) : Nh;
  }
}
class qs {
  getLogger(t, n, r) {
    var i;
    return (i = this._getDelegateLogger(t, n, r)) !== null && i !== void 0 ? i : new Lh(this, t, n, r);
  }
  /**
   * Get the delegate logger provider.
   * Used by tests only.
   * @internal
   */
  _getDelegate() {
    var t;
    return (t = this._delegate) !== null && t !== void 0 ? t : Xa;
  }
  /**
   * Set the delegate logger provider
   * @internal
   */
  _setDelegate(t) {
    this._delegate = t;
  }
  /**
   * @internal
   */
  _getDelegateLogger(t, n, r) {
    var i;
    return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, n, r);
  }
}
class ji {
  constructor() {
    this._proxyLoggerProvider = new qs();
  }
  static getInstance() {
    return this._instance || (this._instance = new ji()), this._instance;
  }
  setGlobalLoggerProvider(t) {
    return Pt[an] ? this.getLoggerProvider() : (Pt[an] = xh(Gs, t, Xa), this._proxyLoggerProvider._setDelegate(t), t);
  }
  /**
   * Returns the global logger provider.
   *
   * @returns LoggerProvider
   */
  getLoggerProvider() {
    var t, n;
    return (n = (t = Pt[an]) === null || t === void 0 ? void 0 : t.call(Pt, Gs)) !== null && n !== void 0 ? n : this._proxyLoggerProvider;
  }
  /**
   * Returns a logger from the global logger provider.
   *
   * @returns Logger
   */
  getLogger(t, n, r) {
    return this.getLoggerProvider().getLogger(t, n, r);
  }
  /** Remove the global logger provider */
  disable() {
    delete Pt[an], this._proxyLoggerProvider = new qs();
  }
}
const Qa = ji.getInstance();
function kh(e, t, n, r) {
  for (let i = 0, s = e.length; i < s; i++) {
    const o = e[i];
    t && o.setTracerProvider(t), n && o.setMeterProvider(n), r && o.setLoggerProvider && o.setLoggerProvider(r), o.getConfig().enabled || o.enable();
  }
}
function Dh(e) {
  e.forEach((t) => t.disable());
}
function Uh(e) {
  var s, o;
  const t = e.tracerProvider || G.getTracerProvider(), n = e.meterProvider || fa.getMeterProvider(), r = e.loggerProvider || Qa.getLoggerProvider(), i = (o = (s = e.instrumentations) == null ? void 0 : s.flat()) != null ? o : [];
  return kh(i, t, n, r), () => {
    Dh(i);
  };
}
let Q = console.error.bind(console);
function It(e, t, n) {
  const r = !!e[t] && Object.prototype.propertyIsEnumerable.call(e, t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: r,
    writable: !0,
    value: n
  });
}
const Ja = (e, t, n) => {
  if (!e || !e[t]) {
    Q("no original function " + String(t) + " to wrap");
    return;
  }
  if (!n) {
    Q("no wrapper function"), Q(new Error().stack);
    return;
  }
  const r = e[t];
  if (typeof r != "function" || typeof n != "function") {
    Q("original object and wrapper must be functions");
    return;
  }
  const i = n(r, t);
  return It(i, "__original", r), It(i, "__unwrap", () => {
    e[t] === i && It(e, t, r);
  }), It(i, "__wrapped", !0), It(e, t, i), i;
}, jh = (e, t, n) => {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    Q("must provide one or more modules to patch"), Q(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    Q("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach((r) => {
    t.forEach((i) => {
      Ja(r, i, n);
    });
  });
}, Za = (e, t) => {
  if (!e || !e[t]) {
    Q("no function to unwrap."), Q(new Error().stack);
    return;
  }
  const n = e[t];
  if (!n.__unwrap)
    Q("no original to unwrap to -- has " + String(t) + " already been unwrapped?");
  else {
    n.__unwrap();
    return;
  }
}, Bh = (e, t) => {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    Q("must provide one or more modules to patch"), Q(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    Q("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach((n) => {
    t.forEach((r) => {
      Za(n, r);
    });
  });
};
class $h {
  constructor(t, n, r) {
    v(this, "_config", {});
    v(this, "_tracer");
    v(this, "_meter");
    v(this, "_logger");
    v(this, "_diag");
    v(this, "instrumentationName");
    v(this, "instrumentationVersion");
    /* Api to wrap instrumented method */
    v(this, "_wrap", Ja);
    /* Api to unwrap instrumented methods */
    v(this, "_unwrap", Za);
    /* Api to mass wrap instrumented method */
    v(this, "_massWrap", jh);
    /* Api to mass unwrap instrumented methods */
    v(this, "_massUnwrap", Bh);
    this.instrumentationName = t, this.instrumentationVersion = n, this.setConfig(r), this._diag = I.createComponentLogger({
      namespace: t
    }), this._tracer = G.getTracer(t, n), this._meter = fa.getMeter(t, n), this._logger = Qa.getLogger(t, n), this._updateMetricInstruments();
  }
  /* Returns meter */
  get meter() {
    return this._meter;
  }
  /**
   * Sets MeterProvider to this plugin
   * @param meterProvider
   */
  setMeterProvider(t) {
    this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
  }
  /* Returns logger */
  get logger() {
    return this._logger;
  }
  /**
   * Sets LoggerProvider to this plugin
   * @param loggerProvider
   */
  setLoggerProvider(t) {
    this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
  }
  /**
   * @experimental
   *
   * Get module definitions defined by {@link init}.
   * This can be used for experimental compile-time instrumentation.
   *
   * @returns an array of {@link InstrumentationModuleDefinition}
   */
  getModuleDefinitions() {
    var n;
    const t = (n = this.init()) != null ? n : [];
    return Array.isArray(t) ? t : [t];
  }
  /**
   * Sets the new metric instruments with the current Meter.
   */
  _updateMetricInstruments() {
  }
  /* Returns InstrumentationConfig */
  getConfig() {
    return this._config;
  }
  /**
   * Sets InstrumentationConfig to this plugin
   * @param config
   */
  setConfig(t) {
    this._config = At({
      enabled: !0
    }, t);
  }
  /**
   * Sets TraceProvider to this plugin
   * @param tracerProvider
   */
  setTracerProvider(t) {
    this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
  }
  /* Returns tracer */
  get tracer() {
    return this._tracer;
  }
  /**
   * Execute span customization hook, if configured, and log any errors.
   * Any semantics of the trigger and info are defined by the specific instrumentation.
   * @param hookHandler The optional hook handler which the user has configured via instrumentation config
   * @param triggerName The name of the trigger for executing the hook for logging purposes
   * @param span The span to which the hook should be applied
   * @param info The info object to be passed to the hook, with useful data the hook may use
   */
  _runSpanCustomizationHook(t, n, r, i) {
    if (t)
      try {
        t(r, i);
      } catch (s) {
        this._diag.error("Error running span customization hook due to exception in handler", { triggerName: n }, s);
      }
  }
}
class eu extends $h {
  constructor(t, n, r) {
    super(t, n, r), this._config.enabled && this.enable();
  }
}
function Qr(e, t, n) {
  let r, i;
  try {
    i = e();
  } catch (s) {
    r = s;
  } finally {
    if (t(r, i), r && !n)
      throw r;
    return i;
  }
}
function Jr(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var B;
(function(e) {
  e[e.STABLE = 1] = "STABLE", e[e.OLD = 2] = "OLD", e[e.DUPLICATE = 3] = "DUPLICATE";
})(B || (B = {}));
function tu(e, t) {
  let n = B.OLD;
  const r = t == null ? void 0 : t.split(",").map((i) => i.trim()).filter((i) => i !== "");
  for (const i of r != null ? r : [])
    if (i.toLowerCase() === e + "/dup") {
      n = B.DUPLICATE;
      break;
    } else
      i.toLowerCase() === e && (n = B.STABLE);
  return n;
}
let un;
function Fh() {
  if (un === void 0)
    try {
      const e = globalThis.process.argv0;
      un = e ? `unknown_service:${e}` : "unknown_service";
    } catch (e) {
      un = "unknown_service";
    }
  return un;
}
const Ct = (e) => e !== null && typeof e == "object" && typeof e.then == "function";
class Tn {
  constructor(t, n) {
    v(this, "_rawAttributes");
    v(this, "_asyncAttributesPending", !1);
    v(this, "_schemaUrl");
    v(this, "_memoizedAttributes");
    var i;
    const r = (i = t.attributes) != null ? i : {};
    this._rawAttributes = Object.entries(r).map(([s, o]) => (Ct(o) && (this._asyncAttributesPending = !0), [s, o])), this._rawAttributes = Ks(this._rawAttributes), this._schemaUrl = Hh(n == null ? void 0 : n.schemaUrl);
  }
  static FromAttributeList(t, n) {
    const r = new Tn({}, n);
    return r._rawAttributes = Ks(t), r._asyncAttributesPending = t.filter(([i, s]) => Ct(s)).length > 0, r;
  }
  get asyncAttributesPending() {
    return this._asyncAttributesPending;
  }
  waitForAsyncAttributes() {
    return Yt(this, null, function* () {
      if (this.asyncAttributesPending) {
        for (let t = 0; t < this._rawAttributes.length; t++) {
          const [n, r] = this._rawAttributes[t];
          this._rawAttributes[t] = [n, Ct(r) ? yield r : r];
        }
        this._asyncAttributesPending = !1;
      }
    });
  }
  get attributes() {
    var n;
    if (this.asyncAttributesPending && I.error("Accessing resource attributes before async attributes settled"), this._memoizedAttributes)
      return this._memoizedAttributes;
    const t = {};
    for (const [r, i] of this._rawAttributes) {
      if (Ct(i)) {
        I.debug(`Unsettled resource attribute ${r} skipped`);
        continue;
      }
      i != null && ((n = t[r]) != null || (t[r] = i));
    }
    return this._asyncAttributesPending || (this._memoizedAttributes = t), t;
  }
  getRawAttributes() {
    return this._rawAttributes;
  }
  get schemaUrl() {
    return this._schemaUrl;
  }
  merge(t) {
    if (t == null)
      return this;
    const n = Vh(this, t), r = n ? { schemaUrl: n } : void 0;
    return Tn.FromAttributeList([...t.getRawAttributes(), ...this.getRawAttributes()], r);
  }
}
function nu(e, t) {
  return Tn.FromAttributeList(Object.entries(e), t);
}
function ru() {
  return nu({
    [Aa]: Fh(),
    [Gr]: fn[Gr],
    [qr]: fn[qr],
    [Kr]: fn[Kr]
  });
}
function Ks(e) {
  return e.map(([t, n]) => Ct(n) ? [
    t,
    n.catch((r) => {
      I.debug("promise rejection for resource attribute: %s - %s", t, r);
    })
  ] : [t, n]);
}
function Hh(e) {
  if (typeof e == "string" || e === void 0)
    return e;
  I.warn("Schema URL must be string or undefined, got %s. Schema URL will be ignored.", e);
}
function Vh(e, t) {
  const n = e == null ? void 0 : e.schemaUrl, r = t == null ? void 0 : t.schemaUrl, i = n === void 0 || n === "", s = r === void 0 || r === "";
  if (i)
    return r;
  if (s || n === r)
    return n;
  I.warn('Schema URL merge conflict: old resource has "%s", updating resource has "%s". Resulting resource will have undefined Schema URL.', n, r);
}
const zh = "exception";
class Gh {
  /**
   * Constructs a new SpanImpl instance.
   */
  constructor(t) {
    // Below properties are included to implement ReadableSpan for export
    // purposes but are not intended to be written-to directly.
    v(this, "_spanContext");
    v(this, "kind");
    v(this, "parentSpanContext");
    v(this, "attributes", {});
    v(this, "links", []);
    v(this, "events", []);
    v(this, "startTime");
    v(this, "resource");
    v(this, "instrumentationScope");
    v(this, "_droppedAttributesCount", 0);
    v(this, "_droppedEventsCount", 0);
    v(this, "_droppedLinksCount", 0);
    v(this, "name");
    v(this, "status", {
      code: ze.UNSET
    });
    v(this, "endTime", [0, 0]);
    v(this, "_ended", !1);
    v(this, "_duration", [-1, -1]);
    v(this, "_spanProcessor");
    v(this, "_spanLimits");
    v(this, "_attributeValueLengthLimit");
    v(this, "_performanceStartTime");
    v(this, "_performanceOffset");
    v(this, "_startTimeProvided");
    var r;
    const n = Date.now();
    this._spanContext = t.spanContext, this._performanceStartTime = oe.now(), this._performanceOffset = n - (this._performanceStartTime + oe.timeOrigin), this._startTimeProvided = t.startTime != null, this._spanLimits = t.spanLimits, this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, this._spanProcessor = t.spanProcessor, this.name = t.name, this.parentSpanContext = t.parentSpanContext, this.kind = t.kind, this.links = t.links || [], this.startTime = this._getTime((r = t.startTime) != null ? r : n), this.resource = t.resource, this.instrumentationScope = t.scope, t.attributes != null && this.setAttributes(t.attributes), this._spanProcessor.onStart(this, t.context);
  }
  spanContext() {
    return this._spanContext;
  }
  setAttribute(t, n) {
    if (n == null || this._isSpanEnded())
      return this;
    if (t.length === 0)
      return I.warn(`Invalid attribute key: ${t}`), this;
    if (!Ri(n))
      return I.warn(`Invalid attribute value set for key: ${t}`), this;
    const { attributeCountLimit: r } = this._spanLimits;
    return r !== void 0 && Object.keys(this.attributes).length >= r && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(n), this);
  }
  setAttributes(t) {
    for (const [n, r] of Object.entries(t))
      this.setAttribute(n, r);
    return this;
  }
  /**
   *
   * @param name Span Name
   * @param [attributesOrStartTime] Span attributes or start time
   *     if type is {@type TimeInput} and 3rd param is undefined
   * @param [timeStamp] Specified time stamp for the event
   */
  addEvent(t, n, r) {
    if (this._isSpanEnded())
      return this;
    const { eventCountLimit: i } = this._spanLimits;
    if (i === 0)
      return I.warn("No events allowed."), this._droppedEventsCount++, this;
    i !== void 0 && this.events.length >= i && (this._droppedEventsCount === 0 && I.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Wr(n) && (Wr(r) || (r = n), n = void 0);
    const s = xt(n);
    return this.events.push({
      name: t,
      attributes: s,
      time: this._getTime(r),
      droppedAttributesCount: 0
    }), this;
  }
  addLink(t) {
    return this.links.push(t), this;
  }
  addLinks(t) {
    return this.links.push(...t), this;
  }
  setStatus(t) {
    return this._isSpanEnded() ? this : (this.status = At({}, t), this.status.message != null && typeof t.message != "string" && (I.warn(`Dropping invalid status.message of type '${typeof t.message}', expected 'string'`), delete this.status.message), this);
  }
  updateName(t) {
    return this._isSpanEnded() ? this : (this.name = t, this);
  }
  end(t) {
    if (this._isSpanEnded()) {
      I.error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`);
      return;
    }
    this.endTime = this._getTime(t), this._duration = Pa(this.startTime, this.endTime), this._duration[0] < 0 && (I.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && I.warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`), this._spanProcessor.onEnding && this._spanProcessor.onEnding(this), this._ended = !0, this._spanProcessor.onEnd(this);
  }
  _getTime(t) {
    if (typeof t == "number" && t <= oe.now())
      return qe(t + this._performanceOffset);
    if (typeof t == "number")
      return fe(t);
    if (t instanceof Date)
      return fe(t.getTime());
    if (Qn(t))
      return t;
    if (this._startTimeProvided)
      return fe(Date.now());
    const n = oe.now() - this._performanceStartTime;
    return Pi(this.startTime, fe(n));
  }
  isRecording() {
    return this._ended === !1;
  }
  recordException(t, n) {
    const r = {};
    typeof t == "string" ? r[Cr] = t : t && (t.code ? r[Nr] = t.code.toString() : t.name && (r[Nr] = t.name), t.message && (r[Cr] = t.message), t.stack && (r[Sp] = t.stack)), r[Nr] || r[Cr] ? this.addEvent(zh, r, n) : I.warn(`Failed to record an exception ${t}`);
  }
  get duration() {
    return this._duration;
  }
  get ended() {
    return this._ended;
  }
  get droppedAttributesCount() {
    return this._droppedAttributesCount;
  }
  get droppedEventsCount() {
    return this._droppedEventsCount;
  }
  get droppedLinksCount() {
    return this._droppedLinksCount;
  }
  _isSpanEnded() {
    if (this._ended) {
      const t = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
      I.warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, t);
    }
    return this._ended;
  }
  // Utility function to truncate given value within size
  // for value type of string, will truncate to given limit
  // for type of non-string, will return same value
  _truncateToLimitUtil(t, n) {
    return t.length <= n ? t : t.substring(0, n);
  }
  /**
   * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
   * return string with truncated to {@code attributeValueLengthLimit} characters
   *
   * If the given attribute value is array of strings then
   * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
   *
   * Otherwise return same Attribute {@code value}
   *
   * @param value Attribute value
   * @returns truncated attribute value if required, otherwise same value
   */
  _truncateToSize(t) {
    const n = this._attributeValueLengthLimit;
    return n <= 0 ? (I.warn(`Attribute value limit must be positive, got ${n}`), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map((r) => typeof r == "string" ? this._truncateToLimitUtil(r, n) : r) : t;
  }
}
var Ue;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Ue || (Ue = {}));
class wn {
  shouldSample() {
    return {
      decision: Ue.NOT_RECORD
    };
  }
  toString() {
    return "AlwaysOffSampler";
  }
}
class ot {
  shouldSample() {
    return {
      decision: Ue.RECORD_AND_SAMPLED
    };
  }
  toString() {
    return "AlwaysOnSampler";
  }
}
class cn {
  constructor(t) {
    v(this, "_root");
    v(this, "_remoteParentSampled");
    v(this, "_remoteParentNotSampled");
    v(this, "_localParentSampled");
    v(this, "_localParentNotSampled");
    var n, r, i, s;
    this._root = t.root, this._root || (Ge(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new ot()), this._remoteParentSampled = (n = t.remoteParentSampled) != null ? n : new ot(), this._remoteParentNotSampled = (r = t.remoteParentNotSampled) != null ? r : new wn(), this._localParentSampled = (i = t.localParentSampled) != null ? i : new ot(), this._localParentNotSampled = (s = t.localParentNotSampled) != null ? s : new wn();
  }
  shouldSample(t, n, r, i, s, o) {
    const a = G.getSpanContext(t);
    return !a || !Yn(a) ? this._root.shouldSample(t, n, r, i, s, o) : a.isRemote ? a.traceFlags & Re.SAMPLED ? this._remoteParentSampled.shouldSample(t, n, r, i, s, o) : this._remoteParentNotSampled.shouldSample(t, n, r, i, s, o) : a.traceFlags & Re.SAMPLED ? this._localParentSampled.shouldSample(t, n, r, i, s, o) : this._localParentNotSampled.shouldSample(t, n, r, i, s, o);
  }
  toString() {
    return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
  }
}
class Ws {
  constructor(t = 0) {
    v(this, "_ratio");
    v(this, "_upperBound");
    this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
  }
  shouldSample(t, n) {
    return {
      decision: la(n) && this._accumulate(n) < this._upperBound ? Ue.RECORD_AND_SAMPLED : Ue.NOT_RECORD
    };
  }
  toString() {
    return `TraceIdRatioBased{${this._ratio}}`;
  }
  _normalize(t) {
    return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
  }
  _accumulate(t) {
    let n = 0;
    for (let r = 0; r < t.length / 8; r++) {
      const i = r * 8, s = parseInt(t.slice(i, i + 8), 16);
      n = (n ^ s) >>> 0;
    }
    return n;
  }
}
var le;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(le || (le = {}));
const Ys = 1;
function iu() {
  return {
    sampler: su(),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: 1 / 0,
      attributeCountLimit: 128
    },
    spanLimits: {
      attributeValueLengthLimit: 1 / 0,
      attributeCountLimit: 128,
      linkCountLimit: 128,
      eventCountLimit: 128,
      attributePerEventCountLimit: 128,
      attributePerLinkCountLimit: 128
    }
  };
}
function su() {
  const e = le.ParentBasedAlwaysOn;
  switch (e) {
    case le.AlwaysOn:
      return new ot();
    case le.AlwaysOff:
      return new wn();
    case le.ParentBasedAlwaysOn:
      return new cn({
        root: new ot()
      });
    case le.ParentBasedAlwaysOff:
      return new cn({
        root: new wn()
      });
    case le.TraceIdRatio:
      return new Ws(Xs());
    case le.ParentBasedTraceIdRatio:
      return new cn({
        root: new Ws(Xs())
      });
    default:
      return I.error(`OTEL_TRACES_SAMPLER value "${e}" invalid, defaulting to "${le.ParentBasedAlwaysOn}".`), new cn({
        root: new ot()
      });
  }
}
function Xs() {
  return I.error(`OTEL_TRACES_SAMPLER_ARG is blank, defaulting to ${Ys}.`), Ys;
}
const qh = 128, Kh = 1 / 0;
function Wh(e) {
  const t = {
    sampler: su()
  }, n = iu(), r = Object.assign({}, n, t, e);
  return r.generalLimits = Object.assign({}, n.generalLimits, e.generalLimits || {}), r.spanLimits = Object.assign({}, n.spanLimits, e.spanLimits || {}), r;
}
function Yh(e) {
  var n, r, i, s, o, a, u, c, p, m, d, l;
  const t = Object.assign({}, e.spanLimits);
  return t.attributeCountLimit = (a = (o = (s = (i = (n = e.spanLimits) == null ? void 0 : n.attributeCountLimit) != null ? i : (r = e.generalLimits) == null ? void 0 : r.attributeCountLimit) != null ? s : void 0) != null ? o : void 0) != null ? a : qh, t.attributeValueLengthLimit = (l = (d = (m = (p = (u = e.spanLimits) == null ? void 0 : u.attributeValueLengthLimit) != null ? p : (c = e.generalLimits) == null ? void 0 : c.attributeValueLengthLimit) != null ? m : void 0) != null ? d : void 0) != null ? l : Kh, Object.assign({}, e, { spanLimits: t });
}
class Xh {
  constructor(t, n) {
    v(this, "_maxExportBatchSize");
    v(this, "_maxQueueSize");
    v(this, "_scheduledDelayMillis");
    v(this, "_exportTimeoutMillis");
    v(this, "_exporter");
    v(this, "_isExporting", !1);
    v(this, "_finishedSpans", []);
    v(this, "_timer");
    v(this, "_shutdownOnce");
    v(this, "_droppedSpansCount", 0);
    this._exporter = t, this._maxExportBatchSize = typeof (n == null ? void 0 : n.maxExportBatchSize) == "number" ? n.maxExportBatchSize : 512, this._maxQueueSize = typeof (n == null ? void 0 : n.maxQueueSize) == "number" ? n.maxQueueSize : 2048, this._scheduledDelayMillis = typeof (n == null ? void 0 : n.scheduledDelayMillis) == "number" ? n.scheduledDelayMillis : 5e3, this._exportTimeoutMillis = typeof (n == null ? void 0 : n.exportTimeoutMillis) == "number" ? n.exportTimeoutMillis : 3e4, this._shutdownOnce = new ja(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (I.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
  }
  forceFlush() {
    return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
  }
  // does nothing.
  onStart(t, n) {
  }
  onEnd(t) {
    this._shutdownOnce.isCalled || t.spanContext().traceFlags & Re.SAMPLED && this._addToBuffer(t);
  }
  shutdown() {
    return this._shutdownOnce.call();
  }
  _shutdown() {
    return Promise.resolve().then(() => this.onShutdown()).then(() => this._flushAll()).then(() => this._exporter.shutdown());
  }
  /** Add a span in the buffer. */
  _addToBuffer(t) {
    if (this._finishedSpans.length >= this._maxQueueSize) {
      this._droppedSpansCount === 0 && I.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
      return;
    }
    this._droppedSpansCount > 0 && (I.warn(`Dropped ${this._droppedSpansCount} spans because maxQueueSize reached`), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
  }
  /**
   * Send all spans to the exporter respecting the batch size limit
   * This function is used only on forceFlush or shutdown,
   * for all other cases _flush should be used
   * */
  _flushAll() {
    return new Promise((t, n) => {
      const r = [], i = Math.ceil(this._finishedSpans.length / this._maxExportBatchSize);
      for (let s = 0, o = i; s < o; s++)
        r.push(this._flushOneBatch());
      Promise.all(r).then(() => {
        t();
      }).catch(n);
    });
  }
  _flushOneBatch() {
    return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise((t, n) => {
      const r = setTimeout(() => {
        n(new Error("Timeout"));
      }, this._exportTimeoutMillis);
      j.with(Oi(j.active()), () => {
        let i;
        this._finishedSpans.length <= this._maxExportBatchSize ? (i = this._finishedSpans, this._finishedSpans = []) : i = this._finishedSpans.splice(0, this._maxExportBatchSize);
        const s = () => this._exporter.export(i, (a) => {
          var u;
          clearTimeout(r), a.code === Dt.SUCCESS ? t() : n((u = a.error) != null ? u : new Error("BatchSpanProcessor: span export failed"));
        });
        let o = null;
        for (let a = 0, u = i.length; a < u; a++) {
          const c = i[a];
          c.resource.asyncAttributesPending && c.resource.waitForAsyncAttributes && (o != null || (o = []), o.push(c.resource.waitForAsyncAttributes()));
        }
        o === null ? s() : Promise.all(o).then(s, (a) => {
          Ge(a), n(a);
        });
      });
    });
  }
  _maybeStartTimer() {
    if (this._isExporting)
      return;
    const t = () => {
      this._isExporting = !0, this._flushOneBatch().finally(() => {
        this._isExporting = !1, this._finishedSpans.length > 0 && (this._clearTimer(), this._maybeStartTimer());
      }).catch((n) => {
        this._isExporting = !1, Ge(n);
      });
    };
    if (this._finishedSpans.length >= this._maxExportBatchSize)
      return t();
    this._timer === void 0 && (this._timer = setTimeout(() => t(), this._scheduledDelayMillis), typeof this._timer != "number" && this._timer.unref());
  }
  _clearTimer() {
    this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
  }
}
class Qh extends Xh {
  constructor(n, r) {
    super(n, r);
    v(this, "_visibilityChangeListener");
    v(this, "_pageHideListener");
    this.onInit(r);
  }
  onInit(n) {
    (n == null ? void 0 : n.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = () => {
      document.visibilityState === "hidden" && this.forceFlush().catch((r) => {
        Ge(r);
      });
    }, this._pageHideListener = () => {
      this.forceFlush().catch((r) => {
        Ge(r);
      });
    }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
  }
  onShutdown() {
    typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
  }
}
const Jh = 8, Zh = 16;
class em {
  constructor() {
    /**
     * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
     * characters corresponding to 128 bits.
     */
    v(this, "generateTraceId", Qs(Zh));
    /**
     * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
     * characters corresponding to 64 bits.
     */
    v(this, "generateSpanId", Qs(Jh));
  }
}
const ln = Array(32);
function Qs(e) {
  return function() {
    for (let n = 0; n < e * 2; n++)
      ln[n] = Math.floor(Math.random() * 16) + 48, ln[n] >= 58 && (ln[n] += 39);
    return String.fromCharCode.apply(null, ln.slice(0, e * 2));
  };
}
class tm {
  /**
   * Constructs a new Tracer instance.
   */
  constructor(t, n, r, i) {
    v(this, "_sampler");
    v(this, "_generalLimits");
    v(this, "_spanLimits");
    v(this, "_idGenerator");
    v(this, "instrumentationScope");
    v(this, "_resource");
    v(this, "_spanProcessor");
    const s = Wh(n);
    this._sampler = s.sampler, this._generalLimits = s.generalLimits, this._spanLimits = s.spanLimits, this._idGenerator = n.idGenerator || new em(), this._resource = r, this._spanProcessor = i, this.instrumentationScope = t;
  }
  /**
   * Starts a new Span or returns the default NoopSpan based on the sampling
   * decision.
   */
  startSpan(t, n = {}, r = j.active()) {
    var T, S, b;
    n.root && (r = G.deleteSpan(r));
    const i = G.getSpan(r);
    if (Xn(r))
      return I.debug("Instrumentation suppressed, returning Noop Span"), G.wrapSpanContext(ua);
    const s = i == null ? void 0 : i.spanContext(), o = this._idGenerator.generateSpanId();
    let a, u, c;
    !s || !G.isSpanContextValid(s) ? u = this._idGenerator.generateTraceId() : (u = s.traceId, c = s.traceState, a = s);
    const p = (T = n.kind) != null ? T : kt.INTERNAL, m = ((S = n.links) != null ? S : []).map((y) => ({
      context: y.context,
      attributes: xt(y.attributes)
    })), d = xt(n.attributes), l = this._sampler.shouldSample(r, u, t, p, d, m);
    c = (b = l.traceState) != null ? b : c;
    const f = l.decision === bn.RECORD_AND_SAMPLED ? Re.SAMPLED : Re.NONE, h = { traceId: u, spanId: o, traceFlags: f, traceState: c };
    if (l.decision === bn.NOT_RECORD)
      return I.debug("Recording is off, propagating context in a non-recording span"), G.wrapSpanContext(h);
    const g = xt(Object.assign(d, l.attributes));
    return new Gh({
      resource: this._resource,
      scope: this.instrumentationScope,
      context: r,
      spanContext: h,
      name: t,
      kind: p,
      links: m,
      parentSpanContext: a,
      attributes: g,
      startTime: n.startTime,
      spanProcessor: this._spanProcessor,
      spanLimits: this._spanLimits
    });
  }
  startActiveSpan(t, n, r, i) {
    let s, o, a;
    if (arguments.length < 2)
      return;
    arguments.length === 2 ? a = n : arguments.length === 3 ? (s = n, a = r) : (s = n, o = r, a = i);
    const u = o != null ? o : j.active(), c = this.startSpan(t, s, u), p = G.setSpan(u, c);
    return j.with(p, a, void 0, c);
  }
  /** Returns the active {@link GeneralLimits}. */
  getGeneralLimits() {
    return this._generalLimits;
  }
  /** Returns the active {@link SpanLimits}. */
  getSpanLimits() {
    return this._spanLimits;
  }
}
class nm {
  constructor(t) {
    v(this, "_spanProcessors");
    this._spanProcessors = t;
  }
  forceFlush() {
    const t = [];
    for (const n of this._spanProcessors)
      t.push(n.forceFlush());
    return new Promise((n) => {
      Promise.all(t).then(() => {
        n();
      }).catch((r) => {
        Ge(r || new Error("MultiSpanProcessor: forceFlush failed")), n();
      });
    });
  }
  onStart(t, n) {
    for (const r of this._spanProcessors)
      r.onStart(t, n);
  }
  onEnding(t) {
    for (const n of this._spanProcessors)
      n.onEnding && n.onEnding(t);
  }
  onEnd(t) {
    for (const n of this._spanProcessors)
      n.onEnd(t);
  }
  shutdown() {
    const t = [];
    for (const n of this._spanProcessors)
      t.push(n.shutdown());
    return new Promise((n, r) => {
      Promise.all(t).then(() => {
        n();
      }, r);
    });
  }
}
var $e;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})($e || ($e = {}));
class rm {
  constructor(t = {}) {
    v(this, "_config");
    v(this, "_tracers", /* @__PURE__ */ new Map());
    v(this, "_resource");
    v(this, "_activeSpanProcessor");
    var i, s;
    const n = ka({}, iu(), Yh(t));
    this._resource = (i = n.resource) != null ? i : ru(), this._config = Object.assign({}, n, {
      resource: this._resource
    });
    const r = [];
    (s = t.spanProcessors) != null && s.length && r.push(...t.spanProcessors), this._activeSpanProcessor = new nm(r);
  }
  getTracer(t, n, r) {
    const i = `${t}@${n || ""}:${(r == null ? void 0 : r.schemaUrl) || ""}`;
    return this._tracers.has(i) || this._tracers.set(i, new tm({ name: t, version: n, schemaUrl: r == null ? void 0 : r.schemaUrl }, this._config, this._resource, this._activeSpanProcessor)), this._tracers.get(i);
  }
  forceFlush() {
    const t = this._config.forceFlushTimeoutMillis, n = this._activeSpanProcessor._spanProcessors.map((r) => new Promise((i) => {
      let s;
      const o = setTimeout(() => {
        i(new Error(`Span processor did not completed within timeout period of ${t} ms`)), s = $e.timeout;
      }, t);
      r.forceFlush().then(() => {
        clearTimeout(o), s !== $e.timeout && (s = $e.resolved, i(s));
      }).catch((a) => {
        clearTimeout(o), s = $e.error, i(a);
      });
    }));
    return new Promise((r, i) => {
      Promise.all(n).then((s) => {
        const o = s.filter((a) => a !== $e.resolved);
        o.length > 0 ? i(o) : r();
      }).catch((s) => i([s]));
    });
  }
  shutdown() {
    return this._activeSpanProcessor.shutdown();
  }
}
class im {
  constructor() {
    /**
     * whether the context manager is enabled or not
     */
    v(this, "_enabled", !1);
    /**
     * Keeps the reference to current context
     */
    v(this, "_currentContext", nt);
  }
  /**
   *
   * @param context
   * @param target Function to be executed within the context
   */
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  _bindFunction(t = nt, n) {
    const r = this, i = function(...s) {
      return r.with(t, () => n.apply(this, s));
    };
    return Object.defineProperty(i, "length", {
      enumerable: !1,
      configurable: !0,
      writable: !1,
      value: n.length
    }), i;
  }
  /**
   * Returns the active context
   */
  active() {
    return this._currentContext;
  }
  /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */
  bind(t, n) {
    return t === void 0 && (t = this.active()), typeof n == "function" ? this._bindFunction(t, n) : n;
  }
  /**
   * Disable the context manager (clears the current context)
   */
  disable() {
    return this._currentContext = nt, this._enabled = !1, this;
  }
  /**
   * Enables the context manager and creates a default(root) context
   */
  enable() {
    return this._enabled ? this : (this._enabled = !0, this._currentContext = nt, this);
  }
  /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */
  with(t, n, r, ...i) {
    const s = this._currentContext;
    this._currentContext = t || nt;
    try {
      return n.call(r, ...i);
    } finally {
      this._currentContext = s;
    }
  }
}
function sm(e) {
  if (e !== null) {
    if (e === void 0) {
      const t = new im();
      t.enable(), j.setGlobalContextManager(t);
      return;
    }
    e.enable(), j.setGlobalContextManager(e);
  }
}
function om(e) {
  if (e !== null) {
    if (e === void 0) {
      ee.setGlobalPropagator(new Ia({
        propagators: [
          new Ii(),
          new ga()
        ]
      }));
      return;
    }
    ee.setGlobalPropagator(e);
  }
}
class am extends rm {
  /**
   * Constructs a new Tracer instance.
   * @param config Web Tracer config
   */
  constructor(t = {}) {
    super(t);
  }
  /**
   * Register this TracerProvider for use with the OpenTelemetry API.
   * Undefined values may be replaced with defaults, and
   * null values will be skipped.
   *
   * @param config Configuration object for SDK registration
   */
  register(t = {}) {
    G.setGlobalTracerProvider(this), om(t.propagator), sm(t.contextManager);
  }
}
var M;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.START_TIME = "startTime", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(M || (M = {}));
const um = "http.response_content_length", cm = "http.response_content_length_uncompressed";
let Mr;
function lm() {
  return Mr || (Mr = document.createElement("a")), Mr;
}
function dm(e, t) {
  return t in e;
}
function be(e, t, n, r = !0) {
  if (dm(n, t) && typeof n[t] == "number" && !(r && n[t] === 0))
    return e.addEvent(t, n[t]);
}
function An(e, t, n = !1, r, i) {
  if (r === void 0 && (r = t[M.START_TIME] !== 0), n || (be(e, M.FETCH_START, t, r), be(e, M.DOMAIN_LOOKUP_START, t, r), be(e, M.DOMAIN_LOOKUP_END, t, r), be(e, M.CONNECT_START, t, r), be(e, M.SECURE_CONNECTION_START, t, r), be(e, M.CONNECT_END, t, r), be(e, M.REQUEST_START, t, r), be(e, M.RESPONSE_START, t, r), be(e, M.RESPONSE_END, t, r)), !i) {
    const s = t[M.ENCODED_BODY_SIZE];
    s !== void 0 && e.setAttribute(um, s);
    const o = t[M.DECODED_BODY_SIZE];
    o !== void 0 && s !== o && e.setAttribute(cm, o);
  }
}
function fm(e) {
  return e.slice().sort((t, n) => {
    const r = t[M.FETCH_START], i = n[M.FETCH_START];
    return r > i ? 1 : r < i ? -1 : 0;
  });
}
function ou() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function au(e, t, n, r, i = /* @__PURE__ */ new WeakSet(), s) {
  const o = Se(e);
  e = o.toString();
  const a = hm(e, t, n, r, i, s);
  if (a.length === 0)
    return {
      mainRequest: void 0
    };
  if (a.length === 1)
    return {
      mainRequest: a[0]
    };
  const u = fm(a);
  if (o.origin !== ou() && u.length > 1) {
    let c = u[0], p = pm(u, c[M.RESPONSE_END], n);
    const m = c[M.RESPONSE_END];
    return p[M.FETCH_START] < m && (p = c, c = void 0), {
      corsPreFlightRequest: c,
      mainRequest: p
    };
  } else
    return {
      mainRequest: a[0]
    };
}
function pm(e, t, n) {
  const r = Te(n), i = Te(st(t));
  let s = e[1], o;
  const a = e.length;
  for (let u = 1; u < a; u++) {
    const c = e[u], p = Te(st(c[M.FETCH_START])), m = Te(st(c[M.RESPONSE_END])), d = r - m;
    p >= i && (!o || d < o) && (o = d, s = c);
  }
  return s;
}
function hm(e, t, n, r, i, s) {
  const o = Te(t), a = Te(n);
  let u = r.filter((c) => {
    const p = Te(st(c[M.FETCH_START])), m = Te(st(c[M.RESPONSE_END]));
    return c.initiatorType.toLowerCase() === (s || "xmlhttprequest") && c.name === e && p >= o && m <= a;
  });
  return u.length > 0 && (u = u.filter((c) => !i.has(c))), u;
}
function Se(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  const t = lm();
  return t.href = e, t;
}
function uu(e, t) {
  let n = t || [];
  return (typeof n == "string" || n instanceof RegExp) && (n = [n]), Se(e).origin === ou() ? !0 : n.some((i) => Ni(e, i));
}
var On;
(function(e) {
  e.COMPONENT = "component", e.HTTP_STATUS_TEXT = "http.status_text";
})(On || (On = {}));
const mm = "http.host", gm = "http.method", vm = "http.request.body.size", _m = "http.request_content_length_uncompressed", bm = "http.scheme", Em = "http.status_code", Sm = "http.url", ym = "http.user_agent", cu = I.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function Tm(...e) {
  if (e[0] instanceof URL || typeof e[0] == "string") {
    const t = e[1];
    if (!(t != null && t.body))
      return Promise.resolve();
    if (t.body instanceof ReadableStream) {
      const { body: n, length: r } = wm(t.body);
      return t.body = n, r;
    } else
      return Promise.resolve(Om(t.body));
  } else {
    const t = e[0];
    return t != null && t.body ? t.clone().text().then((n) => Zr(n)) : Promise.resolve();
  }
}
function wm(e) {
  if (!e.pipeThrough)
    return cu.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  let t = 0, n;
  const r = new Promise((o) => {
    n = o;
  }), i = new TransformStream({
    start() {
    },
    transform(o, a) {
      return Yt(this, null, function* () {
        const u = yield o;
        t += u.byteLength, a.enqueue(o);
      });
    },
    flush() {
      n(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: r
  };
}
function Am(e) {
  return typeof Document != "undefined" && e instanceof Document;
}
function Om(e) {
  if (Am(e))
    return new XMLSerializer().serializeToString(document).length;
  if (typeof e == "string")
    return Zr(e);
  if (e instanceof Blob)
    return e.size;
  if (e instanceof FormData)
    return Pm(e);
  if (e instanceof URLSearchParams)
    return Zr(e.toString());
  if (e.byteLength !== void 0)
    return e.byteLength;
  cu.warn("unknown body type");
}
const Rm = new TextEncoder();
function Zr(e) {
  return Rm.encode(e).byteLength;
}
function Pm(e) {
  let t = 0;
  for (const [n, r] of e.entries())
    t += n.length, r instanceof Blob ? t += r.size : t += r.length;
  return t;
}
function Im(e) {
  const t = Nm(), n = e.toUpperCase();
  return n in t ? n : "_OTHER";
}
const Cm = {
  CONNECT: !0,
  DELETE: !0,
  GET: !0,
  HEAD: !0,
  OPTIONS: !0,
  PATCH: !0,
  POST: !0,
  PUT: !0,
  TRACE: !0,
  // QUERY from https://datatracker.ietf.org/doc/draft-ietf-httpbis-safe-method-w-body/
  QUERY: !0
};
let Lr;
function Nm() {
  return Lr === void 0 && (Lr = Cm), Lr;
}
const xm = {
  "https:": "443",
  "http:": "80"
};
function Mm(e) {
  const t = Number(e.port || xm[e.protocol]);
  if (t && !isNaN(t))
    return t;
}
const Js = "0.211.0", Lm = 300, Zs = typeof PerformanceObserver != "undefined";
class km extends eu {
  constructor(n = {}) {
    super("@opentelemetry/instrumentation-fetch", Js, n);
    v(this, "component", "fetch");
    v(this, "version", Js);
    v(this, "moduleName", this.component);
    v(this, "_usedResources", /* @__PURE__ */ new WeakSet());
    v(this, "_tasksCount", 0);
    v(this, "_semconvStability");
    this._semconvStability = tu("http", n == null ? void 0 : n.semconvStabilityOptIn);
  }
  init() {
  }
  /**
   * Add cors pre flight child span
   * @param span
   * @param corsPreFlightRequest
   */
  _addChildSpan(n, r) {
    const i = this.tracer.startSpan("CORS Preflight", {
      startTime: r[M.FETCH_START]
    }, G.setSpan(j.active(), n)), s = !(this._semconvStability & B.OLD);
    An(i, r, this.getConfig().ignoreNetworkEvents, void 0, s), i.end(r[M.RESPONSE_END]);
  }
  /**
   * Adds more attributes to span just before ending it
   * @param span
   * @param response
   */
  _addFinalSpanAttributes(n, r) {
    const i = Se(r.url);
    if (this._semconvStability & B.OLD && (n.setAttribute(Em, r.status), r.statusText != null && n.setAttribute(On.HTTP_STATUS_TEXT, r.statusText), n.setAttribute(mm, i.host), n.setAttribute(bm, i.protocol.replace(":", "")), typeof navigator != "undefined" && n.setAttribute(ym, navigator.userAgent)), this._semconvStability & B.STABLE) {
      n.setAttribute(ya, r.status), n.setAttribute(Ta, i.hostname);
      const s = Mm(i);
      s && n.setAttribute(wa, s);
    }
  }
  /**
   * Add headers
   * @param options
   * @param spanUrl
   */
  _addHeaders(n, r) {
    if (!uu(r, this.getConfig().propagateTraceHeaderCorsUrls)) {
      const i = {};
      ee.inject(j.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
      return;
    }
    if (n instanceof Request)
      ee.inject(j.active(), n.headers, {
        set: (i, s, o) => i.set(s, typeof o == "string" ? o : String(o))
      });
    else if (n.headers instanceof Headers)
      ee.inject(j.active(), n.headers, {
        set: (i, s, o) => i.set(s, typeof o == "string" ? o : String(o))
      });
    else if (n.headers instanceof Map)
      ee.inject(j.active(), n.headers, {
        set: (i, s, o) => i.set(s, typeof o == "string" ? o : String(o))
      });
    else {
      const i = {};
      ee.inject(j.active(), i), n.headers = Object.assign({}, i, n.headers || {});
    }
  }
  /**
   * Clears the resource timings and all resources assigned with spans
   *     when {@link FetchPluginConfig.clearTimingResources} is
   *     set to true (default false)
   * @private
   */
  _clearResources() {
    this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
  }
  /**
   * Creates a new span
   * @param url
   * @param options
   */
  _createSpan(n, r = {}) {
    if (xi(n, this.getConfig().ignoreUrls)) {
      this._diag.debug("ignoring span as url matches ignored url");
      return;
    }
    let i = "";
    const s = {};
    if (this._semconvStability & B.OLD) {
      const o = (r.method || "GET").toUpperCase();
      i = `HTTP ${o}`, s[On.COMPONENT] = this.moduleName, s[gm] = o, s[Sm] = n;
    }
    if (this._semconvStability & B.STABLE) {
      const o = r.method, a = Im(r.method || "GET");
      i || (i = a), s[Ea] = a, a !== o && (s[Sa] = o), s[Oa] = n;
    }
    return this.tracer.startSpan(i, {
      kind: kt.CLIENT,
      attributes: s
    });
  }
  /**
   * Finds appropriate resource and add network events to the span
   * @param span
   * @param resourcesObserver
   * @param endTime
   */
  _findResourceAndAddNetworkEvents(n, r, i) {
    let s = r.entries;
    if (!s.length) {
      if (!performance.getEntriesByType)
        return;
      s = performance.getEntriesByType("resource");
    }
    const o = au(r.spanUrl, r.startTime, i, s, this._usedResources, "fetch");
    if (o.mainRequest) {
      const a = o.mainRequest;
      this._markResourceAsUsed(a);
      const u = o.corsPreFlightRequest;
      u && (this._addChildSpan(n, u), this._markResourceAsUsed(u));
      const c = !(this._semconvStability & B.OLD);
      An(n, a, this.getConfig().ignoreNetworkEvents, void 0, c);
    }
  }
  /**
   * Marks certain [resource]{@link PerformanceResourceTiming} when information
   * from this is used to add events to span.
   * This is done to avoid reusing the same resource again for next span
   * @param resource
   */
  _markResourceAsUsed(n) {
    this._usedResources.add(n);
  }
  /**
   * Finish span, add attributes, network events etc.
   * @param span
   * @param spanData
   * @param response
   */
  _endSpan(n, r, i) {
    const s = fe(Date.now()), o = qe();
    this._addFinalSpanAttributes(n, i), this._semconvStability & B.STABLE && i.status >= 400 && (n.setStatus({ code: ze.ERROR }), n.setAttribute(zr, String(i.status))), setTimeout(() => {
      var a;
      (a = r.observer) == null || a.disconnect(), this._findResourceAndAddNetworkEvents(n, r, o), this._tasksCount--, this._clearResources(), n.end(s);
    }, Lm);
  }
  /**
   * Patches the constructor of fetch
   */
  _patchConstructor() {
    return (n) => {
      const r = this;
      return function(...s) {
        const o = this, a = Se(s[0] instanceof Request ? s[0].url : String(s[0])).href, u = s[0] instanceof Request ? s[0] : s[1] || {}, c = r._createSpan(a, u);
        if (!c)
          return n.apply(this, s);
        const p = r._prepareSpanData(a);
        r.getConfig().measureRequestSize && Tm(...s).then((g) => {
          g && (r._semconvStability & B.OLD && c.setAttribute(_m, g), r._semconvStability & B.STABLE && c.setAttribute(vm, g));
        }).catch((g) => {
          r._diag.warn("getFetchBodyLength", g);
        });
        function m(g, _) {
          r._applyAttributesAfterFetch(g, u, _), r._endSpan(g, p, {
            status: _.status || 0,
            statusText: _.message,
            url: a
          });
        }
        function d(g, _) {
          r._applyAttributesAfterFetch(g, u, _), _.status >= 200 && _.status < 400 ? r._endSpan(g, p, _) : r._endSpan(g, p, {
            status: _.status,
            statusText: _.statusText,
            url: a
          });
        }
        function l(g, _) {
          if (!g)
            return null;
          const T = g.getReader();
          return new ReadableStream({
            pull(b) {
              return Yt(this, null, function* () {
                try {
                  const { value: y, done: E } = yield T.read();
                  E ? (T.releaseLock(), b.close()) : b.enqueue(y);
                } catch (y) {
                  b.error(y), T.cancel(y).catch((E) => {
                  });
                  try {
                    T.releaseLock();
                  } catch (E) {
                  }
                }
              });
            },
            cancel(b) {
              return _.cancel(b).catch((y) => {
              }), T.cancel(b);
            }
          });
        }
        function f(g, _, T) {
          let S = null;
          try {
            const y = T.clone().body;
            if (y) {
              const E = y.getReader(), D = /* 101 responses and protocol upgrading is handled internally by the browser */ T.status === 204 || T.status === 205 || T.status === 304 ? null : l(T.body, E);
              S = new Response(D, {
                status: T.status,
                statusText: T.statusText,
                headers: T.headers
              });
              const V = () => {
                E.read().then(({ done: Y }) => {
                  Y ? d(g, T) : V();
                }, (Y) => {
                  m(g, Y);
                });
              };
              V();
            } else
              d(g, T);
          } finally {
            _(S != null ? S : T);
          }
        }
        function h(g, _, T) {
          try {
            m(g, T);
          } finally {
            _(T);
          }
        }
        return new Promise((g, _) => j.with(G.setSpan(j.active(), c), () => (r._addHeaders(u, a), r._callRequestHook(c, u), r._tasksCount++, n.apply(o, u instanceof Request ? [u] : [a, u]).then(f.bind(o, c, g), h.bind(o, c, _)))));
      };
    };
  }
  _applyAttributesAfterFetch(n, r, i) {
    const s = this.getConfig().applyCustomAttributesOnSpan;
    s && Qr(() => s(n, r, i), (o) => {
      o && this._diag.error("applyCustomAttributesOnSpan", o);
    }, !0);
  }
  _callRequestHook(n, r) {
    const i = this.getConfig().requestHook;
    i && Qr(() => i(n, r), (s) => {
      s && this._diag.error("requestHook", s);
    }, !0);
  }
  /**
   * Prepares a span data - needed later for matching appropriate network
   *     resources
   * @param spanUrl
   */
  _prepareSpanData(n) {
    const r = qe(), i = [];
    if (typeof PerformanceObserver != "function")
      return { entries: i, startTime: r, spanUrl: n };
    const s = new PerformanceObserver((o) => {
      o.getEntries().forEach((u) => {
        u.initiatorType === "fetch" && u.name === n && i.push(u);
      });
    });
    return s.observe({
      entryTypes: ["resource"]
    }), { entries: i, observer: s, startTime: r, spanUrl: n };
  }
  /**
   * implements enable function
   */
  enable() {
    if (!Zs) {
      this._diag.warn("this instrumentation is intended for web usage only, it does not instrument server-side fetch()");
      return;
    }
    Jr(fetch) && (this._unwrap(globalThis, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(globalThis, "fetch", this._patchConstructor());
  }
  /**
   * implements unpatch function
   */
  disable() {
    Zs && (this._unwrap(globalThis, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
  }
}
const Dm = "http.host", Um = "http.method", jm = "http.request.body.size", Bm = "http.request_content_length_uncompressed", $m = "http.scheme", Fm = "http.status_code", Hm = "http.url", Vm = "http.user_agent";
var Ee;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(Ee || (Ee = {}));
const zm = I.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function Gm(e) {
  return typeof Document != "undefined" && e instanceof Document;
}
function qm(e) {
  if (Gm(e))
    return new XMLSerializer().serializeToString(document).length;
  if (typeof e == "string")
    return eo(e);
  if (e instanceof Blob)
    return e.size;
  if (e instanceof FormData)
    return Wm(e);
  if (e instanceof URLSearchParams)
    return eo(e.toString());
  if (e.byteLength !== void 0)
    return e.byteLength;
  zm.warn("unknown body type");
}
const Km = new TextEncoder();
function eo(e) {
  return Km.encode(e).byteLength;
}
function Wm(e) {
  let t = 0;
  for (const [n, r] of e.entries())
    t += n.length, r instanceof Blob ? t += r.size : t += r.length;
  return t;
}
function Ym(e) {
  const t = Qm(), n = e.toUpperCase();
  return n in t ? n : "_OTHER";
}
const Xm = {
  CONNECT: !0,
  DELETE: !0,
  GET: !0,
  HEAD: !0,
  OPTIONS: !0,
  PATCH: !0,
  POST: !0,
  PUT: !0,
  TRACE: !0,
  // QUERY from https://datatracker.ietf.org/doc/draft-ietf-httpbis-safe-method-w-body/
  QUERY: !0
};
let kr;
function Qm() {
  return kr === void 0 && (kr = Xm), kr;
}
const Jm = {
  "https:": "443",
  "http:": "80"
};
function Zm(e) {
  const t = Number(e.port || Jm[e.protocol]);
  if (t && !isNaN(t))
    return t;
}
const to = "0.211.0";
var ei;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(ei || (ei = {}));
const eg = 300;
class tg extends eu {
  constructor(n = {}) {
    super("@opentelemetry/instrumentation-xml-http-request", to, n);
    v(this, "component", "xml-http-request");
    v(this, "version", to);
    v(this, "moduleName", this.component);
    v(this, "_tasksCount", 0);
    v(this, "_xhrMem", /* @__PURE__ */ new WeakMap());
    v(this, "_usedResources", /* @__PURE__ */ new WeakSet());
    v(this, "_semconvStability");
    this._semconvStability = tu("http", n == null ? void 0 : n.semconvStabilityOptIn);
  }
  init() {
  }
  /**
   * Adds custom headers to XMLHttpRequest
   * @param xhr
   * @param spanUrl
   * @private
   */
  _addHeaders(n, r) {
    const i = Se(r).href;
    if (!uu(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
      const o = {};
      ee.inject(j.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
      return;
    }
    const s = {};
    ee.inject(j.active(), s), Object.keys(s).forEach((o) => {
      n.setRequestHeader(o, String(s[o]));
    });
  }
  /**
   * Add cors pre flight child span
   * @param span
   * @param corsPreFlightRequest
   * @private
   */
  _addChildSpan(n, r) {
    j.with(G.setSpan(j.active(), n), () => {
      const i = this.tracer.startSpan("CORS Preflight", {
        startTime: r[M.FETCH_START]
      }), s = !(this._semconvStability & B.OLD);
      An(i, r, this.getConfig().ignoreNetworkEvents, void 0, s), i.end(r[M.RESPONSE_END]);
    });
  }
  /**
   * Add attributes when span is going to end
   * @param span
   * @param xhr
   * @param spanUrl
   * @private
   */
  _addFinalSpanAttributes(n, r, i) {
    if (this._semconvStability & B.OLD) {
      if (r.status !== void 0 && n.setAttribute(Fm, r.status), r.statusText !== void 0 && n.setAttribute(ei.HTTP_STATUS_TEXT, r.statusText), typeof i == "string") {
        const s = Se(i);
        n.setAttribute(Dm, s.host), n.setAttribute($m, s.protocol.replace(":", ""));
      }
      n.setAttribute(Vm, navigator.userAgent);
    }
    this._semconvStability & B.STABLE && r.status && n.setAttribute(ya, r.status);
  }
  _applyAttributesAfterXHR(n, r) {
    const i = this.getConfig().applyCustomAttributesOnSpan;
    typeof i == "function" && Qr(() => i(n, r), (s) => {
      s && this._diag.error("applyCustomAttributesOnSpan", s);
    }, !0);
  }
  /**
   * will collect information about all resources created
   * between "send" and "end" with additional waiting for main resource
   * @param xhr
   * @param spanUrl
   * @private
   */
  _addResourceObserver(n, r) {
    const i = this._xhrMem.get(n);
    !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
      observer: new PerformanceObserver((s) => {
        const o = s.getEntries(), a = Se(r);
        o.forEach((u) => {
          u.initiatorType === "xmlhttprequest" && u.name === a.href && i.createdResources && i.createdResources.entries.push(u);
        });
      }),
      entries: []
    }, i.createdResources.observer.observe({
      entryTypes: ["resource"]
    }));
  }
  /**
   * Clears the resource timings and all resources assigned with spans
   *     when {@link XMLHttpRequestInstrumentationConfig.clearTimingResources} is
   *     set to true (default false)
   * @private
   */
  _clearResources() {
    this._tasksCount === 0 && this.getConfig().clearTimingResources && (oe.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
  }
  /**
   * Finds appropriate resource and add network events to the span
   * @param span
   */
  _findResourceAndAddNetworkEvents(n, r, i, s, o) {
    if (!i || !s || !o || !n.createdResources)
      return;
    let a = n.createdResources.entries;
    (!a || !a.length) && (a = oe.getEntriesByType("resource"));
    const u = au(Se(i).href, s, o, a, this._usedResources);
    if (u.mainRequest) {
      const c = u.mainRequest;
      this._markResourceAsUsed(c);
      const p = u.corsPreFlightRequest;
      p && (this._addChildSpan(r, p), this._markResourceAsUsed(p));
      const m = !(this._semconvStability & B.OLD);
      An(r, c, this.getConfig().ignoreNetworkEvents, void 0, m);
    }
  }
  /**
   * Removes the previous information about span.
   * This might happened when the same xhr is used again.
   * @param xhr
   * @private
   */
  _cleanPreviousSpanInformation(n) {
    const r = this._xhrMem.get(n);
    if (r) {
      const i = r.callbackToRemoveEvents;
      i && i(), this._xhrMem.delete(n);
    }
  }
  /**
   * Creates a new span when method "open" is called
   * @param xhr
   * @param url
   * @param method
   * @private
   */
  _createSpan(n, r, i) {
    if (xi(r, this.getConfig().ignoreUrls)) {
      this._diag.debug("ignoring span as url matches ignored url");
      return;
    }
    let s = "";
    const o = Se(r), a = {};
    if (this._semconvStability & B.OLD && (s = i.toUpperCase(), a[Um] = i, a[Hm] = o.toString()), this._semconvStability & B.STABLE) {
      const c = i, p = Ym(i);
      s || (s = p), a[Ea] = p, p !== c && (a[Sa] = c), a[Oa] = o.toString(), a[Ta] = o.hostname;
      const m = Zm(o);
      m && (a[wa] = m);
    }
    const u = this.tracer.startSpan(s, {
      kind: kt.CLIENT,
      attributes: a
    });
    return u.addEvent(Ee.METHOD_OPEN), this._cleanPreviousSpanInformation(n), this._xhrMem.set(n, {
      span: u,
      spanUrl: r
    }), u;
  }
  /**
   * Marks certain [resource]{@link PerformanceResourceTiming} when information
   * from this is used to add events to span.
   * This is done to avoid reusing the same resource again for next span
   * @param resource
   * @private
   */
  _markResourceAsUsed(n) {
    this._usedResources.add(n);
  }
  /**
   * Patches the method open
   * @private
   */
  _patchOpen() {
    return (n) => {
      const r = this;
      return function(...s) {
        const o = s[0], a = s[1];
        return r._createSpan(this, a, o), n.apply(this, s);
      };
    };
  }
  /**
   * Patches the method send
   * @private
   */
  _patchSend() {
    const n = this;
    function r(p, m, d, l) {
      const f = m.callbackToRemoveEvents;
      typeof f == "function" && f();
      const { span: h, spanUrl: g, sendStartTime: _ } = m;
      h && (n._findResourceAndAddNetworkEvents(m, h, g, _, d), h.addEvent(p, l), n._addFinalSpanAttributes(h, m, g), h.end(l), n._tasksCount--), n._clearResources();
    }
    function i(p, m, d, l) {
      const f = n._xhrMem.get(m);
      if (!f)
        return;
      if (f.status = m.status, f.statusText = m.statusText, n._xhrMem.delete(m), f.span) {
        const _ = f.span;
        n._applyAttributesAfterXHR(_, m), n._semconvStability & B.STABLE && (d ? l && (_.setStatus({
          code: ze.ERROR,
          message: l
        }), _.setAttribute(zr, l)) : f.status && f.status >= 400 && (_.setStatus({ code: ze.ERROR }), _.setAttribute(zr, String(f.status))));
      }
      const h = qe(), g = Date.now();
      setTimeout(() => {
        r(p, f, h, g);
      }, eg);
    }
    function s() {
      i(Ee.EVENT_ERROR, this, !0, "error");
    }
    function o() {
      i(Ee.EVENT_ABORT, this, !1);
    }
    function a() {
      i(Ee.EVENT_TIMEOUT, this, !0, "timeout");
    }
    function u() {
      this.status < 299 ? i(Ee.EVENT_LOAD, this, !1) : i(Ee.EVENT_ERROR, this, !1);
    }
    function c(p) {
      p.removeEventListener("abort", o), p.removeEventListener("error", s), p.removeEventListener("load", u), p.removeEventListener("timeout", a);
      const m = n._xhrMem.get(p);
      m && (m.callbackToRemoveEvents = void 0);
    }
    return (p) => function(...d) {
      const l = n._xhrMem.get(this);
      if (!l)
        return p.apply(this, d);
      const f = l.span, h = l.spanUrl;
      if (f && h) {
        if (n.getConfig().measureRequestSize && (d != null && d[0])) {
          const g = d[0], _ = qm(g);
          _ !== void 0 && (n._semconvStability & B.OLD && f.setAttribute(Bm, _), n._semconvStability & B.STABLE && f.setAttribute(jm, _));
        }
        j.with(G.setSpan(j.active(), f), () => {
          n._tasksCount++, l.sendStartTime = qe(), f.addEvent(Ee.METHOD_SEND), this.addEventListener("abort", o), this.addEventListener("error", s), this.addEventListener("load", u), this.addEventListener("timeout", a), l.callbackToRemoveEvents = () => {
            c(this), l.createdResources && l.createdResources.observer.disconnect();
          }, n._addHeaders(this, h), n._addResourceObserver(this, h);
        });
      }
      return p.apply(this, d);
    };
  }
  /**
   * implements enable function
   */
  enable() {
    this._diag.debug("applying patch to", this.moduleName, this.version), Jr(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), Jr(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
  }
  /**
   * implements disable function
   */
  disable() {
    this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
  }
}
class ng extends tg {
  constructor(t = {}) {
    super(t);
    const n = this;
    this.parentCreateSpan = n._createSpan.bind(this);
  }
  // Patching the parent's private method to handle url type string or URL
  _patchOpen() {
    return (t) => {
      const n = this;
      return function(...i) {
        let s;
        try {
          const a = i[0];
          let u = xo(i[1]);
          s = n.parentCreateSpan(this, u, a);
        } catch (a) {
          k.internalLogger.error(a);
        }
        const o = k.api.getActiveUserAction();
        return s && o && (o == null ? void 0 : o.getState()) === L.Started && (s.setAttribute("faro.action.user.name", o.name), s.setAttribute("faro.action.user.parentId", o.parentId)), t.apply(this, i);
      };
    };
  }
}
function rg(e, t, n) {
  const r = n instanceof Error ? 0 : n.status;
  lu(e, r);
}
function ig(e, t) {
  lu(e, t.status);
}
function lu(e, t) {
  if (t == null)
    return;
  const n = t === 0, r = t >= 400 && t < 600;
  (n || r) && e.setStatus({ code: ze.ERROR });
}
function sg(e) {
  return (t, n, r) => {
    rg(t, n, r), e == null || e(t, n, r);
  };
}
function og(e) {
  return (t, n) => {
    ig(t, n), e == null || e(t, n);
  };
}
var ag = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function ug(e = {}) {
  const { fetchInstrumentationOptions: t, xhrInstrumentationOptions: n } = e, r = ag(e, ["fetchInstrumentationOptions", "xhrInstrumentationOptions"]), i = cg(t, r), s = lg(n, r);
  return [new km(i), new ng(s)];
}
function cg(e, t) {
  return Object.assign(Object.assign(Object.assign(Object.assign({}, t), { ignoreNetworkEvents: !0 }), e), {
    // always keep this function
    applyCustomAttributesOnSpan: sg(e == null ? void 0 : e.applyCustomAttributesOnSpan),
    requestHook: (n, r) => {
      const i = k.api.getActiveUserAction();
      i && (i == null ? void 0 : i.getState()) === L.Started && (n.setAttribute("faro.action.user.name", i.name), n.setAttribute("faro.action.user.parentId", i.parentId));
    }
  });
}
function lg(e, t) {
  return Object.assign(Object.assign(Object.assign(Object.assign({}, t), { ignoreNetworkEvents: !0 }), e), {
    // always keep this function
    applyCustomAttributesOnSpan: og(e == null ? void 0 : e.applyCustomAttributesOnSpan)
  });
}
const dg = "session.id", fg = "deployment.environment.name", pg = "service.namespace", hg = "process.runtime.name", mg = "process.runtime.version", gg = "telemetry.distro.name", vg = "telemetry.distro.version", _g = "browser.brands", bg = "browser.language", Eg = "browser.mobile", Sg = "browser.platform";
class yg {
  constructor(t, n) {
    this.processor = t, this.metas = n;
  }
  forceFlush() {
    return this.processor.forceFlush();
  }
  onStart(t, n) {
    var r;
    const i = this.metas.value.session;
    i != null && i.id && (t.attributes[dg] = i.id);
    const s = (r = this.metas.value.user) !== null && r !== void 0 ? r : {};
    s.email && (t.attributes["user.email"] = s.email), s.id && (t.attributes["user.id"] = s.id), s.username && (t.attributes["user.name"] = s.username), s.fullName && (t.attributes["user.full_name"] = s.fullName), s.roles && (t.attributes["user.roles"] = s.roles.split(",").map((o) => o.trim())), s.hash && (t.attributes["user.hash"] = s.hash), this.processor.onStart(t, n);
  }
  onEnd(t) {
    this.processor.onEnd(t);
  }
  shutdown() {
    return this.processor.shutdown();
  }
}
function Tg(e = {}) {
  var t;
  return ((t = e.attributes) === null || t === void 0 ? void 0 : t.isSampled) === "true" ? Ue.RECORD_AND_SAMPLED : Ue.NOT_RECORD;
}
class tr extends ve {
  constructor(t = {}) {
    super(), this.options = t, this.name = "@grafana/faro-web-tracing", this.version = J;
  }
  initialize() {
    var t, n, r, i, s;
    const o = this.options, a = {};
    this.config.app.name && (a[Aa] = this.config.app.name), this.config.app.namespace && (a[pg] = this.config.app.namespace), this.config.app.version && (a[yp] = this.config.app.version), this.config.app.environment && (a[fg] = this.config.app.environment, a[Ep] = this.config.app.environment);
    const u = this.metas.value.browser;
    at(u == null ? void 0 : u.brands) && (a[_g] = u.brands.map((f) => f.brand)), u != null && u.language && (a[bg] = u.language), typeof (u == null ? void 0 : u.mobile) == "boolean" && (a[Eg] = !!u.mobile), u != null && u.os && (a[Sg] = u.os), u != null && u.userAgent && (a[wp] = u.userAgent), a[hg] = "browser", a[mg] = (t = this.metas.value.browser) === null || t === void 0 ? void 0 : t.userAgent, a[gg] = "faro-web-sdk", a[vg] = J, Object.assign(a, o.resourceAttributes);
    const c = ru().merge(nu(a));
    new am({
      resource: c,
      sampler: {
        shouldSample: () => ({
          decision: Tg(this.api.getSession())
        })
      },
      spanProcessors: [
        (n = o.spanProcessor) !== null && n !== void 0 ? n : new yg(new Qh(new Ch({ api: this.api }), {
          scheduledDelayMillis: tr.SCHEDULED_BATCH_DELAY_MS,
          maxExportBatchSize: 30
        }), this.metas)
      ]
    }).register({
      propagator: (r = o.propagator) !== null && r !== void 0 ? r : new Ii(),
      contextManager: o.contextManager
    });
    const { propagateTraceHeaderCorsUrls: m, fetchInstrumentationOptions: d, xhrInstrumentationOptions: l } = (i = this.options.instrumentationOptions) !== null && i !== void 0 ? i : {};
    Uh({
      instrumentations: (s = o.instrumentations) !== null && s !== void 0 ? s : ug({
        ignoreUrls: this.getIgnoreUrls(),
        propagateTraceHeaderCorsUrls: m,
        fetchInstrumentationOptions: d,
        xhrInstrumentationOptions: l
      })
    }), this.api.initOTEL(G, j);
  }
  getIgnoreUrls() {
    return this.transports.transports.flatMap((t) => t.getIgnoreUrls());
  }
}
tr.SCHEDULED_BATCH_DELAY_MS = 1e3;
const wg = "https://faro-api-prod-us-central-0.grafana.net/faro/api/v1", Dg = {
  dev: {
    appId: "2648",
    collectorKey: "31fe883638ce2949dae5fb9394a4af36",
    stackId: "460827",
    apiKey: process.env.FARO_API_KEY || ""
  },
  integ: {
    appId: "2648",
    collectorKey: "31fe883638ce2949dae5fb9394a4af36",
    stackId: "460827",
    apiKey: process.env.FARO_API_KEY || ""
  },
  staging: {
    appId: "2648",
    collectorKey: "31fe883638ce2949dae5fb9394a4af36",
    stackId: "460827",
    apiKey: process.env.FARO_API_KEY || ""
  },
  prod: {
    appId: "2654",
    collectorKey: "cea6cabaf330b91f743edac5a9591a5a",
    stackId: "406974",
    apiKey: process.env.FARO_API_KEY || ""
  }
}, Ug = {
  dev: {
    appId: "2649",
    collectorKey: "264fd5022f4b2f6f4041445211f703b1",
    stackId: "460827",
    apiKey: process.env.FARO_API_KEY || ""
  },
  integ: {
    appId: "2649",
    collectorKey: "264fd5022f4b2f6f4041445211f703b1",
    stackId: "460827",
    apiKey: process.env.FARO_API_KEY || ""
  },
  staging: {
    appId: "2649",
    collectorKey: "264fd5022f4b2f6f4041445211f703b1",
    stackId: "460827",
    apiKey: process.env.FARO_API_KEY || ""
  },
  prod: {
    appId: "2653",
    collectorKey: "9ad053e4209158dd63e46a89d2583082",
    stackId: "406974",
    apiKey: process.env.FARO_API_KEY || ""
  }
};
function jg(e, t) {
  return e[t] || e.integ;
}
const Ag = "https://faro-collector-prod-us-central-0.grafana.net/collect";
function Og(e) {
  return {
    url: `${Ag}/${e.collectorKey}`,
    app: {
      name: e.name,
      version: e.version,
      environment: e.environment || "production"
    },
    sessionTracking: e.sessionTracking ? { enabled: !0, persistent: !0 } : void 0
  };
}
function Rg(e) {
  return process.env.FARO_LOCAL || process.env.FARO_ENABLED ? !0 : !!e && e !== "local" && e !== "dev";
}
function Bg(e) {
  const { additionalInstrumentations: t = [] } = e;
  if (!Rg(e.environment))
    return null;
  const n = Og({
    name: e.name,
    version: e.version,
    collectorKey: e.collectorKey,
    appId: e.appId,
    environment: e.environment,
    sessionTracking: e.sessionTracking
  });
  return Od(Xi(At({}, n), {
    instrumentations: [...Zo(), new tr(), ...t]
  }));
}
function Pg(e) {
  return process.env.FARO_DISABLE_AUTO_UPLOAD !== "true" && !!(e || process.env.FARO_API_KEY);
}
function $g(e, t, n) {
  const r = t[n] || t.integ;
  return Pg(r.apiKey) ? {
    appName: e,
    appId: r.appId,
    endpoint: `${wg}/app/${r.appId}/sourcemaps`,
    apiKey: r.apiKey,
    stackId: r.stackId,
    gzipContents: !0
  } : null;
}
const Fg = "foobar";
export {
  wg as FARO_API_ENDPOINT,
  Ag as FARO_COLLECTOR_BASE,
  Og as createFaroConfig,
  Cg as filterTokensFromPerformance,
  Fg as foobar,
  jg as getFaroConfig,
  $g as getFaroPluginOptions,
  Ng as getUrlParam,
  Bg as initializeFaroForApp,
  Dg as senderFaroConfig,
  Rg as shouldEnableFaro,
  Pg as shouldIncludeFaroPlugin,
  Ug as signerFaroConfig,
  xg as tokenInUrl,
  Mg as validateInput
};
//# sourceMappingURL=index.es.js.map
